/* eslint-disable react/prop-types */
import React, {
  useState,
  useEffect,
  useMemo,
  useRef,
} from 'react';
import {
  Row,
  Col,
  Button,
  Typography,
  Tooltip,
  Spin,
  Form,
  Space,
  Pagination,
  Result,
  Input,
  message,
  Steps,
  Modal,
  Grid,
  Card,
  Radio,
  DatePicker,
} from 'antd';
import GlobalStyles from 'themes/global';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory } from 'react-router';
import {
  QuestionCircleOutlined,
  HomeOutlined,
  InboxOutlined,
  SearchOutlined,
  DeleteOutlined,
  StopOutlined,
  ArrowLeftOutlined,
  LeftOutlined,
  SaveOutlined,
  RightOutlined,
  CheckOutlined,
  FilterOutlined,
  UserOutlined,
  SyncOutlined,
  EyeOutlined,
  CommentOutlined,
  CheckCircleOutlined,
  DoubleRightOutlined,
  FieldTimeOutlined,
  CloudDownloadOutlined,
  CalendarOutlined,
  TrademarkOutlined,
  EnvironmentOutlined,
  CarOutlined,
  KeyOutlined,
  DollarOutlined,
  FileProtectOutlined,
  ShopOutlined,
  AuditOutlined,
  ArrowRightOutlined,
  ExclamationCircleOutlined,
  UnlockOutlined,
  LockOutlined,
  ApartmentOutlined,
  WarningOutlined,
} from '@ant-design/icons';
import styled, { ThemeProvider } from 'styled-components';
import Select from 'components/Select';
import { getPlantillasTramites, getPlantillaTramite } from 'api/tramites/plantillasDeTramites';
import checkToken from 'api/utils/checkToken';
import { getDepartamentos } from 'api/configuracion/departamentos';
import { getDependencias } from 'api/configuracion/dependencias';
import usePaginatedFetcher from 'hooks/usePaginatedFetcher';
import { InputSearchPro } from 'components/InputSearch';
import padronToString, { getPadronKey } from 'utils/padronesToString';
import {
  getDistinctValues,
  listToString,
  toMoment,
  toUpper,
} from 'utils/normalizers';
import {
  deletableKeysPadronesMap,
  getPadronesMap,
  patchPadronesMap,
  postPadronesMap,
  retrievePadronesMap,
  urlsPadronesMap,
} from 'api/recaudacion/utils';
import { getContenTypePorTipoDePadron, getTipoDePadronPorContenType } from 'api/catalogos';
import { getTramites, patchTramite, postTramite } from 'api/tramites/tramites';
import { getComplementosDeTramites, patchComplementoDeTramite, postComplementoDeTramite } from 'api/tramites/complementosDeTramites';
import { getCargosPaginados, patchCargo } from 'api/recaudacion/cargos';
import { getPeriodosFiscales } from 'api/catalogos/periodosFiscales';
import { getMotivosDeCancelacionDeCargo } from 'api/catalogos/motivosDeCancelacionDeCargo';
import { getVariables } from 'api/configuracion/variables';
import { getPlacas, postGenerarCargos, postRecalcularRecargos } from 'api/recaudacion';
import { postImprimirOrdenDePago } from 'api/cuentaunicasir/index';
import formatValues, {
  DATETIME_FORMAT,
  DATETIME_FRONTEND_FORMAT,
  DATE_FORMAT,
  DATE_FRONTEND_FORMAT,
  DATE_NETPAY_FORMAT,
  formatReceived,
} from 'utils/formatValues';
import Previewer, { isPDFBase64 } from 'components/Previewer';
import ModalCancelarTramite from 'components/ModalCancelarTramite';
import BusquedaAvanzadaPadrones from 'views/Recaudacion/Caja/BusquedaAvanzadaPadrones';
import RequisitosDelTramite, {
  isInReview,
  permissionRequisitos,
} from 'views/Tramites/GPM/components/RequisitosDelTramite';
import Variables, {
  complementosToValues,
  permissionVariablesGPM,
  valuesToVariables,
  valuesToVariablesComplementos,
} from 'views/Tramites/GPM/components/Variables';
import {
  solicitantesEnum,
  stepsEnum,
  afectacionesEnum,
  aplicacionesCargosEnum,
  tiposDatosEnum,
  statusRequisitosEnum,
  tiposDePasosEnum,
  saveLabelEnum,
  padronesEnum,
  padronesModelsEnum,
  direccionPrincipalEnum,
  direccionSecundariaEnum,
  tipoDeDocumentoExpedienteEnum,
  estatusEnvioWs,
  procedenciasEnum,
  tiposDeContribuyentesSolicitantesEnum,
} from 'views/Tramites/GPM/enums';
import ArcGisMap, { validateGIS } from 'views/Tramites/GPM/components/ArcGisMap';
import FormSubmitControls from 'components/FormSubmitControls';
import { getRecibo as _getRecibo, getReciboPDFDeTramite } from 'api/recaudacion/recibos';
import Documento from 'views/Tramites/GPM/components/Documento';
import Instrucciones from 'views/Tramites/GPM/components/Instrucciones';
import ModalLog, { generateValues, tiposPasosNoPuedeRetender } from 'views/Tramites/GPM/components/ModalLog';
import { getValoresPorVariablesDeSeleccion } from 'api/configuracion/valoresPorVariablesDeSeleccion';
import {
  ActionsNames,
  getModelPermission,
  hasActionPermission,
  isAdmin,
  isStaff,
} from 'utils/permission';
import { SET_GPM_TIMELINE_OPEN } from 'store/reducers/app';
import getParamsPadron from 'views/Tramites/GPM/paramsPadronesAfectados';
import { postObtenerDocumento } from 'api/reporteador';
import round from 'utils/round';
import FirmaElectronica from 'views/Tramites/components/FirmaElectronica';
import { logger } from 'utils/debug';
import useQuery from 'hooks/useQuery';
import { getHistorialDeTramite, postHistorialDeTramite } from 'api/tramites/historial';
import { getComentariosDeTramites } from 'api/tramites/comentariosDeTramites';
import {
  consultaTramiteFinanzas,
  getZipExpediente,
  patchFirmarTramite,
  postTramitesHijas,
} from 'api/tramites';
import { ESTADOS_GLOBALES_MAP } from 'utils/estadosGlobales';
import CambioPropietario from 'views/Tramites/GPM/components/CambioPropietario';
import Cargos, { getMandatoryKeys, permissionConfig as permissionCargos } from 'views/Tramites/GPM/components/Cargos';
import Table from 'components/Table';
import NoPermission from 'views/Tramites/GPM/components/NoPermission';
import fullNameUser from 'utils/fullNameUser';
import { getAdeudoPadronAsync } from 'hooks/useAdeudoPadron';
import { SET_PIN_PADRON_INFO, normalizeCargos } from 'store/reducers/caja';
import { getCategoriasDeVariables } from 'api/configuracion';
import Direccion, { fieldsDetalle, permissionConfig as permissionDireccion } from 'components/Direccion';
import ObligacionesFiscalesContribuyente, {
  model as modelObligacionesFiscales,
  catalogsModels as catalogsModelsObligacionesFiscales,
} from 'components/Catalogos/ObligacionesFiscalesContribuyente';
import EmpresasDeContribuyentes, {
  model as modelEmpresas,
  catalogsModels as catalogsModelsEmpresas,
} from 'components/Catalogos/EmpresasDeContribuyentes';
import Participe, { permissionParticipe } from 'components/Participes';
import Camera, { dataUrlToFile } from 'views/Tramites/GPM/components/Camera';
import { expedienteToAttrs, getExpedientesDeTramites, postExpedienteDeTramite } from 'api/tramites/expediente';
import ActividadesEconomicas, {
  permissionActividadesEconomicasContribuyentes,
  permissionActividadesContribuyentes,
} from 'components/Catalogos/ActividadesEconomicas';
import ContribuyentesVinculados, { permissionContribuyentesVinculados } from 'components/Catalogos/ContribuyentesVinculados';
import ModalInfoPadron from 'views/Recaudacion/Caja/ModalInfoPadron';
import { getArchivosDeComentariosDeTramitesPorIdsComentario } from 'api/tramites/archivosDeComentarios';
import { getCitas, patchCita, postCita } from 'api/tramites/citas';
import { getPermissionActionsConfigsPadrones, hasPadronPermission, permissionSectionsPadrones } from 'utils/permission/models';
import { patchVehiculo } from 'api/recaudacion/vehiculos';
import { postEnviarInformacionWS } from 'api/recaudacion/repuve';
import useWebSocket from 'react-use-websocket';
import { patchPlaca, postPlaca } from 'api/recaudacion/placas';
import { baseURI as URIContribuyente } from 'api/empresas/contribuyente';
import { baseURI as URICiudadano } from 'api/cuentaunicasir';
import ModalDireccion from 'components/Direccion/Modal';
import { getConfiguracionesDePadrones } from 'api/configuracion/configuracionPadrones';
import address from 'utils/address';
import { patchColindancia, postColindancia } from 'api/catastro/colindancias';
import getAllPages, { getLargeListByID } from 'utils/getAllPages';
import { aplicarAfectacionesPredio, dateKeysPredio, patchPredio } from 'api/catastro/predio';
import { buildFileName, checkIfCanDownload } from 'utils/getFileName';
import useActualizadorDeCartera, { permissionConfigActionsActualizadorCartera } from 'hooks/useActualizadorDeCartera';
import AvaluoConstrucciones, { permissionConfig as permissionConfigConstrucciones } from 'components/Catalogos/AvaluoConstrucciones';
import AvaluoTerreno, { permissionConfig as permissionConfigTerreno } from 'components/Catalogos/AvaluoTerreno';
import Colindancias, { permissionConfig as permissionConfigColindancias } from 'components/Catalogos/ColindanciasDePredios';
import AreasComunesDePredios, { permissionConfig as permissionAreasComunes } from 'components/Catalogos/AreasComunesDePredios';
import ValoresReferidosDePredios, { permissionConfig as permissionValoresReferidos } from 'components/Catalogos/ValoresReferidosDePredios';
import {
  postConsultaCertificadoNoAdeudoAgua,
  postImportacionMasivaPredios,
  getEstadoImportacionMasivaPredios,
} from 'api/catastro';
import { getContribuyentes } from 'api/empresas/contribuyentes';
import { getCatalogoPeritosDePredio } from 'api/catastro/peritosDePredios';
import { getCatalogoNotariosDePredios } from 'api/catastro/notariosDePredios';
import CargaDocumento from './components/CargaDocumento';
import Cita, { permissionCitas } from './components/Cita';
import ConsultaCita, { estadosCitasMap } from './components/ConsultaCita';
import AsignacionConstancia from './components/AsignacionConstancia';
import ModalInfoRepuve from './components/ModalInfoRepuve';
import PlacaGPM from './components/PlacaGPM';
import removeIndexes from './removeIndexes';
import Subdivision from './components/Subdivision';
import Fusion from './components/Fusion';
import Alertas, { permissionConfig as permissionAlertas } from './components/Alertas';

const RenderFieldsByConfig = React.lazy(() => import('./components/RenderFieldsByConfig'));
const { Title, Text } = Typography;
const PORTAL_CIUDADANO = process.env.REACT_APP_APIHOST_PORTAL_CIUDADANO;
const DEV = process.env.NODE_ENV === 'development';
const ENV_NAME = process.env.REACT_APP_ENV_NAME;
const REPUVE = ENV_NAME === 'repuve';
const OAXACA = ENV_NAME === 'oaxaca';
const TLAJOMULCO = ENV_NAME === 'tlajomulco';
const IPROVINAY = ENV_NAME === 'iprovinay';
// const TIPOS_DE_CARGOS_TRASLACION = [
//   4565, 4516, 4517, 4518, 4519, 4520, 3649, 3650, 3651, 3652, 3653, 3654, 3655, 2083,
//   2084, 2081, 2082, 2079, 2080, 2046, 2049, 2078, 2042, 2044, 2063, 1996, 1997,
// ];

const mapFirmas = (firma) => {
  const {
    nombre,
    puesto,
    rfc,
    serie,
    fecha,
    sello,
  } = firma;
  const asString = `FIRMANTE ${nombre} RFC ${rfc} CARGO ${puesto} NUM. CERTIFICADO ${serie}`
    + ` FECHA Y HORA ${fecha} |n SELLO ${sello}`;
  return { ...firma, asString };
};

const permissionObligaciones = {
  model: modelObligacionesFiscales,
  catalogs: catalogsModelsObligacionesFiscales,
};

const permissionEmpresas = {
  model: modelEmpresas,
  catalogs: catalogsModelsEmpresas,
};

const tabsModels = [
  permissionRequisitos,
  permissionVariablesGPM,
  permissionObligaciones,
  permissionEmpresas,
  permissionParticipe,
  permissionActividadesEconomicasContribuyentes,
  permissionActividadesContribuyentes,
  permissionContribuyentesVinculados,
  permissionCitas,
  permissionDireccion,
  permissionConfigConstrucciones,
  permissionConfigTerreno,
  permissionConfigColindancias,
  permissionCargos,
  permissionValoresReferidos,
  permissionAreasComunes,
  permissionAlertas,
];

const titlesByModel = {
  requisitodeltramite: 'Requisitos',
  complementodetramite: 'Variables de trámites',
  obligacionfiscaldecontribuyente: 'Obligaciones fiscales contribuyentes',
  empresa: 'Empresas',
  participe: 'Participes',
  actividadeconomicadecontribuyente: 'Actividades Económicas De Contribuyente',
  actividaddecontribuyente: 'Actividades De Contribuyente',
  contribuyentevinculado: 'Contribuyentes Vinculados',
  cita: 'Citas',
  direccion: 'Dirección',
};

export const permissionConfig = {
  mainPermission: 'viewcrud_tramite',
  required: [
    'view_tramite',
    'add_tramite',
    'change_tramite',
    'view_plantilladetramite',
    'view_ciudadano',
    'view_contribuyente',
    'view_cargo',
    'view_recibo',
    'view_periodofiscal',
    'view_unidadoperativa',
    'view_unidadresponsable',
    'view_historialdetramite',
    'add_historialdetramite',
    'view_comentariodeltramite',
    'add_comentariodeltramite',
    'view_archivodecomentariodeltramite',
    'add_archivodecomentariodeltramite',
    'view_expedientedetramite',
    'add_expedientedetramite',
  ],
  customSections: [
    ...tabsModels.map((tab) => (tab.permissions ? tab : ({
      title: titlesByModel[tab.model] || tab.title,
      name: tab.model,
      permissions: [
        `view_${tab.model}`,
        `add_${tab.model}`,
        `change_${tab.model}`,
        `delete_${tab.model}`,
        ...(tab.catalogs || []).map((c) => `view_${c}`),
      ],
    }))),
    ...permissionSectionsPadrones.filter((e) => e.gpm),
  ],
  customActions: [
    ...getPermissionActionsConfigsPadrones(ActionsNames.add),
    ...getPermissionActionsConfigsPadrones(ActionsNames.change),
    ...permissionConfigActionsActualizadorCartera.filter((e) => e.padron === 3),
    REPUVE && {
      name: 'enviar_ws',
      title: 'Enviar a WS',
      permissions: ['enviar_vehiculo_ws'],
    },
    {
      name: 'cancelar_cargo',
      title: 'Cancelar cargos',
      permissions: ['cancelar_cargo'],
    },
    {
      name: 'recalcular_cargo',
      title: 'Recalcular cargos',
      permissions: ['recalcular_cargo'],
    },
    {
      name: 'actualizar_cartera_tramites',
      title: 'Recalcular cargos',
      permissions: ['actualizar_cartera_tramites', 'view_configuraciondeactualizadordecarteras'],
    },
    {
      name: 'autorizar_tramite',
      title: 'Finalizar trámite',
      permissions: ['autorizar_tramite'],
    },
    {
      name: 'editar_area_titulo_predio_gpm',
      title: 'Editar área título predio',
      permissions: ['editar_area_titulo_predio_gpm'],
    },
  ].filter((e) => e),
};

const pasosCruds = [
  tiposDePasosEnum.OBLIGACIONES,
  tiposDePasosEnum.EMPRESAS,
  tiposDePasosEnum.PARTICIPES,
  tiposDePasosEnum.CONSTRUCCIONES,
  tiposDePasosEnum.AVALUO_TERRENO,
  tiposDePasosEnum.COLINDANCIAS,
  tiposDePasosEnum.AREAS_COMUNES_DE_PREDIOS,
  tiposDePasosEnum.VALORES_REFERIDOS_DE_PREDIOS,
  tiposDePasosEnum.ALERTAS,
];

const tiposPasosNoCancelable = [
  tiposDePasosEnum.MODIFICACION_AFECTADO,
  tiposDePasosEnum.MODIFICACION_SOLICITANTE,
  tiposDePasosEnum.CAMBIO_DE_PROPIETARIO,
  tiposDePasosEnum.DIRECCION_PRINCIPAL,
  tiposDePasosEnum.DIRECCION_SECUNDARIA,
  tiposDePasosEnum.ACTIVIDADES_ECONOMICAS,
  tiposDePasosEnum.ACTIVIDADES_ECONOMICAS_SAT,
  tiposDePasosEnum.CONSTRUCCIONES,
  tiposDePasosEnum.CONTRIBUYENTES_VINCULADOS,
  tiposDePasosEnum.EMPRESAS,
  tiposDePasosEnum.OBLIGACIONES,
  tiposDePasosEnum.PARTICIPES,
  tiposDePasosEnum.SINCRONIZACION_DE_DATOS_FINANZAS,
  tiposDePasosEnum.ASIGNACION_CONSTANCIA,
  tiposDePasosEnum.AFECTAR_PADRON_JSON,
  tiposDePasosEnum.AVALUO_TERRENO,
  tiposDePasosEnum.COLINDANCIAS,
  tiposDePasosEnum.AREAS_COMUNES_DE_PREDIOS,
  tiposDePasosEnum.VALORES_REFERIDOS_DE_PREDIOS,
];

const tiposPasosModificaciones = [
  ...tiposPasosNoCancelable,
  tiposDePasosEnum.SUBDIVISION,
  tiposDePasosEnum.FUSION,
];

const initialValueStatusRequisitos = { generales: null, caso: null };

// para incluir formato antiguo como tabs y crud tramite y omitir la modificacion completa por ahora
const formatPermission = (_permission) => ({
  ...getModelPermission('tramite', [], tabsModels),
  ..._permission,
});

const SOCKETS_URL = process.env.REACT_APP_REPUVE_SOCKETS_URL;
const connect = REPUVE && !/localhost/.test(window.location.hostname);

const ModalCambioPropietario = ({
  open,
  onOk,
  onCancel,
  loading,
  padronAfectado,
  padronSolicitante,
  initialValuePlaca,
  fechaExpRpv,
}) => {
  const [placaModal, setPlacaModal] = useState(initialValuePlaca);

  return (
    <Modal
      open={open}
      onCancel={() => onCancel(true)}
      okText="Confirmar cambios"
      title="Confirmación de propietario"
      width="70%"
      okButtonProps={{ className: 'no-color', icon: <CheckCircleOutlined />, disabled: loading }}
      cancelButtonProps={{ className: 'no-color', disabled: loading }}
      onOk={() => onOk(placaModal)}
      destroyOnClose
      closable={false}
    >
      <Spin spinning={loading}>
        El solicitante seleccionado no es el propietario del vehículo.
        <br />
        Para continuar con el trámite es necesario realizar algunos ajustes al vehículo.
        <br />
        Esta acción no puede revertirse,
        {' '}
        <b>asegurese de que el contribuyente seleccionado es el propietario.</b>
        <br />
        <br />
        <b>Se realizaran los siguientes cambios a vehículo:</b>
        <br />
        propietario cambiará de
        {' '}
        <b>{padronToString(padronAfectado?.contribuyente_propietario, 15, false, false)}</b>
        {' '}
        a:
        {' '}
        <b>{padronToString(padronSolicitante, 15, false, false)}</b>
        ,
        <br />
        y número de placa vigente cambiará de
        {' '}
        <b>{padronAfectado?.numero_de_placa_vigente}</b>
        {' '}
        a
        {' '}
        <Input
          value={placaModal}
          onChange={(e) => setPlacaModal(toUpper(e.target.value))}
          style={{ width: 200, display: 'inline-block' }}
          placeholder="Ingrese placa"
        />
        {!!placaModal && placaModal === initialValuePlaca && ` - fechaExpRpv: ${fechaExpRpv}`}
      </Spin>
    </Modal>
  );
};

const tiposDePasosLog = [
  tiposDePasosEnum.VALIDACION_REQUISITOS,
  tiposDePasosEnum.OBLIGACIONES,
  tiposDePasosEnum.EMPRESAS,
  tiposDePasosEnum.PARTICIPES,
  tiposDePasosEnum.CONSTRUCCIONES,
  tiposDePasosEnum.AREAS_COMUNES_DE_PREDIOS,
  tiposDePasosEnum.VALORES_REFERIDOS_DE_PREDIOS,
  tiposDePasosEnum.ACTIVIDADES_ECONOMICAS,
  tiposDePasosEnum.ACTIVIDADES_ECONOMICAS_SAT,
  tiposDePasosEnum.CONTRIBUYENTES_VINCULADOS,
  tiposDePasosEnum.AVALUO_TERRENO,
  tiposDePasosEnum.COLINDANCIAS,
  tiposDePasosEnum.ALERTAS,
];

const GPM = ({ permission: _permission }) => {
  const { sendMessage, lastMessage, readyState } = useWebSocket(SOCKETS_URL, {}, connect);
  const permission = formatPermission(_permission);
  const addressPermission = permission.tabs[permissionDireccion.model];
  const screens = Grid.useBreakpoint();
  const dispatch = useDispatch();
  const { user, roles, entidad } = useSelector(({ auth }) => auth);
  const history = useHistory();
  const { theme, GPMTimelineOpen: timelineOpen } = useSelector(({ app }) => app);
  const padrones = useSelector(({ catalogs }) => catalogs.padrones).filter((p) => p.id !== 5)
    .filter((p) => hasPadronPermission(p.id));
  const [form] = Form.useForm();
  const [formSearch] = Form.useForm();
  const [formFilter] = Form.useForm();
  const tipoDeFiltro = Form.useWatch('tipoDeFiltro', formFilter);
  const filtro = Form.useWatch('filtro', formFilter);
  const base64GIS = Form.useWatch('base64', form);
  const [hasGISInfo, setHasGISInfo] = useState(false);
  const [_loading, setLoading] = useState(true);
  const showControls = useMemo(() => isAdmin() || isStaff(), []);
  const [tramiteParam, citaParam, plantillaParam, finalizadosParam] = useQuery(['tramite', 'cita', 'plantilla', 'finalizados']);
  const refPatch = useRef(false);
  const prevStepRef = useRef();
  const [_lastMessage, setLastMessage] = useState();
  const isSubmittingRef = useRef(false);

  useEffect(() => {
    setLastMessage(lastMessage);
  }, [lastMessage]);

  const params = useMemo(() => {
    const _params = {};
    if (!showControls) {
      _params.estado_de_ficha = 3; // publicados
      if (user.centro_de_costos) {
        _params.centro_de_costos = user.centro_de_costos.id;
      } else if (user.unidad_responsable) {
        _params.departamentos = user.unidad_responsable.id;
      } else if (user.unidad_operativa) {
        _params.dependencia = user.unidad_operativa.id;
      } else {
        // prevenimos que haga fetch de algo si no tiene departamento o dependencia
        // y usamos como flag para otras validaciones
        _params.id = -1;
      }
    }
    return _params;
  }, []);

  const fetchPlantillasConf = {
    auto: true,
    onlyOnePage: true,
    params,
  };

  const [plantillasDeTramites, fetchPlantillasDeTramites, loadingFetch = false] = tramiteParam
    || citaParam ? [] : usePaginatedFetcher(getPlantillasTramites, fetchPlantillasConf);
  const [plantillaDeTramite, setPlantillaDeTramite] = useState();
  const padronesSolicitantes = (plantillaDeTramite?.padrones_solicitante || [1, 15])
    .map((e) => padrones.find((p) => p.id === e)).filter((e) => e);
  const [unidadesResponsables, setUnidadesResponsables] = useState();
  const [unidadesOperativas, setUnidadesOperativas] = useState();
  const [visibleCancelar, setVisibleCancelar] = useState(false);
  const [currentStep, setCurrentStep] = useState(null);
  const [casoDeRequisitos, setCasoDeRequisitos] = useState(null);
  const [tramite, setTramite] = useState();
  const [statusRequisitos, setStatusRequisitos] = useState(initialValueStatusRequisitos);
  const [periodosFiscales, setPeriodosFiscales] = useState([]);
  const [periodosSeleccionados, setPeriodosSeleccionados] = useState([]);
  const [catalogoDeVariables, setCatalogoDeVariables] = useState([]);
  const [selectedKeysTiposCargos, setSelectedKeysTiposCargos] = useState([]);
  const [valoresDeVariablesDeSelecion, setValoresDeVariables] = useState([]);
  const base64Ref = useRef({});
  const searchInputRef = useRef();
  const actualControlRef = useRef();
  const [visiblePreview, setVisiblePreview] = useState();
  const [visibleModalLog, setVisibleModalLog] = useState();
  const [cargosTramite, setCargosTramite] = useState([]);
  const [loadingAdeudo, setLoadingAdeudo] = useState();
  const [loadingMessage, setLoadingMessage] = useState();
  const [hasObligaciones, setHasObligaciones] = useState(false);
  const [hasEmpresas, setHasEmpresas] = useState(false);
  const [hasParticipes, setHasParticipes] = useState(false);
  const [hasZonasHomogeneas, setHasZonasHomogeneas] = useState(false);
  const [hasColindancias, setHasColindancias] = useState(false);
  const [hasActividades, setHasActividades] = useState(false);
  const cargosTramiteTextRef = useRef();
  const [realizarEnvioWS, setRealizarEnvio] = useState(REPUVE && permission.enviar_ws);
  const [tramites, setTramites] = useState([]);
  const [prediosRelacionados, setPrediosRelacionados] = useState([]);

  // Padrones involucrados
  const [padronSolicitante, setPadronSolicitante] = useState();
  const [padronAfectado, setPadronAfectado] = useState();
  const [tipoPadronSolicitante, setTipoPadronSolicitante] = useState();
  const [visibleBusquedaPadronSolicitante, setVisibleBusquedaPadronSolicitante] = useState(false);
  const [visibleBusquedaPadronAfectado, setVisibleBusquedaPadronAfectado] = useState(false);
  const [showMessagesRequisitos, setShowMessagesRequisitos] = useState(false);
  const [historial, setHistorial] = useState([]);
  const [complementos, setComplementos] = useState([]);
  const [categoriasDeVariables, setCategoriasDeVariables] = useState([]);
  const [autoridadesExternas, setAutoridadesExternas] = useState([]);
  const [peritosDePredios, setPeritosDePredios] = useState([]);
  const [notariosDePredios, setNotariosDePredios] = useState([]);
  const [visibleSeguimiento, setVisibleSeguimiento] = useState(false);
  const [cargosSaldados, setCargosSaldados] = useState(false);
  const [expediente, setExpediente] = useState([]);
  const [foliosRecibos, setFoliosRecibos] = useState([]);
  const [citas, setCitas] = useState([]);
  const [valuesRepuve, setValuesRepuve] = useState();
  const [configContribuyente, setConfigContribuyente] = useState();
  const [openCambioPropietario, setOpenCambioPropietario] = useState(false);
  const [visibleModalInfoRepuve, setVisibleModalInfoRepuve] = useState(false);
  const [visibleConfirmFinish, setVisibleConfirmFinish] = useState(false);
  const valuesRepuveForm = Form.useWatch('valuesRepuve', form);

  const loading = _loading || loadingFetch;
  const isFiltered = !!filtro && plantillasDeTramites.params?.[tipoDeFiltro] === filtro;
  const isTransmision = TLAJOMULCO && /transmisi(o|ó)n/i.test(plantillaDeTramite?.nombre);
  const aplicaCambioDeAfectado = TLAJOMULCO && plantillaDeTramite?.id === 14;

  const sortAlertas = (a, b) => b.es_restrictiva
    .toString().localeCompare(a.es_restrictiva.toString());

  const alertasSolicitante = (padronSolicitante?.alerta || []).sort(sortAlertas);
  const restrictivasSolicitante = alertasSolicitante.filter((a) => a.es_restrictiva);
  const alertasAfectado = (padronAfectado?.alerta || []).sort(sortAlertas);
  const restrictivasAfectado = alertasAfectado.filter((a) => a.es_restrictiva);
  const pasosDelTramite = (plantillaDeTramite?.pasos_para_tramites || []).filter((paso) => {
    if (paso.tipo_de_paso === tiposDePasosEnum.MODIFICACION_SOLICITANTE) {
      return paso.configuracion_de_padron.padron?.id === tipoPadronSolicitante;
    }
    if (paso.tipo_de_paso === tiposDePasosEnum.VALIDACION_REQUISITOS) {
      return [3, 4].includes(tramite?.canal_de_pago);
    }
    return true;
  });
  const hasPasoAlertas = pasosDelTramite.some((p) => p.tipo_de_paso === tiposDePasosEnum.ALERTAS);
  const hasAlertasRestrictivas = !hasPasoAlertas
    && !!(restrictivasSolicitante.length || restrictivasAfectado.length);
  const valuesComplementos = complementosToValues(complementos, catalogoDeVariables);

  const pasoActual = useMemo(() => {
    const _pasoActual = pasosDelTramite.find((p) => p.id === currentStep);
    if (!_pasoActual) return null;
    if (_pasoActual.tipo_de_paso === tiposDePasosEnum.VARIABLES) {
      const variablesRequeridas = catalogoDeVariables
        .filter((v) => _pasoActual.variables.includes(v.id) && v.es_requerido);
      _pasoActual.hasAllVariables = variablesRequeridas
        .every((v) => complementos.some((c) => c.variable === v.id));
    }
    _pasoActual.tiene_tablas = _pasoActual.variables.some((v) => catalogoDeVariables
      .find((c) => c.id === v)?.tipo_de_variable === tiposDatosEnum.TABLA);
    return _pasoActual;
  }, [currentStep, complementos, catalogoDeVariables]);

  const variableTotalizado = useMemo(() => catalogoDeVariables
    .find((v) => v.nombre_de_variable === 'totalizado_de_cobros'), [catalogoDeVariables]);
  const tipoCargoTotalizado = useMemo(() => variableTotalizado && pasoActual?.tipos_de_cargos
    .find((tc) => tc.variables?.includes(variableTotalizado.id)), [pasoActual]);

  const includeJsonInfo = (original) => {
    const copy = {
      ...original,
      ...(formatReceived(original?.json_predio || {})),
    };
    delete copy.json_predio;
    delete copy.json_predio_raw;
    return copy;
  };

  // const baseParaCobroDeTrasladoPorDemasia = useMemo(() => {
  //   if (!tramite || !isSubdivisionDisolucionOaxaca) return null;
  //   const bases_gravables_json = (/hij(o|a)/i.test(tramite.descripcion)
  //     ? tramite.tramiteMadre : tramite)?.bases_gravables_json;
  //   if (!bases_gravables_json) return null;
  //   const json = JSON.parse(bases_gravables_json);
  //   const idx = json.TRAMITES?.findIndex((e) => e === tramite.id);
  //   const base_gravable = parseFloat(json.BASES_GRAVABLES[idx]);
  //   const media = parseFloat(json.MEDIA);
  //   // si la base gravable del predio es menor a la media no se paga traslado
  //   if (base_gravable < media) return null;
  //   return base_gravable - media;
  // }, [tramite]);

  const valuesVariablesCargos = Object.fromEntries(pasoActual?.tipos_de_cargos.map((tc) => {
    const _entries = tc.variables.map((v) => {
      const { nombre_de_variable } = catalogoDeVariables.find((_v) => _v.id === v);
      return [
        nombre_de_variable,
        valuesComplementos[nombre_de_variable]
        // || (nombre_de_variable === 'base_gravable' && baseParaCobroDeTrasladoPorDemasia)
        || includeJsonInfo(padronAfectado)[nombre_de_variable],
      ];
    });
    if (isTransmision && tc.es_editable_fecha_de_vencimiento) {
      _entries.push([
        'fecha_de_vencimiento',
        includeJsonInfo(padronAfectado)?.fecha_traslado,
      ]);
    }
    if (tc.id === tipoCargoTotalizado?.id) {
      _entries.push([
        variableTotalizado.nombre_de_variable,
        'Por calcular',
      ]);
    }
    return [tc.id.toString(), Object.fromEntries(_entries)];
  }) || []);

  const firmasElectronicas = useMemo(
    () => JSON.parse(tramite?.firma_electronica || '[]').filter((f) => !f.eliminado).map(mapFirmas),
    [tramite],
  );
  const requisitosStatusContinue = [statusRequisitosEnum.CONTINUE, statusRequisitosEnum.AUTORIZED];
  const requisitosStatusAuthorize = [statusRequisitosEnum.CONTINUE, statusRequisitosEnum.COMPLETE];
  const lastLog = historial.at(-1);

  const existingValidLogForStep = (step) => {
    if (!lastLog) return false;
    const lastHistoryForStep = historial.findLast((l) => l.paso === step);
    if (!lastHistoryForStep) return false;

    const stepToInLastLog = pasosDelTramite.find((p) => p.id === lastLog.paso_a_mandar);
    const currStep = pasosDelTramite.find((p) => p.id === step);

    if (!currStep) return false;
    const stepIsLastStep = step === pasosDelTramite.at(-1).id;

    return stepToInLastLog?.orden > currStep.orden
      || (stepIsLastStep && stepToInLastLog?.orden === currStep.orden);
  };

  const lastLogForStep = historial.findLast((e) => e.paso === currentStep);
  const historialesPasoActual = historial
    .filter((h) => h.paso === pasoActual?.id || h.paso_a_mandar === pasoActual?.id);
  const hasComentarioDeCapturaFinalizada = existingValidLogForStep(pasoActual?.id)
    && /finalizada captura/i.test(lastLogForStep?.comentario?.comentario);
  const citaPaso = citas.find((c) => c.paso === pasoActual?.id
    && ![estadosCitasMap.CANCELADA, estadosCitasMap.NO_ASISTIO].includes(c.estado_de_cita));
  const citaEnProcesoOFinalizada = [estadosCitasMap.EN_PROCESO, estadosCitasMap.FINALIZADA]
    .includes(citaPaso?.estado_de_cita);

  const pasoActualHasFirma = firmasElectronicas.some((f) => f.paso === pasoActual?.id)
    && existingValidLogForStep(pasoActual?.id);

  const hasPlaca = padronAfectado?.historial_de_placas
    ?.some((p) => p.numero_de_placa === padronAfectado.numero_de_placa_vigente);

  useEffect(() => {
    if (loading) {
      actualControlRef.current = document.activeElement;
      actualControlRef.current?.blur();
    } else {
      actualControlRef.current?.focus();
    }
  }, [loading]);

  const tramiteHasAllVariables = plantillaDeTramite
    ?.variables.every((v) => complementos.some((vt) => vt.variable === v));

  const getProps = (_tramite, _plantillaDeTramite) => {
    if (!_plantillaDeTramite) {
      return [];
    }
    const {
      configuracion_de_padron,
      tipo_de_padron,
      es_consulta_de_adeudo: _es_consulta_de_adeudo,
      tipos_de_cargos_consulta,
      pasos_para_tramites,
      no_iniciar_con_adeudo,
      es_consulta_de_recibos,
      permite_generar_sin_adeudo: _permiteGenerarSinAdeudo,
    } = _plantillaDeTramite;
    const _tramiteEnProceso = _tramite && ![4, 5].includes(_tramite?.estados_globales);
    const _tipoDeAfectacion = configuracion_de_padron?.tipo_de_afectacion.id;
    const _labelTipoDePadronAfectado = padrones.find((e) => e.id === tipo_de_padron)?.descripcion;
    const _esConsultaDeAdeudo = _es_consulta_de_adeudo && !!tipos_de_cargos_consulta.length;
    const _esConsultaDeRecibos = es_consulta_de_recibos && !!tipos_de_cargos_consulta.length;
    const _altaEnPaso = pasos_para_tramites
      .some((p) => p.tipo_de_paso === tiposDePasosEnum.ALTA_AFECTADO)
      && plantillaDeTramite?.id !== 14;
    const _pasoConsultaDeAdeudo = _es_consulta_de_adeudo
      && pasos_para_tramites.find((p) => p.aplica_adeudo)?.id;
    // const _validateCNAaguaTlajo = _plantillaDeTramite.id === -1 && !!_pasoConsultaDeAdeudo
    //   && _pasoConsultaDeAdeudo === pasoActual?.id;
    return [
      _tramiteEnProceso,
      _tipoDeAfectacion,
      _labelTipoDePadronAfectado,
      tipo_de_padron,
      _esConsultaDeAdeudo && !_pasoConsultaDeAdeudo,
      _pasoConsultaDeAdeudo,
      false,
      _altaEnPaso,
      no_iniciar_con_adeudo,
      tipos_de_cargos_consulta,
      _permiteGenerarSinAdeudo,
      _esConsultaDeRecibos,
    ];
  };

  const [
    tramiteEnProceso,
    tipoDeAfectacion,
    labelTipoDePadronAfectado,
    tipoPadronAfectado,
    esConsultaDeAdeudo,
    pasoConsultaDeAdeudo,
    validateCNAaguaTlajo,
    altaEnPaso,
    noIniciarConAdeudo,
    tiposDeCargosConsulta,
    permiteGenerarSinAdeudo,
    esConsultaDeRecibos,
  ] = getProps(tramite, plantillaDeTramite);

  const canSkipSolicitante = !tramite && tipoDeAfectacion === afectacionesEnum.ALTA
    && [1, 15].includes(tipoPadronAfectado) && currentStep === stepsEnum.PADRON_SOLICITANTE;
  const validateGISInfo = tipoPadronAfectado === padronesEnum.PREDIO
    && (plantillaDeTramite?.requiere_gis && plantillaDeTramite
      ?.pasos_para_tramites.some((p) => p.tipo_de_paso === tiposDePasosEnum.GIS));
  const hasFusionStep = pasosDelTramite.some((p) => p.tipo_de_paso === tiposDePasosEnum.FUSION);
  const hasWritingJsonStep = pasosDelTramite.some((p) => p.no_afectar_padron);
  const hasImpactJsonStep = pasosDelTramite
    .some((p) => p.tipo_de_paso === tiposDePasosEnum.AFECTAR_PADRON_JSON);

  const buscarRecibos = async (_tipoDePadron, _padronId) => {
    if (_tipoDePadron && _padronId) {
      const _cargos = (await Promise.all(tiposDeCargosConsulta.map((t) => getCargosPaginados({
        tipo_de_cargo: t,
        saldado: true,
        object_id: _padronId,
        content_type: getContenTypePorTipoDePadron(_tipoDePadron),
      })))).flat();
      const responsesRecibos = await Promise.all(_cargos.map((c) => getReciboPDFDeTramite(c.id)));
      const _recibos = getDistinctValues(responsesRecibos.flat().map((r) => r.folio).flat());
      if (!_recibos.length) {
        Modal.info({
          centered: true,
          title: 'No se encontraron recibos',
          icon: <ExclamationCircleOutlined />,
          content: 'El padrón no ha realizado el pago necesario para iniciar el trámite',
        });
      }
      setFoliosRecibos(_recibos);
    } else {
      setFoliosRecibos([]);
    }
  };

  const validateAdeudoVencido = (_cargos, _padronFound, d) => {
    const filtered = _cargos.filter((c) => !c.tramite);
    const validateWithDate = plantillaDeTramite.valida_adeudo_con_fecha;
    const date = d?.clone()
      || (validateWithDate ? toMoment(_padronFound.fecha_traslado) : undefined);
    const mandatoryKeys = getMandatoryKeys(filtered, tiposDeCargosConsulta, date);
    const _cargosTramite = mandatoryKeys.map((k) => filtered.find((c) => c.id === k));
    return [mandatoryKeys, _cargosTramite, date];
  };

  const validateNoIniciarConAdeudo = (_padronFound, _cargos) => {
    const [mandatoryKeys, _cargosTramite, date] = validateAdeudoVencido(_cargos, _padronFound);

    const getModalAdeudoTitle = () => 'Consulta de adeudo';

    const getModalAdeudoContent = () => (
      <>
        <Text>
          {mandatoryKeys.length ? (
            <>
              El padrón tiene adeudos por pagar, por favor realice el pago antes de continuar.
              <br />
              {date && 'Cargos vencidos a fecha de otorgamiento: '}
              {/* {date && !validateCNAaguaTlajo && (
                <DatePicker
                  value={date}
                  format={DATE_FRONTEND_FORMAT}
                  onChange={(d) => {
                    onChangeDate(d);
                    modal.update({
                      content: getModalAdeudoContent(),
                      title: getModalAdeudoTitle(),
                      type: !mandatoryKeys.length ? 'success' : 'error',
                    });
                  }}
                  disabled={validateCNAaguaTlajo}
                  style={{ width: 150 }}
                  allowClear={false}
                  renderExtraFooter={() => (
                    <>
                      <Button
                        type="link"
                        className="no-color"
                        onClick={() => {
                          onChangeDate(toMoment(new Date()));
                          modal.update({
                            content: getModalAdeudoContent(),
                            title: getModalAdeudoTitle(),
                            type: !mandatoryKeys.length ? 'success' : 'error',
                          });
                        }}
                      >
                        Hoy
                      </Button>
                      <Button
                        type="link"
                        className="no-color"
                        onClick={() => {
                          onChangeDate(toMoment(_padronFound.fecha_de_celebracion));
                          modal.update({
                            content: getModalAdeudoContent(),
                            title: getModalAdeudoTitle(),
                            type: !mandatoryKeys.length ? 'success' : 'error',
                          });
                        }}
                      >
                        Fecha inicial
                      </Button>
                    </>
                  )}
                  showToday={false}
                />
              )} */}
              {date && validateCNAaguaTlajo && date.format(DATE_FRONTEND_FORMAT)}
            </>
          ) : `El padrón no tiene adeudos por pagar en este trámite${date ? date.format(`[ a fecha de otorgamiento: ] ${DATE_FRONTEND_FORMAT}`) : ''}.`}
        </Text>
        <br />
        <br />
        {_cargosTramite.map((cargo) => (
          <Col span={24} key={cargo.id}>
            <Text>
              {DEV && `(${cargo.id}) - `}
              {cargo.es_accesorio && '(Accesorio) '}
              {[
                cargo.tipo_de_cargo?.periodo_fiscal?.periodo,
                cargo.tipo_de_cargo?.clave,
                cargo.descripcion,
                cargo.tipo_de_cargo?.fecha_de_vencimiento
                && `(${cargo.tipo_de_cargo?.fecha_de_vencimiento})`,
              ].filter((e) => e).join(' - ')}
            </Text>
          </Col>
        ))}
      </>
    );

    // modal =
    Modal[!mandatoryKeys.length ? 'success' : 'error']({
      width: '60vw',
      title: getModalAdeudoTitle(),
      content: getModalAdeudoContent(date),
      onOk: () => setCargosTramite(_cargosTramite),
    });
  };

  const getAdeudo = async (_tipoDePadron, _padronId, setterPadron, _padronFound, callback) => {
    if (!_tipoDePadron || !_padronId) {
      setCargosTramite([]);
      return;
    }

    setLoading(true);
    const [_cargos, err] = await getAdeudoPadronAsync(_tipoDePadron, _padronId);
    setLoading(false);
    if (err) {
      message.warn(err);
      setterPadron();
      return;
    }
    const [mandatoryKeys, _cargosTramite] = validateAdeudoVencido(_cargos, tiposDeCargosConsulta);
    if (esConsultaDeAdeudo && !permiteGenerarSinAdeudo) {
      if (!mandatoryKeys.length) message.warn('El padrón no tiene adeudos por pagar en este trámite', 5);
    }
    if (noIniciarConAdeudo) validateNoIniciarConAdeudo(_padronFound, _cargos);
    setCargosTramite(_cargosTramite);
    if (callback) callback();
  };

  const focusSearchInput = () => setTimeout(() => screens.md && searchInputRef.current?.focus());

  const tiposDeCargos = plantillaDeTramite ? [
    plantillaDeTramite.tipos_de_cargos,
    ...plantillaDeTramite.pasos_para_tramites.map((p) => p.tipos_de_cargos),
  ].flat() : [];

  const periodos = useMemo(() => {
    if (plantillaDeTramite) {
      const diff = [...new Set(tiposDeCargos.map((tc) => tc.periodo_fiscal))];
      const mapped = diff.filter((e) => typeof e === 'number').map((id) => {
        const _periodo = periodosFiscales.find((pf) => pf.id === id);
        return ({ value: _periodo.id, label: _periodo.periodo, disabled: _periodo.vigente });
      });
      const periodoVigenteID = mapped.find((p) => p.disabled)?.value;
      if (isTransmision) {
        const anioTransmision = parseInt(includeJsonInfo(padronAfectado)?.fecha_traslado?.format?.('YYYY'), 10);
        const periodoCelebracion = mapped.find((e) => e.label === anioTransmision)?.value;
        setPeriodosSeleccionados([periodoVigenteID, periodoCelebracion].filter((e) => e));
      } else if (periodoVigenteID) {
        setPeriodosSeleccionados([periodoVigenteID]);
      }
      return mapped;
    }
    return [];
  }, [plantillaDeTramite, pasoActual]);

  const hasPermissionForStep = useMemo(() => {
    if (!currentStep) return false;
    if (isAdmin() || isStaff()) return true;

    const hasAllViewPermissionVariables = permission
      .tabs[permissionVariablesGPM.model].hasAllViewPermission;
    const hasAllViewPermissionRequisitos = permission
      .tabs[permissionRequisitos.model].hasAllViewPermission;
    const hasAllViewPermissionCargos = permission
      .tabs[permissionCargos.model].hasAllViewPermission;
    const hasPermissionToViewSolicitante = hasActionPermission('contribuyente', ActionsNames.view)
      || hasActionPermission('ciudadano', ActionsNames.view);
    if (typeof currentStep === 'string') {
      const hasPermissionMap = {
        [stepsEnum.PADRON_SOLICITANTE]: () => hasPermissionToViewSolicitante,
        [stepsEnum.PADRON_AFECTADO]: () => (tipoDeAfectacion === afectacionesEnum.ALTA
          ? hasActionPermission(padronesModelsEnum[tipoPadronAfectado], ActionsNames.add)
          : hasActionPermission(padronesModelsEnum[tipoPadronAfectado], ActionsNames.view)),
        [stepsEnum.REQUISITOS_GENERALES]: () => hasAllViewPermissionRequisitos,
        [stepsEnum.CASOS_DE_REQUISITOS]: () => hasAllViewPermissionRequisitos,
        [stepsEnum.REQUISITOS_DEL_CASO]: () => hasAllViewPermissionRequisitos,
        [stepsEnum.VARIABLES]: () => hasAllViewPermissionVariables,
        [stepsEnum.GENERAR_CARGOS]: () => hasAllViewPermissionCargos,
      };
      return hasPermissionMap[currentStep]();
    }
    const _roles = roles.map((r) => r.id);
    const hasConfigPermission = pasoActual.usuarios.includes(user.id)
      || pasoActual.groups.some((r) => _roles.includes(r));
    if (!hasConfigPermission) return false;

    const hasPermissionToChangePadronAfectado = hasActionPermission(
      padronesModelsEnum[tipoPadronAfectado],
      ActionsNames.change,
    );
    const hasPermissionToChangeSolicitante = hasActionPermission('ciudadano', ActionsNames.change)
      || hasActionPermission('contribuyente', ActionsNames.change);
    const modelAfectado = padrones.find((p) => p.id === tipoPadronAfectado)?.model;
    const hasAllViewPermissionObligaciones = permission
      .tabs[permissionObligaciones.model].hasAllViewPermission;
    const hasAllViewPermissionEmpresas = permission
      .tabs[permissionEmpresas.model].hasAllViewPermission;
    const hasAllViewPermissionParticipes = permission
      .tabs[permissionParticipe.model].hasAllViewPermission;
    const hasAllViewPermissionConstrucciones = permission
      .tabs[permissionConfigConstrucciones.model].hasAllViewPermission;
    const hasAllViewPermissionActividades = permission
      .tabs[permissionActividadesContribuyentes.model].hasAllViewPermission;
    const hasAllViewPermissionActividadesSat = permission
      .tabs[permissionActividadesEconomicasContribuyentes.model].hasAllViewPermission;
    const hasAllViewPermissionContVinculados = permission
      .tabs[permissionContribuyentesVinculados.model].hasAllViewPermission;
    const hasAllViewPermissionCitas = permission
      .tabs[permissionCitas.model].hasAllViewPermission;
    const hasAllViewPermissionAvaluoTerreno = permission
      .tabs[permissionConfigTerreno.model].hasAllViewPermission;
    const hasAllViewPermissionColindancias = permission
      .tabs[permissionConfigColindancias.model].hasAllViewPermission;
    const hasAllViewPermissionAreasComunes = permission
      .tabs[permissionAreasComunes.model].hasAllViewPermission;
    const hasAllViewPermissionValoresReferidos = permission
      .tabs[permissionValoresReferidos.model].hasAllViewPermission;
    const hasAllViewPermissionAlertas = permission
      .tabs[permissionAlertas.model].hasAllViewPermission;

    const hasPermissionMap = {
      [tiposDePasosEnum.EMISION_DE_DOCUMENTO]: () => permission.add_expedientedetramite,
      [tiposDePasosEnum.FIRMA_ELECTRONICA]: () => permission.change,
      [tiposDePasosEnum.GIS]: () => permission.add_expedientedetramite,
      [tiposDePasosEnum.VARIABLES]: () => hasAllViewPermissionVariables,
      [tiposDePasosEnum.MODIFICACION_SOLICITANTE]: () => hasPermissionToChangeSolicitante,
      [tiposDePasosEnum.MODIFICACION_AFECTADO]: () => hasPermissionToChangePadronAfectado,
      [tiposDePasosEnum.VALIDACION_REQUISITOS]: () => hasAllViewPermissionRequisitos,
      [tiposDePasosEnum.CAMBIO_DE_PROPIETARIO]: () => hasPermissionToViewSolicitante
        && hasPermissionToChangePadronAfectado,
      [tiposDePasosEnum.REQUISITOS]: () => hasAllViewPermissionRequisitos,
      [tiposDePasosEnum.CARGOS]: () => hasAllViewPermissionCargos,
      [tiposDePasosEnum.ALTA_AFECTADO]: () => permission[`add_${modelAfectado}`],
      [tiposDePasosEnum.DIRECCION_PRINCIPAL]: () => permission[`change_${modelAfectado}`]
        && addressPermission.hasAllViewPermission,
      [tiposDePasosEnum.DIRECCION_SECUNDARIA]: () => permission[`change_${modelAfectado}`]
        && addressPermission.hasAllViewPermission,
      [tiposDePasosEnum.OBLIGACIONES]: () => hasAllViewPermissionObligaciones,
      [tiposDePasosEnum.EMPRESAS]: () => hasAllViewPermissionEmpresas,
      [tiposDePasosEnum.PARTICIPES]: () => hasAllViewPermissionParticipes,
      [tiposDePasosEnum.FOTOGRAFIA]: () => permission.add_expedientedetramite,
      [tiposDePasosEnum.CONSTRUCCIONES]: () => hasAllViewPermissionConstrucciones,
      [tiposDePasosEnum.AREAS_COMUNES_DE_PREDIOS]: () => hasAllViewPermissionAreasComunes,
      [tiposDePasosEnum.VALORES_REFERIDOS_DE_PREDIOS]: () => hasAllViewPermissionValoresReferidos,
      [tiposDePasosEnum.ACTIVIDADES_ECONOMICAS]: () => hasAllViewPermissionActividades,
      [tiposDePasosEnum.ACTIVIDADES_ECONOMICAS_SAT]: () => hasAllViewPermissionActividadesSat,
      [tiposDePasosEnum.CONTRIBUYENTES_VINCULADOS]: () => hasAllViewPermissionContVinculados,
      [tiposDePasosEnum.CARGA_DE_DOCUMENTO]: () => permission.add_expedientedetramite,
      [tiposDePasosEnum.CITA]: () => hasAllViewPermissionCitas,
      [tiposDePasosEnum.BAJA_EMPRESA]: () => permission.change_empresa,
      [tiposDePasosEnum.AFECTAR_PADRON_JSON]: () => permission.change_predio,
      [tiposDePasosEnum.SUBDIVISION]: () => permission.add_predio && permission.change_predio
        && permission.add_tramite && permission.change_tramite,
      [tiposDePasosEnum.FUSION]: () => permission.change_predio,
      [tiposDePasosEnum.AVALUO_TERRENO]: () => hasAllViewPermissionAvaluoTerreno,
      [tiposDePasosEnum.COLINDANCIAS]: () => hasAllViewPermissionColindancias,
      [tiposDePasosEnum.ALERTAS]: () => hasAllViewPermissionAlertas,
    };
    const validatePermission = hasPermissionMap[pasoActual.tipo_de_paso];
    return validatePermission ? validatePermission() : true;
  }, [currentStep, tramite]);

  useEffect(() => {
    let mounted = true;
    const fetchData = async () => {
      setLoading(true);
      const promises = [
        getPeriodosFiscales(),
        getVariables(),
        getValoresPorVariablesDeSeleccion(),
        getCategoriasDeVariables(),
      ];
      if (!tramiteParam && !citaParam) {
        promises.push(getAllPages(getContribuyentes, { es_autoridad_externa: true }));
        promises.push(getAllPages(getCatalogoPeritosDePredio));
        promises.push(getAllPages(getCatalogoNotariosDePredios));
      }
      if (showControls) {
        promises.push(getDepartamentos());
        promises.push(getDependencias());
      }
      if (REPUVE) {
        promises.push(
          getConfiguracionesDePadrones({ padron: 15, uso_de_configuracion_de_padron: 1 }),
        );
      }
      await checkToken();
      const [
        _periodosFiscales,
        _catalogoDeVariables,
        _valoresDeVariablesDeSeleccion,
        _categoriasDeVariables,
        _autoridadesExternas = [],
        _peritosDePredios = [],
        _notariosDePredios = [],
        _unidadesResponsables = [],
        _unidadesOperativas = [],
        [_configContribuyente] = [],
      ] = await Promise.all(promises);
      if (mounted) {
        setConfigContribuyente(_configContribuyente);
        setUnidadesResponsables(_unidadesResponsables);
        setUnidadesOperativas(_unidadesOperativas);
        setPeriodosFiscales(_periodosFiscales);
        setCatalogoDeVariables(_catalogoDeVariables);
        setValoresDeVariables(_valoresDeVariablesDeSeleccion);
        setCategoriasDeVariables(_categoriasDeVariables);
        setAutoridadesExternas(_autoridadesExternas);
        setPeritosDePredios(_peritosDePredios.map((e) => ({
          ...e,
          disabled: !e.vigente,
          tooltip: !e.vigente && `Perito sin vigencia (${e.fecha_vigencia?.format(DATE_FRONTEND_FORMAT)})`,
        })));
        setNotariosDePredios(_notariosDePredios);
        focusSearchInput();
        if (tramiteParam) {
          // eslint-disable-next-line no-use-before-define
          setTimeout(() => onFinishSearchTramite({ id: tramiteParam }, _periodosFiscales), 2000);
        } else if (citaParam) {
          // eslint-disable-next-line no-use-before-define
          setTimeout(autofillFromCita, 2000);
        } else if (plantillaParam) {
          // eslint-disable-next-line no-use-before-define
          setTimeout(() => onSelectPlantilla(plantillaParam), 2000);
        } else {
          setLoading(false);
        }
      }
    };
    fetchData();
    return () => {
      mounted = false;
    };
  }, []);

  useEffect(() => {
    const validate = async () => {
      if (!padronAfectado) {
        setHasGISInfo(false);
        return;
      }
      setLoading(true);
      const [hasInfo] = await validateGIS(padronAfectado.clave_catastral_municipal);
      setHasGISInfo(hasInfo);
      setLoading(false);
    };
    if (validateGISInfo) {
      validate();
    }
  }, [padronAfectado]);

  const getUrl = () => {
    if (tramiteParam) return `/tramites/seguimiento-de-tramites${finalizadosParam ? '-finalizados' : ''}`;
    if (citaParam) return '/citas/seguimiento-de-citas';
    if (plantillaParam) return '/tramites/registrar-tramite';
    return undefined;
  };

  const onCancel = () => {
    if (tramiteParam || citaParam) {
      history.push(getUrl());
      return;
    }
    if (plantillaParam) {
      history.push(getUrl());
    }
    setLoading(false);
    setPlantillaDeTramite();
    setCurrentStep(null);
    setCasoDeRequisitos();
    setPadronAfectado();
    setPadronSolicitante();
    setSelectedKeysTiposCargos([]);
    setStatusRequisitos(initialValueStatusRequisitos);
    setTramite();
    setShowMessagesRequisitos(false);
    form.resetFields();
    formSearch.resetFields();
    formFilter.resetFields();
    setVisiblePreview();
    base64Ref.current = {};
    setCargosTramite([]);
    setFoliosRecibos([]);
    setHistorial([]);
    setExpediente([]);
    setComplementos([]);
    focusSearchInput();
    setHasObligaciones(false);
    setHasEmpresas(false);
    setHasParticipes(false);
    setHasZonasHomogeneas(false);
    setHasColindancias(false);
    setHasActividades(false);
    refPatch.current = false;
    setHasGISInfo(false);
    setCitas([]);
    setValuesRepuve(false);
    setLastMessage();
    setTramites([]);
    setPrediosRelacionados();
  };

  const fetchCitas = async (_tramite = tramite) => {
    const _citas = await getCitas({ tramite: _tramite.id }, true);
    setCitas(_citas);
  };

  const searchPadron = async (qNameOrId, tipoDePadron, callback, extraParams = {}) => {
    setLoading(true);
    const q = typeof qNameOrId === 'string' && form.getFieldValue(qNameOrId);
    const id = typeof qNameOrId === 'number' && qNameOrId;
    if (q || id) {
      const _params = { ...extraParams };
      _params[q ? 'q' : 'id'] = q || id;
      const _matches = await getPadronesMap[tipoDePadron](_params, false);
      const matches = (_matches.results || _matches).filter((e) => e.estados_globales !== 5);
      if (matches.length === 1) {
        const _padronFound = await retrievePadronesMap[tipoDePadron](matches[0].id);
        if (tipoDePadron === padronesEnum.VEHICULO) {
          _padronFound.historial_de_placas = matches[0].historial_de_placas;
        }
        _padronFound.direccion_index = matches[0].direccion_index;
        if (callback) {
          await callback(_padronFound);
          setLoading(false);
        }
        return _padronFound;
      }
      message.warn(matches.length ? 'Ingrese una búsqueda más específica'
        : `No se encontró ${padrones.find((e) => e.id === tipoDePadron)?.descripcion}`);
    }
    if (callback) setLoading(false);
    return null;
  };

  const getHistorial = async (_tramite = tramite, stopLoading = true) => {
    setLoading(true);
    const [_historial, _comentarios] = await Promise.all([
      getHistorialDeTramite({ tramite: _tramite.id }),
      getComentariosDeTramites({ tramite: _tramite.id }),
    ]);
    const archivos = await getArchivosDeComentariosDeTramitesPorIdsComentario(_comentarios
      .map((e) => e.id));
    const indexed = _historial.map((h) => {
      const comentario = _comentarios.find((c) => c.id === h.comentario);
      if (!comentario) return h;
      comentario.archivos = archivos.filter((e) => e.comentario === comentario.id);
      return { ...h, comentario };
    });
    setHistorial(indexed);
    if (stopLoading) setLoading(false);
  };

  const getExpediente = async (_tramite = tramite, stopLoading = true) => {
    setLoading(true);
    const _expediente = await getExpedientesDeTramites({ tramite: _tramite.id });
    setExpediente(_expediente);
    if (stopLoading) setLoading(false);
  };

  const mapCargos = (_plantillaDeTramite, _periodosFiscales) => (cargo) => {
    const tipo_de_cargo = tiposDeCargos.find((tc) => tc.id === cargo.tipo_de_cargo.id);
    const periodo_fiscal = tipo_de_cargo && _periodosFiscales
      .find((pf) => pf.id === tipo_de_cargo.periodo_fiscal);
    return {
      ...cargo,
      tipo_de_cargo: tipo_de_cargo ? { ...tipo_de_cargo, periodo_fiscal } : cargo.tipo_de_cargo,
    };
  };

  const _getCargos = async (
    _getAdeudo,
    _tramite = tramite,
    _plantillaDeTramite = plantillaDeTramite,
    _periodosFiscales = periodosFiscales,
  ) => {
    if (_getAdeudo) {
      const _tipoDePadronSolicitante = _tramite.solicitante_ciudadano
        ? solicitantesEnum.CIUDADANO : solicitantesEnum.CONTRIBUYENTE;
      const _tipoDePadronAfectado = getTipoDePadronPorContenType(
        _tramite.content_type_a_padron,
      );
      const _idSolicitante = _tipoDePadronSolicitante === solicitantesEnum.CIUDADANO
        ? _tramite.ciudadano : _tramite.contribuyente;
      const [, err] = await getAdeudoPadronAsync(
        _tipoDePadronAfectado && !altaEnPaso ? _tipoDePadronAfectado : _tipoDePadronSolicitante,
        _tipoDePadronAfectado && !altaEnPaso ? _tramite.object_id_padron : _idSolicitante,
        (_message) => setLoadingAdeudo(_message),
        false,
      );
      setLoadingAdeudo();
      if (err) {
        return [err, []];
      }
    }
    const _params = { tramite: _tramite.id, eliminado: false, cancelado: false };
    const _cargos = await getCargosPaginados(_params);
    return [
      null,
      normalizeCargos(_cargos).map(mapCargos(_plantillaDeTramite, _periodosFiscales)),
    ];
  };

  const autofillFromCita = async () => {
    const { results: [cita] } = await getCitas({ id: citaParam });
    if (!cita) {
      message.info('Cita no encontrada');
      setLoading(false);
      return;
    }
    if (cita.tramite) {
      message.info('Cita ya cuenta con trámite');
      setLoading(false);
      return;
    }
    if (cita.estado_de_cita !== estadosCitasMap.EN_PROCESO) {
      message.info('Cita no se encuentra en proceso');
      setLoading(false);
      return;
    }
    const _plantillaDeTramite = await getPlantillaTramite(cita.plantilla_de_tramite);
    if (!_plantillaDeTramite || !_plantillaDeTramite.generar_tramite_posterior_a_cita) {
      message.info('Sucedió algo inesperado, intente mas tarde');
      setLoading(false);
      return;
    }
    const _tipoSolicitante = cita.ciudadano
      ? solicitantesEnum.CIUDADANO : solicitantesEnum.CONTRIBUYENTE;
    const _idSolicitante = _tipoSolicitante === solicitantesEnum.CIUDADANO
      ? cita.ciudadano : cita.contribuyente;
    const _padronSolicitante = await searchPadron(_idSolicitante, _tipoSolicitante);
    if (!_padronSolicitante) {
      message.info('Sucedió algo inesperado, intente mas tarde');
      setLoading(false);
      return;
    }
    setPadronSolicitante(_padronSolicitante);
    setPlantillaDeTramite(_plantillaDeTramite);
    setCitas([cita]);
    setCurrentStep(stepsEnum.PADRON_SOLICITANTE);
    setTipoPadronSolicitante(_tipoSolicitante);
    setLoading(false);
  };

  const fetchComplementos = async (_tramite = tramite) => {
    const _complementos = await getComplementosDeTramites({ tramite: _tramite.id });
    setComplementos(_complementos);
  };

  const onFinishSearchTramite = async (_values = null, _periodosFiscales = periodosFiscales) => {
    setLoading(true);
    const values = _values || formSearch.getFieldsValue();
    const [_tramite] = await getTramites(values);
    if (!_tramite) {
      message.info('No se encontró trámite con el folio brindado');
      setLoading(false);
      return;
    }
    const _plantillaDeTramite = await getPlantillaTramite(_tramite.plantilla);
    const _tipoDePadronSolicitante = _tramite.solicitante_ciudadano
      ? solicitantesEnum.CIUDADANO : solicitantesEnum.CONTRIBUYENTE;
    const _idSolicitante = _tipoDePadronSolicitante === solicitantesEnum.CIUDADANO
      ? _tramite.ciudadano : _tramite.contribuyente;
    const _padronSolicitante = await searchPadron(_idSolicitante, _tipoDePadronSolicitante);
    const _tipoDePadronAfectado = getTipoDePadronPorContenType(_tramite.content_type_a_padron);
    if (_tramite.object_id_padron) {
      const _padronAfectado = await searchPadron(_tramite.object_id_padron, _tipoDePadronAfectado);
      setPadronAfectado(_padronAfectado);
    }
    let [err, _cargos] = await _getCargos(
      _plantillaDeTramite.tipos_de_cargos.length
      || _plantillaDeTramite.tipos_de_cargos_consulta.length,
      _tramite,
      _plantillaDeTramite,
      _periodosFiscales,
    );
    if (_cargos.some((c) => !c.saldado) && ![4, 5].includes(_tramite?.estados_globales)) {
      [err, _cargos] = await _getCargos(true, _tramite, _plantillaDeTramite, _periodosFiscales);
    }
    if (/traslado de dominio/i.test(_plantillaDeTramite.nombre)) {
      const cargoSaldado = _cargos.find((c) => c.saldado);
      if (cargoSaldado) {
        const _recibo = await getReciboPDFDeTramite(cargoSaldado.id);
        if (_recibo) {
          const recibo = await _getRecibo(_recibo.id[0]);
          _tramite.recibo = recibo;
        }
      }
    }

    if (err) {
      onCancel();
      setLoading(false);
      return;
    }
    if (_plantillaDeTramite.pasos_para_tramites
      .some((p) => p.tipo_de_paso === tiposDePasosEnum.SUBDIVISION)) {
      const _tramites = await getAllPages(getTramites, { tramite_subdivision_madre: _tramite.id });
      setTramites(_tramites);
    }
    const _prediosRelacionados = await getLargeListByID(
      retrievePadronesMap[padronesEnum.PREDIO],
      _tramite.predios_relacionados,
    );
    if (_tramite.tramite_subdivision_madre) {
      [_tramite.tramiteMadre] = await getTramites({ id: _tramite.tramite_subdivision_madre });
      if (!_tramite.tramiteMadre) {
        message.info('No se encontró trámite madre, inténtelo de nuevo');
        setLoading(false);
        return;
      }
      if (_tramite.tramiteMadre?.estados_globales === ESTADOS_GLOBALES_MAP.CANCELADO) {
        _tramite.estados_globales = ESTADOS_GLOBALES_MAP.CANCELADO;
      }
    }
    await getHistorial(_tramite, false);
    await getExpediente(_tramite, false);
    await fetchCitas(_tramite);
    await getHistorial(_tramite, false);
    await fetchComplementos(_tramite);
    setCargosTramite(_cargos);
    setTipoPadronSolicitante(_tipoDePadronSolicitante);
    setPadronSolicitante(_padronSolicitante);
    setCasoDeRequisitos(_plantillaDeTramite.casos.find((c) => c.id === _tramite.caso));
    setTramite(_tramite);
    setPlantillaDeTramite(_plantillaDeTramite);
    setCurrentStep(stepsEnum.PADRON_SOLICITANTE);
    setPrediosRelacionados(_prediosRelacionados);
    setLoading(false);
  };

  useEffect(() => {
    const _lastLog = historial.at(-1);
    if (TLAJOMULCO && currentStep === stepsEnum.PADRON_SOLICITANTE
      && _lastLog && pasosDelTramite.length) {
      const paso = pasosDelTramite.find((p) => p.id === _lastLog.paso);
      const paso_a_mandar = pasosDelTramite.find((p) => p.id === _lastLog.paso_a_mandar);
      const pasoDestino = paso && paso_a_mandar && paso.orden >= paso_a_mandar.orden
        ? paso_a_mandar
        : paso || paso_a_mandar;
      if (pasoDestino) {
        setTimeout(() => setCurrentStep(pasoDestino.id));
      }
    }
  }, [historial, pasosDelTramite]);

  const onFinishFilter = async (values) => {
    const _params = values.tipoDeFiltro ? { [values.tipoDeFiltro]: values.filtro } : null;
    await fetchPlantillasDeTramites(1, null, _params);
  };

  const tiposDeFiltros = [
    {
      id: 0,
      descripcion: 'Todo',
    },
    {
      id: 'dependencia',
      descripcion: 'Dependencia',
      disabled: !permission.view_unidadoperativa,
    },
    {
      id: 'departamentos',
      descripcion: 'Departamento',
      disabled: !permission.view_unidadresponsable,
    },
    {
      id: 'tipo_de_padron',
      descripcion: 'Padrón',
    },
    {
      id: 'nombre',
      descripcion: 'Nombre',
    },
  ];

  const filtros = {
    0: [],
    dependencia: unidadesOperativas,
    departamentos: unidadesResponsables,
    tipo_de_padron: padrones,
  };

  const getRequirements = ({
    tipo_de_padron: padron,
    requiere_padron: requierePadron,
    es_tramite_gratuito: esTramiteGratuito,
    es_consulta_de_adeudo: _esConsultaDeAdeudo,
    es_consulta_de_recibos: _esConsultaDeRecibos,
    no_iniciar_con_adeudo: _noIniciarConAdeudo,
    configuracion_de_padron: configPadron,
    tipos_de_cargos,
    pasos_para_tramites = [],
    tipos_de_cargos_consulta: _tiposDeCargosConsulta = [],
    formato_para_folio,
  }) => {
    const hasTiposDeCargos = tipos_de_cargos.length
      || pasos_para_tramites.some((p) => p.tipos_de_cargos.length);

    const conditions = [
      {
        condition: !formato_para_folio,
        text: 'formato de folio',
      },
      {
        condition: (padron || configPadron) && !requierePadron,
        text: 'requiere padron',
      },
      {
        condition: (requierePadron || configPadron) && !padron,
        text: 'tipo de padrón',
      },
      {
        condition: (requierePadron || padron) && !configPadron,
        text: 'configuración de padrón',
      },
      {
        condition: esTramiteGratuito && !!hasTiposDeCargos,
        text: 'es trámite gratuito',
      },
      {
        condition: !esTramiteGratuito && !hasTiposDeCargos,
        text: 'tipos de cargos',
      },
      {
        condition: (_esConsultaDeAdeudo || _esConsultaDeRecibos) && !_tiposDeCargosConsulta.length,
        text: 'tipos de cargos consulta',
      },
      {
        condition: _tiposDeCargosConsulta.length
          && !(_esConsultaDeAdeudo || _esConsultaDeRecibos || _noIniciarConAdeudo),
        text: 'es consulta de adeudo o es consulta de recibos o no iniciar con adeudo',
      },
    ];
    const conditionsNotPassed = conditions.filter((e) => e.condition).map((e) => e.text);
    const notSupportedMessage = requierePadron && padron
      && !(getPadronesMap[padron] && postPadronesMap[padron] && patchPadronesMap[padron])
      ? 'tipo de trámite no soportado' : '';
    if (conditionsNotPassed.length) {
      if (notSupportedMessage) {
        conditionsNotPassed[conditionsNotPassed.length - 1] = `${conditionsNotPassed[conditionsNotPassed.length - 1]};`;
        conditionsNotPassed.push(notSupportedMessage);
      }
      const str = listToString(conditionsNotPassed);
      return str ? `plantilla de trámite con configuración incorrecta, revisar: ${str}` : null;
    }
    return notSupportedMessage;
  };

  const onSelectPlantilla = async (_plantillaId) => {
    setLoading(true);
    const _plantillaTramite = await getPlantillaTramite(_plantillaId);
    setLoading(false);
    if (!_plantillaTramite) return;
    setPlantillaDeTramite(_plantillaTramite);
    setTimeout(() => setCurrentStep(stepsEnum.PADRON_SOLICITANTE));
    setTipoPadronSolicitante(_plantillaTramite.padrones_solicitante[0]);
  };

  const requiredRule = { required: true };
  const rules = {
    required: [requiredRule],
    q_afectado: [requiredRule],
    q_solicitante: [requiredRule],
  };

  const resetAndValidateSolicitante = () => {
    setPadronSolicitante();
    form.resetFields(['q_solicitante', 'object_id_solicitante']);
    form.validateFields(['q_solicitante', 'object_id_solicitante']);
  };

  const resetAndValidateAfectado = () => {
    setPadronAfectado();
    form.resetFields(['q_afectado', 'object_id_afectado']);
    form.validateFields(['q_afectado', 'object_id_afectado']);
  };

  const FormItemSearchPadron = ({
    name,
    label,
    disabled,
    inputProps,
    prefixProps,
    onClickAdvanced,
    resultProps,
    allowAdd = false,
  }) => (
    <InputSearchPro
      label={label}
      name={name}
      onClickAdvanced={onClickAdvanced}
      breakPoints={{ md: 24 }}
      prefix={{
        rules: rules.required,
        label: 'Padrón',
        style: { width: 150 },
        allowClear: false,
        ...prefixProps,
      }}
      inputProps={inputProps}
      resultProps={{
        keyLabelRender: false,
        breakPoints: { md: 24 },
        ...resultProps,
      }}
      rules={rules[name]}
      disabled={disabled}
      allowAdd={allowAdd}
    />
  );

  const propsByPadron = {
    [padronesEnum.CIUDADANO]: ['email', 'numero_de_celular', 'lada'],
    [padronesEnum.CONTRIBUYENTE]: ['correo_electronico', 'telefono_celular', 'lada_celular'],
  };

  const hasContactInfo = (pdrn) => propsByPadron[tipoPadronSolicitante].every((p) => pdrn[p]);

  const onCancelModalCambioPropietario = (discartSolicitante = false) => {
    setOpenCambioPropietario(false);
    if (discartSolicitante) setPadronSolicitante();
  };

  const generarPlaca = async (placaNueva, _tramite, fecha_de_baja, contribuyente_propietario) => {
    const _placas = await getPlacas({ vehiculo: padronAfectado.id });
    const ultimaPlaca = _placas[_placas.length - 1];

    // baja de placa vigente repuve y baja con info de finanzas
    if (ultimaPlaca?.vigente) {
      const placaFinanzasBaja = _tramite?.padron.historial_de_placas
        .find((p) => p.numero_de_placa === ultimaPlaca.numero_de_placa);
      const placaBaja = await patchPlaca(ultimaPlaca.id, {
        vigente: false,
        estado_de_la_placa: 2, // baja
        fecha_de_baja: placaFinanzasBaja?.fecha_de_baja || fecha_de_baja,
        cantidad_de_placas: placaFinanzasBaja?.cantidad_de_placas,
        estado: placaFinanzasBaja?.estado,
      });
      if (!placaBaja) return false;
    }

    let placaAlta;

    // alta de placa nueva con datos de placa vigente nueva
    if (placaNueva.numero_de_placa !== ultimaPlaca?.numero_de_placa) {
      placaAlta = await postPlaca({
        vigente: true,
        procedencia: procedenciasEnum.GPM,
        contribuyente_propietario: contribuyente_propietario
          || padronAfectado.contribuyente_propietario.id,
        vehiculo: padronAfectado.id,
        tramite: tramite?.id,
        estado_de_la_placa: 1, // activo
        numero_de_placa: placaNueva.numero_de_placa,
        fecha_expedicion_placa: placaNueva.fecha_expedicion_placa,
      });
      if (!placaAlta) return false;
    }

    const placa = placaAlta || ultimaPlaca;
    // actualizacion de datos de placa vigente en vehiculo
    if (placa?.vigente && placa?.numero_de_placa !== padronAfectado.numero_de_placa_vigente) {
      const values = {
        fecha_expedicion_placa: placaNueva.fecha_expedicion_placa,
        numero_de_placa_vigente: placaNueva.numero_de_placa,
      };
      if (contribuyente_propietario) {
        values.contribuyente_propietario = contribuyente_propietario;
      }
      const updated = await patchPadronesMap[tipoPadronAfectado](padronAfectado.id, values);
      if (!updated) return false;
    }
    return true;
  };

  const tipoDeContribuyenteSolicitante = plantillaDeTramite
    ?.tipo_de_contribuyente_solicitante;

  const onSolicitanteFound = async (_padron, fn, _padronAfectado = padronAfectado) => {
    dispatch({ type: SET_PIN_PADRON_INFO });
    if (!REPUVE && !OAXACA && !hasContactInfo(_padron) && !_padron.continuarSinInfoContacto) {
      message.info('Padrón no cuenta con datos de contacto', 10);
      setTimeout(() => dispatch({
        type: SET_PIN_PADRON_INFO,
        payload: { tipo_de_padron: tipoPadronSolicitante, ..._padron },
      }));
      return;
    }
    if (plantillaDeTramite.iniciar_solo_con_solicitante_contribuyente) {
      const tipo = plantillaDeTramite.tipo_de_contribuyente_solicitante.id;
      if ((tipo === tiposDeContribuyentesSolicitantesEnum.NOTARIO && !_padron.es_notario)
        || (tipo === tiposDeContribuyentesSolicitantesEnum.PERITO && !_padron.es_perito)) {
        message.info(`El solicitante seleccionado no es ${tipoDeContribuyenteSolicitante.descripcion}`, 10);
        return;
      }
    } else if (!plantillaDeTramite.aplica_contribuyente_especial
      && (_padron.es_notario || _padron.es_perito)) {
      message.info(`No es posible usar solicitante seleccionado porque es ${_padron.es_notario ? 'NOTARIO' : 'PERITO'}`, 10);
      return;
    }
    if (typeof fn === 'function') fn();
    setPadronSolicitante(_padron);
    form.setFieldsValue({ object_id_solicitante: _padron.id });
    if ((esConsultaDeAdeudo || noIniciarConAdeudo) && (!tipoPadronAfectado || altaEnPaso)) {
      await getAdeudo(tipoPadronSolicitante, _padron?.id, setPadronSolicitante);
    }
    if (esConsultaDeRecibos && (!tipoPadronAfectado || altaEnPaso)) {
      await buscarRecibos(tipoPadronSolicitante, _padron?.id, setPadronSolicitante);
    }
    if (REPUVE && _padronAfectado
      && _padron.id !== _padronAfectado?.contribuyente_propietario?.id) {
      setOpenCambioPropietario(true);
    }
  };

  const mapAlerta = (alerta) => (
    <li key={alerta.id} className={alerta.es_restrictiva ? 'danger' : null}>
      {alerta.descripcion}
      {' '}
      {alerta.es_restrictiva && '(Restrictiva)'}
    </li>
  );

  const showAlertas = () => Modal.info({
    width: `${screens.md ? 60 : 90}%`,
    title: 'Alertas',
    content: (
      <>
        {hasAlertasRestrictivas && (
          <>
            <Text type="warning">
              No es posible iniciar trámite debido a que existen alertas restrictivas
            </Text>
            <br />
          </>
        )}
        {!!alertasSolicitante.length && (
          <Text>
            {padronToString(padronSolicitante, tipoPadronSolicitante, true, false)}
            <br />
            <ul>
              {alertasSolicitante.map(mapAlerta)}
            </ul>
          </Text>
        )}
        {!!alertasSolicitante.length && !!alertasAfectado.length && (
          <>
            <br />
            <br />
          </>
        )}
        {!!alertasAfectado.length && (
          <Text>
            {padronToString(includeJsonInfo(padronAfectado), tipoPadronAfectado, true, false)}
            <br />
            <ul>
              {alertasAfectado.map(mapAlerta)}
            </ul>
          </Text>
        )}
      </>
    ),
  });

  const dataSourceSolicitantes = {
    [tiposDeContribuyentesSolicitantesEnum.AUTORIDAD_EXTERNA]: autoridadesExternas,
    [tiposDeContribuyentesSolicitantesEnum.NOTARIO]: notariosDePredios,
    [tiposDeContribuyentesSolicitantesEnum.PERITO]: peritosDePredios,
  }[tipoDeContribuyenteSolicitante?.id];

  const SearchSolicitante = () => (tipoDeContribuyenteSolicitante ? (
    <Col span={24}>
      <Form.Item
        label={tipoDeContribuyenteSolicitante.descripcion}
        name="object_id_solicitante"
        rules={rules.required}
      >
        <Select
          dataSource={dataSourceSolicitantes}
          labelProp="nombre_completo"
          // eslint-disable-next-line max-len
          keyLabelRender={tipoDeContribuyenteSolicitante?.id !== tiposDeContribuyentesSolicitantesEnum.AUTORIDAD_EXTERNA
            && tipoDeContribuyenteSolicitante?.id !== tiposDeContribuyentesSolicitantesEnum.NOTARIO}
          // eslint-disable-next-line max-len
          render={tipoDeContribuyenteSolicitante?.id === tiposDeContribuyentesSolicitantesEnum.NOTARIO
            ? (s) => ['clave', 'nombre_completo', 'numero_notaria'].map((k) => s[k]).filter((e) => e).join(' - ')
            : undefined}
          disabled={!!((padronAfectado && padronSolicitante) || tramite)}
          onChange={(id) => searchPadron(id, tipoPadronSolicitante, onSolicitanteFound)}
        />
      </Form.Item>
    </Col>
  ) : (
    <FormItemSearchPadron
      title="Búsqueda/Registro del solicitante"
      name="q_solicitante"
      label={padronesSolicitantes.find((e) => e.id === tipoPadronSolicitante)?.descripcion}
      onClickAdvanced={() => setVisibleBusquedaPadronSolicitante(true)}
      prefixProps={{
        dataSource: padronesSolicitantes,
        name: 'tipo_de_padron_solicitante',
        style: { width: 170 },
        onChange: (val) => setTipoPadronSolicitante(val),
      }}
      inputProps={{
        onPressEnter: () => searchPadron(
          'q_solicitante',
          tipoPadronSolicitante,
          onSolicitanteFound,
        ),
        onChange: ({ target: { value } }) => {
          if (!value && padronSolicitante) {
            resetAndValidateSolicitante();
          }
        },
      }}
      resultProps={{
        name: 'object_id_solicitante',
        label: padronesSolicitantes.find((e) => e.id === tipoPadronSolicitante)?.descripcion,
        dataSource: padronSolicitante,
        render: (padron) => padronToString(padron, tipoPadronSolicitante),
        rules: rules.required,
        onClear: (REPUVE || !padronAfectado) && !tramite
          ? () => resetAndValidateSolicitante() : undefined,
      }}
      disabled={!!((padronAfectado && padronSolicitante) || tramite)}
    />
  ));

  const extraParams = useMemo(() => {
    if (plantillaDeTramite && padronSolicitante) {
      return getParamsPadron(
        plantillaDeTramite,
        tipoPadronSolicitante,
        padronSolicitante,
      );
    }
    return {};
  }, [plantillaDeTramite, padronSolicitante]);

  const validateCNAAgua = async (_padronFound, callback) => {
    const [recaudadora, tipoPredio, cuenta] = _padronFound
      .clave_catastral_municipal.match(/\d+|\D+/g);
    const [error, cert] = await postConsultaCertificadoNoAdeudoAgua({
      recaudadora,
      tipoPredio,
      cuenta,
    });

    if (cert) {
      cert.captura = toMoment(cert.fechaCaptura);
      cert.validoHasta = toMoment(`${cert.anioCertificado}-${cert.mesCertificado}-01`).endOf('month');
      cert.fecha_traslado = toMoment(_padronFound.fecha_traslado);
      cert.vigente = cert.validoHasta.isAfter(cert.fecha_traslado);
    }

    let modal;
    const fechaTraslado = toMoment(_padronFound.fecha_traslado);

    const onChangeDate = (_fecha_traslado) => {
      cert.fecha_traslado = _fecha_traslado;
      cert.vigente = cert.validoHasta.isAfter(_fecha_traslado);
    };

    const getModalCNATitle = () => (
      <Text>
        Certificado De No Adeudo De Agua
        {cert && (
          <Text type={cert.vigente ? 'success' : 'danger'}>
            {!cert.vigente && ' No'}
            {' '}
            Vigente
          </Text>
        )}
      </Text>
    );

    const getModalCNAContent = () => {
      if (error) return <Text>{error}</Text>;

      return (
        <>
          <Text>
            {'Fecha de otorgamiento: '}
            <DatePicker
              value={cert.fecha_traslado}
              format={DATE_FRONTEND_FORMAT}
              onChange={(d) => {
                onChangeDate(d);
                modal.update({
                  content: getModalCNAContent(),
                  title: getModalCNATitle(),
                  type: cert.vigente ? 'success' : 'error',
                });
              }}
              style={{ width: 150 }}
              allowClear={false}
              renderExtraFooter={() => (
                <>
                  <Button
                    type="link"
                    className="no-color"
                    onClick={() => {
                      onChangeDate(toMoment(new Date()));
                      modal.update({
                        content: getModalCNAContent(),
                        title: getModalCNATitle(),
                        type: cert.vigente ? 'success' : 'error',
                      });
                    }}
                  >
                    Hoy
                  </Button>
                  <Button
                    type="link"
                    className="no-color"
                    onClick={() => {
                      onChangeDate(toMoment(fechaTraslado));
                      modal.update({
                        content: getModalCNAContent(),
                        title: getModalCNATitle(),
                        type: cert.vigente ? 'success' : 'error',
                      });
                    }}
                  >
                    Fecha inicial
                  </Button>
                </>
              )}
              showToday={false}
            />
          </Text>
          <br />
          <Text>{`Certificado válido hasta ${cert.validoHasta.format('MMMM YYYY')}`}</Text>
          <br />
          <Text>{`Certificado emitido el ${cert.captura.format(DATE_FRONTEND_FORMAT)}`}</Text>
        </>
      );
    };

    modal = Modal[cert?.vigente ? 'success' : 'error']({
      width: '60vw',
      title: getModalCNATitle(),
      content: getModalCNAContent(fechaTraslado),
      okButtonProps: { className: 'no-color' },
      cancelText: 'Usar otra fecha',
      onOk: () => {
        if (cert?.vigente) {
          if (esConsultaDeAdeudo) {
            getAdeudo(
              padronesEnum.PREDIO,
              _padronFound.id,
              setPadronAfectado,
              _padronFound,
              callback,
            );
          }
        }
      },
    });
    return error;
  };

  const onAfectadoFound = async (_padronFound) => {
    if (_padronFound.json_predio) {
      message.info(`No es posible iniciar trámite con ${labelTipoDePadronAfectado}: ${getPadronKey(_padronFound, tipoPadronAfectado)}`);
      return;
    }
    if (validateCNAaguaTlajo) {
      const error = await validateCNAAgua(_padronFound);
      if (error) return;
    }
    // omitimos si validateCNAaguaTlajo para hacerlo en validateCNAAgua
    // y usar la misma fecha_traslado usada para cna
    if ((esConsultaDeAdeudo || noIniciarConAdeudo) && !validateCNAaguaTlajo) {
      await getAdeudo(tipoPadronAfectado, _padronFound.id, setPadronAfectado, _padronFound);
    }
    if (esConsultaDeRecibos) {
      await buscarRecibos(tipoPadronAfectado, _padronFound?.id, setPadronAfectado);
    }
    const _padronAfectado = await searchPadron(_padronFound.id, tipoPadronAfectado);
    setPadronAfectado(_padronAfectado);
    form.setFieldsValue({ object_id_afectado: _padronFound.id });
    setLoading(false);
  };

  const SearchAfectado = () => (
    <FormItemSearchPadron
      title="Búsqueda del padrón afectado"
      name="q_afectado"
      label={labelTipoDePadronAfectado}
      onClickAdvanced={() => setVisibleBusquedaPadronAfectado(true)}
      prefixProps={{
        dataSource: padrones,
        name: 'tipo_de_padron_afectado',
        disabled: true,
      }}
      inputProps={{
        onPressEnter: async () => {
          const _padron = await searchPadron('q_afectado', tipoPadronAfectado, onAfectadoFound, extraParams);
          if (!_padron && REPUVE && tipoPadronAfectado === padronesEnum.VEHICULO) {
            message.info({
              content: (
                <>
                  El vehículo ingresado No se encuentra registrado,
                  favor de realizar el trámite de &quot;Inscripción Vehicular&quot;
                  <Button type="link" href="/tramites/registrar-tramite/?plantilla=1">
                    Ir
                    <ArrowRightOutlined />
                  </Button>
                </>
              ),
              duration: 10,
            });
          }
        },
        onChange: ({ target: { value } }) => {
          if (!value && padronAfectado) {
            resetAndValidateAfectado();
          }
        },
      }}
      resultProps={{
        name: 'object_id_afectado',
        label: labelTipoDePadronAfectado,
        dataSource: padronAfectado,
        render: (padron) => padronToString(padron, tipoPadronAfectado, false, false),
        rules: rules.required,
        onClear: tramite || REPUVE ? null : () => resetAndValidateAfectado(),
      }}
      disabled={!!tramite}
      allowAdd={false}
    />
  );

  const stepsTitles = {
    [stepsEnum.PADRON_SOLICITANTE]: 'PADRÓN SOLICITANTE',
    [stepsEnum.PADRON_AFECTADO]: 'PADRÓN AFECTADO',
    [stepsEnum.REQUISITOS_GENERALES]: 'REQUISITOS GENERALES',
    [stepsEnum.CASOS_DE_REQUISITOS]: 'SELECCIÓN DE CASO DE REQUISITOS',
    [stepsEnum.REQUISITOS_DEL_CASO]: casoDeRequisitos?.descripcion?.toUpperCase() || 'REQUISITOS DEL CASO',
    [stepsEnum.VARIABLES]: 'COMPLEMENTAR INFORMACIÓN',
    [stepsEnum.GENERAR_CARGOS]: esConsultaDeAdeudo ? 'ADEUDO' : 'GENERACIÓN DE CARGOS',
  };

  const stepsTimelineItems = useMemo(() => {
    if (!plantillaDeTramite) {
      return [];
    }
    const steps = [
      {
        key: stepsEnum.PADRON_SOLICITANTE,
        title: stepsTitles[stepsEnum.PADRON_SOLICITANTE],
      },
    ];
    if (tipoPadronAfectado && !altaEnPaso) {
      steps.push({
        key: stepsEnum.PADRON_AFECTADO,
        title: stepsTitles[stepsEnum.PADRON_AFECTADO],
      });
    }
    if (plantillaDeTramite.requisitos_generales.length) {
      steps.push({
        key: stepsEnum.REQUISITOS_GENERALES,
        title: stepsTitles[stepsEnum.REQUISITOS_GENERALES],
      });
    }
    if (plantillaDeTramite.casos.length) {
      steps.push({
        key: stepsEnum.CASOS_DE_REQUISITOS,
        title: stepsTitles[stepsEnum.CASOS_DE_REQUISITOS],
      });
      steps.push({
        key: stepsEnum.REQUISITOS_DEL_CASO,
        title: stepsTitles[stepsEnum.REQUISITOS_DEL_CASO],
      });
    }
    if (plantillaDeTramite.variables.length) {
      steps.push({
        key: stepsEnum.VARIABLES,
        title: stepsTitles[stepsEnum.VARIABLES],
      });
    }
    if (plantillaDeTramite.tipos_de_cargos.length
      || getMandatoryKeys(cargosTramite, tiposDeCargosConsulta).length) {
      steps.push({
        key: stepsEnum.GENERAR_CARGOS,
        title: stepsTitles[stepsEnum.GENERAR_CARGOS],
      });
    }
    return steps.concat(pasosDelTramite
      .map((paso) => ({ key: paso.id, title: paso.nombre })));
  }, [plantillaDeTramite, currentStep, tramite, padronSolicitante, padronAfectado,
    statusRequisitos, tramiteHasAllVariables]);

  const currentStepTimelineIdx = stepsTimelineItems.findIndex((s) => s.key === currentStep);
  const currentStepTimeline = stepsTimelineItems[currentStepTimelineIdx]?.key;
  const stepToInLastLog = pasosDelTramite.find((p) => p.id === lastLog?.paso_a_mandar);
  const {
    PASOSVERIFICADOS: pasosVerificados = [],
    PASOVERIFICO: pasoVerifico,
  } = JSON.parse(tramite?.comentarios_del_tramite || '{}');

  const getTitle = ({ orden, key, title }, idx) => {
    const verified = !!pasosVerificados.length
      && (pasosVerificados.includes(key) || idx < currentStepTimelineIdx);
    const atended = typeof key === 'number' && existingValidLogForStep(key);
    const textDecoration = orden && stepToInLastLog?.orden > orden
      && !historial.some((h) => h.paso === key) ? 'line-through' : null;
    const className = [atended ? 'blue' : '', verified ? 'success' : ''].join(' ').trim();
    if (key === lastLog?.paso_a_mandar || (!lastLog && key === currentStepTimeline)) {
      return (
        <b className={className || 'primary-text'} style={{ textDecoration, background: '#FFF' }}>
          {title}
          {/* {verified && <CheckCircleOutlined />} */}
        </b>
      );
    }
    return (
      <b style={{ textDecoration, background: '#FFF' }} className={className}>
        {title}
        {/* {verified && <CheckCircleOutlined />} */}
      </b>
    );
  };

  const getStatus = (idx) => {
    if (currentStepTimelineIdx > idx) return 'finish';
    if (currentStepTimelineIdx < idx) return 'wait';
    return 'process';
  };

  const StepsTimeline = () => (
    <Steps
      type="mini"
      progressDot
      labelPlacement="vertical"
      current={currentStepTimelineIdx}
    >
      {stepsTimelineItems.map((step, idx) => {
        const status = getStatus(idx);
        return (
          <Steps.Step
            key={step.key}
            title={getTitle(step)}
            status={status}
            onClick={DEV ? (() => setCurrentStep(step.key)) : null}
          />
        );
      })}
    </Steps>
  );

  const currentStepIsLastStep = currentStep === stepsTimelineItems.at(-1)?.key;

  const VISIBLE_PREVIEW_ENUM = {
    RECEIPT: 'RECEIPT',
    PAYMENT_ORDER: 'PAYMENT_ORDER',
    FORMATO_DE_ACUSE: 'FORMATO_DE_ACUSE',
    ACUSE_VARIABLES: 'ACUSE_VARIABLES',
    COTIZACION: 'COTIZACION',
  };

  const srcPaymentOrder = `${VISIBLE_PREVIEW_ENUM.PAYMENT_ORDER}_${currentStep}`;
  const srcCotizacion = `${VISIBLE_PREVIEW_ENUM.COTIZACION}_${currentStep}`;

  const getCotizacion = async () => {
    if (base64Ref.current[srcCotizacion]) {
      setVisiblePreview(srcCotizacion);
      return;
    }
    setLoading(true);
    const _cargos = cargosTramite.map((c) => ({
      nombre: `${c.tipo_de_cargo?.clave} ${c.tipo_de_cargo?.periodo_fiscal?.periodo} ${c.tipo_de_cargo.descripcion}`,
      base: c.adeudo_base,
      cantidad: 1,
      recargos: c.recargos_base,
      gastos: c.gastos_totales,
      descuentos: c._descuentos_totales_junto_accesorios,
      adeudo: c.adeudo_total,
    }));
    const [base, recargos, gastos, descuentos, adeudo] = _cargos
      .reduce(([_base, _recargos, _gastos, _descuentos, _adeudo], curr) => [
        _base + curr.base,
        _recargos + curr.recargos,
        _gastos + curr.gastos,
        _descuentos + curr.descuentos,
        _adeudo + curr.adeudo,
      ], [0, 0, 0, 0, 0]);

    const values = {
      ID: pasoActual.id_de_reporte,
      Parametros: [
        {
          Nombre: 'clave',
          TipoParametro: 'Texto',
          Valor: tramite.id,
        },
        {
          Nombre: 'tramite',
          TipoParametro: 'Texto',
          Valor: tramite.id,
        },
        {
          Nombre: 'importe_total',
          TipoParametro: 'Texto',
          Valor: adeudo,
        },
        {
          Nombre: 'cargos_json',
          TipoParametro: 'JSON',
          Valor: [
            {
              nombre: 'Clave Periodo y Descripción',
              base: 'Importe base',
              cantidad: 'Cantidad',
              recargos: 'Recargos',
              gastos: 'Gastos/Multas',
              descuentos: 'Descuentos',
              adeudo: 'Adeudo',
            },
            ..._cargos,
            {
              nombre: 'Total',
              base,
              cantidad: '',
              recargos,
              gastos,
              descuentos,
              adeudo,
            },
          ],
        },
      ],
    };
    const [err, formato] = await postObtenerDocumento(values);
    if (formato) {
      base64Ref.current[srcCotizacion] = formato;
      setVisiblePreview(srcCotizacion);
    } else {
      message.warn(err);
    }
    setLoading(false);
  };

  const getAcuseTramite = async () => {
    const srcAcuse = VISIBLE_PREVIEW_ENUM.FORMATO_DE_ACUSE;
    setLoading(true);
    if (base64Ref.current[srcAcuse]) {
      setVisiblePreview(srcAcuse);
      return;
    }
    const values = {
      ID: plantillaDeTramite.id_reporte_acuse,
      Parametros: [
        {
          Nombre: 'clave',
          TipoParametro: 'Texto',
          Valor: tramite.id,
        },
        {
          Nombre: 'tramite',
          TipoParametro: 'Texto',
          Valor: tramite.id,
        },
      ],
    };
    const [err, formato] = await postObtenerDocumento(values);
    if (formato) {
      base64Ref.current[srcAcuse] = formato;
      setVisiblePreview(srcAcuse);
    } else {
      message.warn(err);
    }
    setLoading(false);
  };

  const getFecha = () => toMoment(new Date()).endOf('month').format(DATE_NETPAY_FORMAT);
  // const getFecha = (cargos) => {
  //   const cargoTraslacion = OAXACA && cargos
  //     .find((c) => TIPOS_DE_CARGOS_TRASLACION.includes(c.tipo_de_cargo.id));
  //   if (cargoTraslacion) {
  //     const now = toMoment(new Date());
  //     const ene31 = toMoment(`${now.year()}-01-31`);
  //     const fecha_de_vencimiento = toMoment(cargoTraslacion.fecha_de_vencimiento)
  //       .year(now.year()).month(now.month());
  //     if (now.isAfter(fecha_de_vencimiento)) fecha_de_vencimiento.add('month', 1);
  //     const dates = [fecha_de_vencimiento];
  //     if (now.isBefore(ene31)) dates.push(ene31);
  //     const sorted = dates.toSorted((a, b) => (a.isAfter(b) ? 1 : -1));
  //     return sorted[0].format(DATE_NETPAY_FORMAT);
  //   }
  //   return toMoment(new Date()).endOf('month').format(DATE_NETPAY_FORMAT);
  // };

  const imprimirOrdenDePago = async (cargos) => {
    if (base64Ref.current[srcPaymentOrder]) {
      setVisiblePreview(srcPaymentOrder);
      return;
    }
    setLoading(true);
    const amount = round(cargos.reduce((acum, curr) => acum + curr.adeudo_total, 0));
    const fechaBilling = toMoment(new Date()).format('DD-MM-YYYY');
    const fecha = getFecha(cargos);
    const ciudadano = tipoPadronSolicitante === solicitantesEnum.CIUDADANO
      ? padronSolicitante.id : padronSolicitante.ciudadano;
    const result = await postImprimirOrdenDePago(
      amount,
      fecha,
      fechaBilling,
      cargosTramite.map((e) => e.id),
      (padronAfectado || padronSolicitante).id,
      tipoPadronAfectado || tipoPadronSolicitante,
      ciudadano,
      true,
      null,
      null,
      cargosTramite.map((c) => c.descuentos_aplicables.map((d) => d.id)).flat(2),
      null,
      pasoActual?.otro_formato,
      false,
    );
    if (result.success) {
      base64Ref.current[srcPaymentOrder] = result.base64;
      setVisiblePreview(srcPaymentOrder);
    }
    setLoading(false);
  };

  const jumpToNextStepLog = (puede_continuar) => {
    const needCustomLog = puede_continuar && pasosVerificados.length;
    const idxPasoVerifico = stepsTimelineItems.findIndex((e) => e.key === pasoVerifico);
    const next = stepsTimelineItems
      .find((s, idx) => idx > currentStepTimelineIdx && !pasosVerificados.includes(s.key));
    return [needCustomLog && idxPasoVerifico >= currentStepTimelineIdx, next?.key || pasoVerifico];
  };

  const getComentarios = (puede_continuar, fallbackAll = false) => {
    const idxPasoVerifico = stepsTimelineItems.findIndex((e) => e.key === pasoVerifico);
    const needCustomLog = puede_continuar && pasosVerificados.length;
    const nextStepToAtendIdx = idxPasoVerifico + (pasosVerificados.includes(pasoVerifico) ? 1 : 0);
    if (fallbackAll || (needCustomLog && currentStepTimelineIdx === nextStepToAtendIdx)) {
      const pasosAtendidos = stepsTimelineItems
        .slice(0, stepsTimelineItems.findIndex((e) => e.key === currentStep));
      return JSON.stringify({
        pasoVerifico,
        pasosVerificados: pasosAtendidos.map((e) => e.key),
      });
    }
    return null;
  };

  const postLog = async (comentario, puede_continuar) => {
    if (!pasoActual) return null;
    const [_logValues] = generateValues(pasoActual, pasosDelTramite, puede_continuar);
    // si pasoVerifico no ha sido "alcanzado" que hay que saltar a siguiente paso no "verificado"
    const [jump, to] = jumpToNextStepLog(puede_continuar);
    if (jump) {
      // verificar si va a jalar al ser el último paso
      _logValues.paso_a_mandar = to;
    }
    const logValues = {
      ..._logValues,
      tramite: tramite.id,
      comentario: `[AUTOGENERADO] ${comentario}`,
    };
    const log = await postHistorialDeTramite(logValues);
    // si pasoVerifico ha sido "alcanzado" que hay "verificar" los pasos anteriores
    const comentarios_del_tramite = getComentarios(puede_continuar);
    if (comentarios_del_tramite) {
      await patchTramite(tramite.id, { comentarios_del_tramite });
      setTramite({ ...tramite, comentarios_del_tramite });
    }
    if (log) await getHistorial();
    return log;
  };

  const getFileExpediente = (tipoDoc, paso) => [...expediente].reverse()
    .find((f) => f.tipo_de_documento_para_expediente === tipoDoc
      && (f.paso_para_tramite === paso || tipoDoc === tipoDeDocumentoExpedienteEnum.GIS));

  const saveFile = async (logComment, _values) => {
    setLoading(true);
    const values = _values || form.getFieldsValue();
    values.tramite = tramite.id;
    const tipoDocByTipoPaso = {
      [tiposDePasosEnum.GIS]: tipoDeDocumentoExpedienteEnum.GIS,
      [tiposDePasosEnum.FOTOGRAFIA]: tipoDeDocumentoExpedienteEnum.FOTOGRAFIA,
      [tiposDePasosEnum.EMISION_DE_DOCUMENTO]: tipoDeDocumentoExpedienteEnum.DOCUMENTO,
      [tiposDePasosEnum.CARGA_DE_DOCUMENTO]: tipoDeDocumentoExpedienteEnum.DOCUMENTO,
      [tiposDePasosEnum.CARGOS]: tipoDeDocumentoExpedienteEnum.RECIBO,
      [tiposDePasosEnum.VARIABLES]: tipoDeDocumentoExpedienteEnum.ACUSE_VARIABLES,
      [stepsEnum.GENERAR_CARGOS]: tipoDeDocumentoExpedienteEnum.RECIBO,
      [stepsEnum.VARIABLES]: tipoDeDocumentoExpedienteEnum.ACUSE_VARIABLES,
    };
    const tipoDePaso = pasoActual?.tipo_de_paso || currentStep;
    values.tipo_de_documento_para_expediente = values.tipo_de_documento_para_expediente
      || tipoDocByTipoPaso[tipoDePaso];
    values.paso_para_tramite = pasoActual?.id;
    values.archivo = values.archivo.file;
    const saved = await postExpedienteDeTramite(values);
    if (saved) {
      await getExpediente();
      if (logComment) {
        const _log = await postLog(logComment, true);
        setLoading(false);
        return [saved, _log];
      }
    }
    setLoading(false);
    return [saved];
  };

  const getAcuseVariables = async (id_reporte, _view) => {
    const srcAcuseVariables = `${VISIBLE_PREVIEW_ENUM.ACUSE_VARIABLES}_${id_reporte}_${currentStep}`;
    const _acuseExp = getFileExpediente(
      tipoDeDocumentoExpedienteEnum.ACUSE_VARIABLES,
      typeof currentStep === 'number' ? currentStep : null,
    );
    if (_acuseExp) {
      base64Ref.current[srcAcuseVariables] = _acuseExp.archivo;
      if (_view) setVisiblePreview(srcAcuseVariables);
      return;
    }

    setLoading(true);
    const values = {
      ID: id_reporte,
      Parametros: [
        {
          Nombre: 'tramite',
          TipoParametro: 'Texto',
          Valor: tramite.id,
        },
        {
          Nombre: 'clave',
          TipoParametro: 'Texto',
          Valor: tramite.id,
        },
      ],
    };
    if (pasoActual) {
      values.Parametros.push({
        Nombre: 'paso',
        TipoParametro: 'Texto',
        Valor: pasoActual.id,
      });
    }
    const [err, _base64] = await postObtenerDocumento(values);
    if (!_base64) {
      setLoading(false);
      message.warn(err);
      return;
    }

    const name = `Acuse variables${pasoActual ? ` paso: ${pasoActual.nombre}` : ''}`;
    const file = await dataUrlToFile(_base64, name, 'application/pdf');
    const [savedFile] = await saveFile(null, { archivo: { file, name: `${name}.pdf` } });
    setLoading(false);

    base64Ref.current[srcAcuseVariables] = savedFile.archivo;
    if (_view) setVisiblePreview(savedFile.archivo);
  };

  const logWithLoading = async (comentario, puede_continuar = true) => {
    const defMessage = {
      [tiposDePasosEnum.VALIDACION_REQUISITOS]: 'Requisitos validados',
      [tiposDePasosEnum.OBLIGACIONES]: 'Finalizada captura de obligaciones',
      [tiposDePasosEnum.EMPRESAS]: 'Finalizada captura de empresas',
      [tiposDePasosEnum.PARTICIPES]: 'Finalizada captura de participes',
      [tiposDePasosEnum.CONSTRUCCIONES]: 'Finalizada captura de bloques de construcciones',
      [tiposDePasosEnum.AREAS_COMUNES_DE_PREDIOS]: 'Finalizada captura de áreas comunes',
      [tiposDePasosEnum.VALORES_REFERIDOS_DE_PREDIOS]: 'Finalizada captura de valores referidos',
      [tiposDePasosEnum.AVALUO_TERRENO]: 'Finalizada captura de bloques de terreno',
      [tiposDePasosEnum.COLINDANCIAS]: 'Finalizada captura de colindancias',
      [tiposDePasosEnum.ACTIVIDADES_ECONOMICAS]: 'Finalizada captura de actividades económicas',
      [tiposDePasosEnum.ACTIVIDADES_ECONOMICAS_SAT]: 'Finalizada captura de actividades económicas SAT',
      [tiposDePasosEnum.CONTRIBUYENTES_VINCULADOS]: 'Finalizada captura de contribuyentes vinculados',
      [tiposDePasosEnum.VISTA_PADRON]: 'Confirmación de datos de padrón',
      [tiposDePasosEnum.ASIGNACION_CONSTANCIA]: 'Constancia ligada a vehículo',
      [tiposDePasosEnum.SINCRONIZACION_DE_DATOS_FINANZAS]: 'Datos sincronizados con finanzas',
      [tiposDePasosEnum.ALERTAS]: 'Finalizada captura de alertas',
    }[pasoActual.tipo_de_paso];
    setLoading(true);
    const log = await postLog(comentario || defMessage, puede_continuar);
    setLoading(false);
    return log;
  };
  const { updateCarteraAvailable, confirmUpdateCartera } = useActualizadorDeCartera({
    tipoDePadronId: tipoPadronAfectado,
    padron: padronAfectado,
    setLoading,
    permission,
    tramite,
  });

  const updateCartera = updateCarteraAvailable && plantillaDeTramite.aplica_actualizacion_cartera
    && permission.actualizar_cartera_tramites;

  const getRecibo = async (cargoId, show = true) => {
    if (pasoActual && !existingValidLogForStep(pasoActual.id)) {
      const log = await logWithLoading('[autogenerado] cargos saldados', true);
      if (!log) {
        message.warn('No fue posible consultar el recibo, intentelo de nuevo');
        return;
      }
    }
    const srcReceipt = `${VISIBLE_PREVIEW_ENUM.RECEIPT}_${currentStep}`;
    const _reciboExp = getFileExpediente(
      tipoDeDocumentoExpedienteEnum.RECIBO,
      typeof currentStep === 'number' ? currentStep : null,
    );
    if (_reciboExp) {
      if (show) {
        base64Ref.current[srcReceipt] = _reciboExp.archivo;
        setVisiblePreview(srcReceipt);
      }
      return;
    }
    setLoading(true);
    const _recibo = await getReciboPDFDeTramite(cargoId);
    if (!_recibo) {
      message.warn('No fue posible consultar el recibo, intentelo de nuevo');
      setLoading(false);
      return;
    }
    const isJrz = ENV_NAME === 'juarez';
    const name = `${isJrz ? 'Ticket' : 'Recibo'}${pasoActual ? `__${pasoActual.nombre}` : ''}`;
    const file = await dataUrlToFile(_recibo.base64, name, 'application/pdf');
    const [savedFile] = await saveFile(null, { archivo: { file, name: `${name}.pdf` } });
    setLoading(false);
    if (!savedFile) {
      message.warn('No fue posible consultar el recibo, intentelo de nuevo');
      return;
    }
    if (show) await getRecibo(cargoId);
  };

  const currentStepTitle = useMemo(
    () => {
      if (typeof currentStep === 'string') {
        return stepsTitles[currentStep];
      }
      return pasoActual?.nombre;
    },
    [currentStep, plantillaDeTramite, padronSolicitante, padronAfectado],
  );

  const PasoDocumento = ({ hasPermission, ...props }) => {
    const _disabled = existingValidLogForStep(pasoActual.id);
    const file = _disabled
      && getFileExpediente(tipoDeDocumentoExpedienteEnum.DOCUMENTO, pasoActual?.id)?.archivo;
    return (
      <Documento
        // eslint-disable-next-line react/jsx-props-no-spreading
        {...props}
        attrs={{ ...expedienteToAttrs(expediente), ...tramite.attrs }}
        tramite={tramite}
        reporteID={pasoActual.id_de_reporte}
        iFrameUrl={file}
        setLoading={setLoading}
        firmasElectronicas={firmasElectronicas}
        disabled={props.disabled || _disabled}
        hasPermission={hasPermission}
        generarConsecutivo={pasoActual.aplica_consecutivo_movimiento}
        capturarObservaciones={pasoActual.aplica_observaciones_cancelacion}
      />
    );
  };

  const saveDocumento = async () => {
    let savedFile = getFileExpediente(tipoDeDocumentoExpedienteEnum.DOCUMENTO, pasoActual.id);
    let _log = existingValidLogForStep(pasoActual.id);

    if (!_log || !savedFile) {
      const _base64 = form.getFieldValue('base64');
      const file = await dataUrlToFile(_base64, 'documento', null);
      const comment = `${pasoActual.nombre}: documento generado por funcionario`;
      [savedFile, _log] = await saveFile(_log ? null : comment, { archivo: { file } });
    }
    if (!_log || !savedFile) message.info('Intentelo de nuevo');
    setLoading(false);
    return savedFile && _log;
  };

  const PasoVariables = ({ hasPermission, ...props }) => (
    <Variables
      // eslint-disable-next-line react/jsx-props-no-spreading
      {...props}
      catalogoDeVariables={catalogoDeVariables}
      variables={pasoActual?.variables}
      disabled={props.disabled || existingValidLogForStep(pasoActual.id)}
      valoresDeVariablesDeSelecion={valoresDeVariablesDeSelecion}
    />
  );

  const PasoEFirma = ({ hasPermission, ...props }) => (
    <FirmaElectronica
      // eslint-disable-next-line react/jsx-props-no-spreading
      {...props}
      firmado={pasoActualHasFirma}
      hasPermission={hasPermission}
      firma_automatica={pasoActual?.firma_automatica}
    />
  );

  const CasosDeRequisitos = (props) => plantillaDeTramite?.casos.map((caso) => (
    <Col span={8} key={caso.id}>
      <StyledButton
        block
        onClick={() => {
          if (!tramite?.caso) {
            setCasoDeRequisitos(caso);
          }
        }}
        style={{ cursor: tramite?.caso && 'not-allowed' }}
        $selected={caso.id === casoDeRequisitos?.id}
        disabled={props.disabled}
        lineClamp={3}
      >
        {caso.nombre}
        {caso.id === casoDeRequisitos?.id && (<CheckOutlined />)}
      </StyledButton>
    </Col>
  ));

  const getLevel = (level) => (screens.md ? level : level + 1);

  const ValidacionRequisitos = ({
    requisitosGenerales,
    requisitosDelCaso,
    ...props
  }) => (
    <>
      {!!plantillaDeTramite.requisitos_generales.length && (
        <>
          <Title level={getLevel(3)}>Requisitos generales</Title>
          <RequisitosDelTramite
            // eslint-disable-next-line react/jsx-props-no-spreading
            {...props}
            // eslint-disable-next-line react/jsx-props-no-spreading
            {...requisitosGenerales}
            disabled={props.disabled || requisitosGenerales.disabled}
            allowReview
          />
        </>
      )}
      {!!tramite.caso && (
        <>
          <br />
          <br />
          <Title level={getLevel(3)}>{stepsTitles[stepsEnum.REQUISITOS_DEL_CASO]}</Title>
          <RequisitosDelTramite
            // eslint-disable-next-line react/jsx-props-no-spreading
            {...props}
            // eslint-disable-next-line react/jsx-props-no-spreading
            {...requisitosDelCaso}
            disabled={props.disabled || requisitosDelCaso.disabled}
            allowReview
          />
        </>
      )}
    </>
  );

  const componentsByStepMap = {
    [tiposDePasosEnum.EMISION_DE_DOCUMENTO]: PasoDocumento,
    [tiposDePasosEnum.FIRMA_ELECTRONICA]: PasoEFirma,
    [tiposDePasosEnum.GIS]: ArcGisMap,
    [tiposDePasosEnum.VARIABLES]: PasoVariables,
    [tiposDePasosEnum.MODIFICACION_SOLICITANTE]: RenderFieldsByConfig,
    [tiposDePasosEnum.MODIFICACION_AFECTADO]: RenderFieldsByConfig,
    [tiposDePasosEnum.VALIDACION_REQUISITOS]: ValidacionRequisitos,
    [tiposDePasosEnum.CAMBIO_DE_PROPIETARIO]: CambioPropietario,
    [tiposDePasosEnum.REQUISITOS]: RequisitosDelTramite,
    [tiposDePasosEnum.CARGOS]: Cargos,
    [tiposDePasosEnum.ALTA_AFECTADO]: RenderFieldsByConfig,
    [tiposDePasosEnum.DIRECCION_PRINCIPAL]: Direccion,
    [tiposDePasosEnum.DIRECCION_SECUNDARIA]: Direccion,
    [tiposDePasosEnum.OBLIGACIONES]: ObligacionesFiscalesContribuyente,
    [tiposDePasosEnum.EMPRESAS]: EmpresasDeContribuyentes,
    [tiposDePasosEnum.PARTICIPES]: Participe,
    [tiposDePasosEnum.FOTOGRAFIA]: Camera,
    [tiposDePasosEnum.CONSTRUCCIONES]: AvaluoConstrucciones,
    [tiposDePasosEnum.ACTIVIDADES_ECONOMICAS]: ActividadesEconomicas,
    [tiposDePasosEnum.ACTIVIDADES_ECONOMICAS_SAT]: ActividadesEconomicas,
    [tiposDePasosEnum.CONTRIBUYENTES_VINCULADOS]: ContribuyentesVinculados,
    [tiposDePasosEnum.CARGA_DE_DOCUMENTO]: CargaDocumento,
    [tiposDePasosEnum.VISTA_PADRON]: RenderFieldsByConfig,
    [tiposDePasosEnum.CITA]: citaPaso ? ConsultaCita : Cita,
    [tiposDePasosEnum.ASIGNACION_CONSTANCIA]: AsignacionConstancia,
    [tiposDePasosEnum.SINCRONIZACION_DE_DATOS_FINANZAS]: PlacaGPM,
    [tiposDePasosEnum.SUBDIVISION]: Subdivision,
    [tiposDePasosEnum.FUSION]: Fusion,
    [tiposDePasosEnum.AVALUO_TERRENO]: AvaluoTerreno,
    [tiposDePasosEnum.COLINDANCIAS]: Colindancias,
    [tiposDePasosEnum.AREAS_COMUNES_DE_PREDIOS]: AreasComunesDePredios,
    [tiposDePasosEnum.VALORES_REFERIDOS_DE_PREDIOS]: ValoresReferidosDePredios,
    [tiposDePasosEnum.ALERTAS]: Alertas,
  };

  // region -> Padrones Afectados
  const PadronesAfectadosOptions = () => {
    const [padronesFound, setPadronesFound] = useState([]);
    const fetchPadrones = async (_params) => {
      let _matches = await getPadronesMap[tipoPadronAfectado](_params, false);
      if (tramite?.id) {
        _matches = _matches.filter((p) => p.id === tramite?.object_id_padron);
      }
      setPadronesFound(_matches);
    };

    useEffect(() => {
      fetchPadrones({ ciudadano: padronSolicitante.id });
    }, []);

    return (
      <RadioGroup
        buttonStyle="solid"
        disabled={!!tramite}
        value={padronAfectado?.id}
        onChange={async ({ target: { value } }) => {
          const match = padronesFound.find((p) => p.id === value);
          await onAfectadoFound(match);
        }}
      >
        {!!padronesFound?.length && padronesFound.map((_p) => (
          <RadioButton
            key={_p.id}
            value={_p.id}
            $selected={padronAfectado?.id === _p.id}
          >
            <Row gutter={10}>
              <Col span={24}>
                PREDIO:
                {' '}
                <strong>
                  {_p?.clave ?? _p.id}
                </strong>
              </Col>
              <Col span={24}>
                DIRECCIÓN:
                {' '}
                <strong>
                  {address(_p.direccion_index)}
                </strong>
              </Col>
            </Row>
          </RadioButton>
        ))}
      </RadioGroup>
    );
  };

  const PadronAfectado = (props) => (
    <>
      {/* eslint-disable-next-line react/jsx-props-no-spreading */}
      <SearchAfectado {...props} />
      {tipoPadronAfectado === padronesEnum.PREDIO && IPROVINAY && (
        <PadronesAfectadosOptions />
      )}
      {padronAfectado && plantillaDeTramite.configuracion_de_padron.tipo_de_afectacion.id === 4 && (
        <RenderFieldsByConfig
          fields={plantillaDeTramite?.configuracion_de_padron
            ?.configuraciones_de_campos_de_padrones}
          tipoDeAfectacion={tipoDeAfectacion}
          plantillaDeTramite={plantillaDeTramite}
          setLoading={setLoading}
          tipoDePadron={tipoPadronAfectado === plantillaDeTramite
            ?.configuracion_de_padron.padron.id ? tipoPadronAfectado : null}
          padron={includeJsonInfo(padronAfectado)}
          tipoDePadronSolicitante={tipoPadronSolicitante}
          padronSolicitante={padronSolicitante}
          disabled
        />
      )}
      {validateGISInfo && padronAfectado && (
        <ArcGisMap
          clave_catastral_municipal={padronAfectado.clave_catastral_municipal}
          // required={!!tramite}
          screenshot={getFileExpediente(tipoDeDocumentoExpedienteEnum.GIS)?.archivo}
          setLoading={setLoading}
          callbackAttrs={(attrs) => tramite && setTramite((t) => ({ ...t, attrs }))}
          disabled={!!getFileExpediente(tipoDeDocumentoExpedienteEnum.GIS)}
          // eslint-disable-next-line react/destructuring-assignment
          hasPermission={props.hasPermission}
          attrs={!!tramite?.attrs}
          autoCapture
        />
      )}
    </>
  );

  const addressName = tipoPadronSolicitante === padronesEnum.CONTRIBUYENTE ? 'direcciones' : 'direccion';

  const PadronSolicitante = (props) => (
    <>
      {/* eslint-disable-next-line react/jsx-props-no-spreading */}
      <SearchSolicitante {...props} />
      {!!padronSolicitante && (
        <ModalDireccion
          baseURI={tipoPadronSolicitante === padronesEnum.CONTRIBUYENTE
            ? URIContribuyente : URICiudadano}
          parentID={padronSolicitante.id}
          addressPropName={addressName}
          callback={(d) => setPadronSolicitante((s) => ({ ...s, [addressName]: d }))}
          required={(tipoPadronAfectado === padronesEnum.VEHICULO && REPUVE) || OAXACA}
        />
      )}
      {REPUVE && padronSolicitante && configContribuyente && (
        <RenderFieldsByConfig
          fields={configContribuyente.configuraciones_de_campos_de_padrones}
          tipoDeAfectacion={afectacionesEnum.CONSULTA}
          setLoading={setLoading}
          tipoDePadron={tipoPadronSolicitante}
          padron={padronSolicitante}
          tipoDePadronSolicitante={tipoPadronSolicitante}
          padronSolicitante={padronSolicitante}
          disabled
        />
      )}
    </>
  );

  const valuesCargoCancelado = {
    observaciones_de_cancelado: 'Cargo cancelado por funcionario en trámite',
    prescripto: false,
    cancelado: true,
    estados_globales: ESTADOS_GLOBALES_MAP.CANCELADO,
    fecha_de_cancelado: toMoment(new Date()).format(DATETIME_FORMAT),
    usuario_que_cancelo: user.id,
  };

  const onCancelCargos = async (_cargos, hasCargosRelacionados) => {
    const modal = Modal.confirm({
      title: 'Confirmación de cancelación',
      width: '80%',
      content: (
        <>
          <Text>¿Seguro que desea cancelar los siguientes cargos?</Text>
          <br />
          {_cargos.map((c) => (
            <Text>
              {c.es_accesorio && '(Accesorio) '}
              {[c.tipo_de_cargo?.periodo_fiscal?.periodo, c.tipo_de_cargo?.clave, c.descripcion]
                .filter((e) => e).join(' - ')}
            </Text>
          ))}
          {hasCargosRelacionados && (
            <Col span={24} style={{ marginTop: 20 }}>
              <Text type="warning">
                <b>Nota:</b>
                los cargos relacionados al trámite pero no generados por el trámite
                no se veran afectados
              </Text>
            </Col>
          )}
        </>
      ),
      onOk: async () => {
        modal.update({ cancelButtonProps: { disabled: true } });
        setLoading(true);
        await checkToken();
        const motivos = await getMotivosDeCancelacionDeCargo();
        const motivoDirecto = motivos.find((m) => m.clave === 'DIRECTO');
        if (!motivoDirecto) {
          message.warn('No se encontró el motivo de cancelación "DIRECTO" en el catálogo.');
          setLoading(false);
          Modal.destroyAll();
          return;
        }
        const values = { ...valuesCargoCancelado, motivo_de_cancelacion: motivoDirecto.id };
        const responses = await Promise
          .all(_cargos.map((c) => patchCargo(c.id, values, true, null, motivoDirecto.clave)));
        if (responses.some((r) => r)) {
          base64Ref.current[srcPaymentOrder] = null;
          const canceled = responses.map((r, i) => r && _cargos[i].id.toString()).filter((e) => e);
          const [, _cargosTramite] = await _getCargos(true);
          setCargosTramite(_cargosTramite);
          await postLog(`Cargos cancelados por funcionario: (${listToString(canceled)})`, false);
          message.info(responses.every((r) => r)
            ? 'Cargos cancelados correctamente'
            : 'Falló cancelación de algunos cargos, inténtelo nuevamente');
        } else {
          message.info('Falló cancelación de cargos, inténtelo nuevamente');
        }
        setLoading(false);
        Modal.destroyAll();
      },
      okText: 'Cancelar cargos',
      okType: 'danger',
      cancelText: 'Cerrar',
      okButtonProps: { className: 'no-color' },
      closable: false,
    });
  };

  const tiposDeCargosToValuesGenerarCargos = (k, pre = true) => {
    const tc = tiposDeCargos.find((t) => t.id === k);
    const formValues = form.getFieldsValue();
    const values = {
      padron: padronAfectado ? tipoPadronAfectado : tipoPadronSolicitante,
      padron_id: (padronAfectado || padronSolicitante).id,
      tipo_de_cargo: tc.id,
      tramite: tramite.id,
      procedencia: procedenciasEnum.GPM,
    };
    if (tc.es_editable_fecha_de_vencimiento) {
      values.fecha_de_vencimiento = formValues[tc.id]
        .fecha_de_vencimiento?.format(DATE_FORMAT) || undefined;
    }
    if (tc.tipo_de_aplicacion === aplicacionesCargosEnum.CAPTURABLE) {
      values.importe = formValues[tc.id].importe;
    }
    if (tc.tipo_de_aplicacion === aplicacionesCargosEnum.FIJO) {
      values.importe = tc.importe;
    }
    // TODO: Por revisar a fondo, nayarit no usa tarifa actualmente
    if ([aplicacionesCargosEnum.TARIFA, aplicacionesCargosEnum.MULTIPLO]
      .includes(tc.tipo_de_aplicacion)) {
      let valor = formValues[tc.id].importe;
      if (tc.tipo_de_aplicacion === tiposDatosEnum.RANGO_DE_FECHAS) {
        const [fechaInicial, fechaFinal] = valor;
        valor = fechaFinal.diff(fechaInicial, 'days');
      }
      values.importe = valor;
    }
    if ([aplicacionesCargosEnum.FORMULA, aplicacionesCargosEnum.SQL_FUNCTION]
      .includes(tc.tipo_de_aplicacion)) {
      const _variables = tc.variables.map((v) => catalogoDeVariables.find((cv) => cv.id === v));
      values.variables = valuesToVariables(formValues, _variables, pre ? tc.id : null);
    }
    return values;
  };

  const generarCargoTotalizado = async (__cargos) => {
    let _cargos = [...__cargos];
    if (!tipoCargoTotalizado) return _cargos;
    const anioCelebracion = parseInt(includeJsonInfo(padronAfectado)?.fecha_de_celebracion?.format?.('YYYY'), 10);
    const periodoCelebracion = periodos.find((e) => e.label === anioCelebracion)?.value;
    if (periodoCelebracion !== tipoCargoTotalizado.periodo_fiscal) return _cargos;
    const cargoTotalizado = _cargos.find((c) => c.tipo_de_cargo.id === tipoCargoTotalizado.id);
    if (cargoTotalizado) {
      const canceled = await patchCargo(cargoTotalizado.id, valuesCargoCancelado, false);
      if (!canceled) return _cargos;
      _cargos = _cargos.filter((e) => e.id !== cargoTotalizado.id);
    }
    const values = tiposDeCargosToValuesGenerarCargos(tipoCargoTotalizado.id, false);
    const total = _cargos.reduce((acum, curr) => acum + curr.adeudo_total, 0);
    values.variables[0].valor = total;
    const _cargosGenerados = (await postGenerarCargos(values)).flat();
    if (_cargosGenerados.length) {
      const [, _cargosTramite] = await _getCargos(true);
      base64Ref.current[srcPaymentOrder] = null;
      cargosTramiteTextRef.current?.scrollIntoView({ block: 'center', behavior: 'smooth' });
      return _cargosTramite;
    }
    return _cargos;
  };

  const onRecalculateCargos = async (_cargos) => {
    const modal = Modal.confirm({
      title: 'Confirmación de recalculo de recargos',
      width: '80%',
      content: (
        <>
          <Text>¿Seguro que desea recalcular los siguientes cargos?</Text>
          <br />
          {_cargos.map((c) => (
            <Text key={c.id}>
              {c.es_accesorio && '(Accesorio) '}
              {[c.tipo_de_cargo?.periodo_fiscal?.periodo, c.tipo_de_cargo?.clave, c.descripcion]
                .filter((e) => e).join(' - ')}
            </Text>
          ))}
        </>
      ),
      onOk: async () => {
        modal.update({ cancelButtonProps: { disabled: true } });
        const recalculated = await postRecalcularRecargos({ cargos: _cargos.map(((c) => c.id)) });
        if (recalculated) {
          message.info('Cargos recalculados correctamente, actualizando adeudo...', 0);
        } else {
          message.warn('Falló recalculo de cargos, inténtelo nuevamente');
        }
        if (recalculated) {
          base64Ref.current[srcPaymentOrder] = null;
          let [, _cargosTramite] = await _getCargos(true);
          _cargosTramite = await generarCargoTotalizado(_cargosTramite);
          setSelectedKeysTiposCargos(selectedKeysTiposCargos
            .filter((tc) => !_cargosTramite.some((c) => c.tipo_de_cargo.id === tc)));
          setCargosTramite(_cargosTramite);
          Modal.destroyAll();
          setTimeout(() => document.querySelector('#btn-imprimir-orden-de-pago')?.click());
          if (pasoActual) {
            await postLog(`Cargos recalculados por funcionario: (${listToString(_cargosTramite
              .map((c) => c.id.toString()))})`, false);
          }
        } else {
          modal.update({ cancelButtonProps: { disabled: false } });
        }
        message.destroy();
      },
      okText: 'Recalcular cargos',
      cancelText: 'Cancelar',
      okButtonProps: { className: 'no-color' },
      closable: false,
    });
  };

  const stepComponents = {
    [stepsEnum.PADRON_SOLICITANTE]: PadronSolicitante,
    [stepsEnum.PADRON_AFECTADO]: tipoDeAfectacion !== afectacionesEnum.ALTA
      ? PadronAfectado : RenderFieldsByConfig,
    [stepsEnum.REQUISITOS_GENERALES]: RequisitosDelTramite,
    [stepsEnum.CASOS_DE_REQUISITOS]: CasosDeRequisitos,
    [stepsEnum.REQUISITOS_DEL_CASO]: RequisitosDelTramite,
    [stepsEnum.VARIABLES]: Variables,
    [stepsEnum.GENERAR_CARGOS]: Cargos,
    ...Object.fromEntries(pasosDelTramite.map((paso) => {
      const output = [paso.id, componentsByStepMap[paso.tipo_de_paso]];
      return output;
    }) || []),
  };

  const stepsPropsMap = {
    [stepsEnum.PADRON_SOLICITANTE]: {},
    [stepsEnum.PADRON_AFECTADO]: tipoDeAfectacion !== afectacionesEnum.ALTA
      ? { allowAdd: false } : {
        fields: plantillaDeTramite?.configuracion_de_padron?.configuraciones_de_campos_de_padrones,
        tipoDeAfectacion,
        setLoading,
        tipoDePadron: tipoPadronAfectado === plantillaDeTramite
          ?.configuracion_de_padron.padron.id ? tipoPadronAfectado : null,
        padron: padronAfectado,
        tipoDePadronSolicitante: tipoPadronSolicitante,
        padronSolicitante,
        disabled: !!padronAfectado,
      },
    [stepsEnum.REQUISITOS_GENERALES]: {
      tramite,
      requisitosGenerales: plantillaDeTramite?.requisitos_generales,
      permission: permission.tabs[permissionRequisitos.model],
      setStatusRequisitos: (val) => setStatusRequisitos({ ...statusRequisitos, generales: val }),
      loading,
      setLoading,
      setShowMessagesRequisitos,
      showMessagesRequisitos,
      disabled: pasosVerificados.includes(stepsEnum.REQUISITOS_GENERALES),
    },
    [stepsEnum.CASOS_DE_REQUISITOS]: {
      disabled: pasosVerificados.includes(stepsEnum.REQUISITOS_DEL_CASO),
    },
    [stepsEnum.REQUISITOS_DEL_CASO]: {
      tramite,
      casoDeRequisitos,
      permission: permission.tabs[permissionRequisitos.model],
      setStatusRequisitos: (val) => setStatusRequisitos({ ...statusRequisitos, caso: val }),
      setCasoDeRequisitos: () => setTramite({ ...tramite, caso: casoDeRequisitos?.id }),
      loading,
      setLoading,
      setShowMessagesRequisitos,
      showMessagesRequisitos,
      disabled: pasosVerificados.includes(stepsEnum.REQUISITOS_DEL_CASO),
    },
    [stepsEnum.VARIABLES]: {
      catalogoDeVariables,
      variables: plantillaDeTramite?.variables,
      disabled: tramiteHasAllVariables || pasosVerificados.includes(stepsEnum.VARIABLES),
      valoresDeVariablesDeSelecion,
      onClick: plantillaDeTramite?.id_acuse_variables
        && ((_view) => getAcuseVariables(plantillaDeTramite?.id_acuse_variables, _view)),
      categoriasDeVariables,
      required: true,
      tramite,
    },
    [stepsEnum.GENERAR_CARGOS]: {
      tiposDeCargos: plantillaDeTramite?.tipos_de_cargos,
      tiposDeCargosConsulta,
      tramite,
      cargosTramite,
      periodosSeleccionados,
      setPeriodosSeleccionados,
      selectedKeysTiposCargos,
      setSelectedKeysTiposCargos,
      periodosFiscales,
      getAcuseTramite: plantillaDeTramite?.id_reporte_acuse ? getAcuseTramite : null,
      catalogoDeVariables,
      getRecibo,
      imprimirOrdenDePago,
      cargosTramiteTextRef,
      periodos,
      setCargosSaldados,
      cargosSaldados,
    },
    ...Object.fromEntries(pasosDelTramite.map((paso) => {
      const output = [paso.id, {}];
      const _disabled = existingValidLogForStep(paso.id) || pasosVerificados.includes(paso.id);
      if (pasoActual?.id !== paso.id) return output;
      if ([tiposDePasosEnum.VALIDACION, tiposDePasosEnum.AFECTAR_PADRON_JSON]
        .includes(paso.tipo_de_paso)) {
        output[1] = null;
      } else if (paso.tipo_de_paso === tiposDePasosEnum.VARIABLES) {
        output[1] = {
          catalogoDeVariables,
          variables: paso.variables,
          disabled: _disabled,
          valoresDeVariablesDeSelecion,
          onClick: paso.id_de_reporte && ((_view) => getAcuseVariables(paso.id_de_reporte, _view)),
          categoriasDeVariables,
          tramite,
          fetchComplementos,
        };
      } else if (paso.tipo_de_paso === tiposDePasosEnum.MODIFICACION_SOLICITANTE) {
        output[1] = {
          fields: paso.configuracion_de_padron.configuraciones_de_campos_de_padrones,
          tipoDeAfectacion: afectacionesEnum.MODIFICACION,
          plantillaDeTramite,
          setLoading,
          tipoDePadron: tipoPadronSolicitante === paso.configuracion_de_padron.padron.id
            ? tipoPadronSolicitante : null,
          padron: padronSolicitante,
          disabled: _disabled,
        };
      } else if (paso.tipo_de_paso === tiposDePasosEnum.MODIFICACION_AFECTADO) {
        output[1] = {
          fields: paso.configuracion_de_padron.configuraciones_de_campos_de_padrones,
          tipoDeAfectacion: afectacionesEnum.MODIFICACION,
          plantillaDeTramite,
          setLoading,
          tipoDePadron: tipoPadronAfectado,
          tipoDePadronSolicitante: tipoPadronSolicitante,
          padron: paso.no_afectar_padron ? includeJsonInfo(padronAfectado) : padronAfectado,
          disabled: _disabled,
          // TODO: solo pasar valuesComplementos de variables capturadas antes del paso actual
          // valuesComplementos,
          key: `${currentStep}_${_disabled}_${historialesPasoActual.length}`,
          tramite,
          recibo: tramite?.recibo,
          padronSolicitante,
        };
      } else if (paso.tipo_de_paso === tiposDePasosEnum.GIS) {
        const screenshot = (getFileExpediente(tipoDeDocumentoExpedienteEnum.GIS, paso.id)?.archivo
          ?? form.getFieldValue('base64')) || base64Ref.current;
        output[1] = {
          clave_catastral_municipal: padronAfectado?.clave_catastral_municipal,
          setLoading,
          callbackAttrs: tramite?.attrs ? null : (attrs) => setTramite({
            ...tramite,
            attrs,
          }),
          screenshot,
          disabled: !!screenshot,
        };
      } else if (paso.tipo_de_paso === tiposDePasosEnum.VALIDACION_REQUISITOS) {
        output[1] = {
          tramite,
          loading,
          setLoading,
          permission: permission.tabs[permissionRequisitos.model],
          showMessagesRequisitos,
        };
        output[1].requisitosGenerales = {
          requisitosGenerales: plantillaDeTramite?.requisitos_generales,
          setStatusRequisitos: (val) => setStatusRequisitos({
            ...statusRequisitos,
            generales: val,
          }),
        };
        output[1].requisitosDelCaso = {
          casoDeRequisitos,
          setStatusRequisitos: (val) => setStatusRequisitos({
            ...statusRequisitos,
            caso: val,
          }),
          setCasoDeRequisitos: () => setTramite({ ...tramite, caso: casoDeRequisitos?.id }),
        };
      } else if (paso.tipo_de_paso === tiposDePasosEnum.CAMBIO_DE_PROPIETARIO) {
        output[1] = {
          tipoDePadronAfectado: plantillaDeTramite.tipo_de_padron,
          padronSolicitante,
          tipoPadronSolicitante,
          padronAfectado,
          disabled: pasoActual && existingValidLogForStep(pasoActual.id),
          setLoading,
        };
      } else if (paso.tipo_de_paso === tiposDePasosEnum.REQUISITOS) {
        output[1] = {
          tramite,
          requisitosGenerales: pasoActual?.requisitos || [],
          permission: permission.tabs[permissionRequisitos.model],
          setStatusRequisitos: (val) => setStatusRequisitos({
            ...statusRequisitos,
            [`paso_${paso.id}`]: val,
          }),
          loading,
          setLoading,
          setShowMessagesRequisitos,
          showMessagesRequisitos,
          allowReview: pasoActual?.requisitos.some(isInReview),
          authorizeAllCallback: async () => {
            setLoading(true);
            if (paso.actualizar_verificador) {
              await patchVehiculo(padronAfectado.id, { usuario_verificador: user.id });
            }
            await postLog('Requisitos autorizados por funcionario', true);
            setLoading(false);
            setShowMessagesRequisitos(false);
          },
          fetchCallback: (data) => data.length && tramiteEnProceso && setTramite({
            ...tramite,
            documento_de_tramite: data[0].requisitoDeTramite?.documentos_de_tramite?.id,
          }),
          isLastStep: currentStepIsLastStep,
          disabled: _disabled,
        };
      } else if (paso.tipo_de_paso === tiposDePasosEnum.CARGOS) {
        output[1] = {
          tramite,
          cargosTramite,
          tiposDeCargos: paso.tipos_de_cargos,
          periodosSeleccionados,
          setPeriodosSeleccionados,
          selectedKeysTiposCargos,
          setSelectedKeysTiposCargos,
          periodosFiscales,
          catalogoDeVariables,
          getRecibo,
          imprimirOrdenDePago,
          periodos,
          setCargosSaldados,
          cargosSaldados,
          getCotizacion: paso.id_de_reporte ? getCotizacion : null,
          onCancelCargos: permission.cancelar_cargo ? onCancelCargos : null,
          onRecalculateCargos: permission.recalcular_cargo ? onRecalculateCargos : null,
          valuesVariablesCargos,
          tipoCargoTotalizado,
          // TODO: aplicar ese values y modificar según convenga por datos en padrón y json
        };
      } else if (paso.tipo_de_paso === tiposDePasosEnum.ALTA_AFECTADO) {
        output[1] = {
          fields: plantillaDeTramite?.configuracion_de_padron
            ?.configuraciones_de_campos_de_padrones,
          tipoDeAfectacion,
          setLoading,
          tipoDePadron: tipoPadronAfectado === plantillaDeTramite
            ?.configuracion_de_padron.padron.id ? tipoPadronAfectado : null,
          tipoDePadronSolicitante: tipoPadronSolicitante,
          padronSolicitante,
          padron: padronAfectado,
          disabled: _disabled,
          valuesRepuve,
          setVisibleModalInfoRepuve,
          // TODO: solo pasar valuesComplementos de variables capturadas antes del paso actual
          valuesComplementos,
        };
        if (aplicaCambioDeAfectado && !_disabled) {
          output[1] = {
            ...output[1],
            fields: paso.configuracion_de_padron?.configuraciones_de_campos_de_padrones,
            tipoDeAfectacion: paso.configuracion_de_padron?.tipo_de_afectacion.id,
            valuesComplementos: null,
            padron: null,
          };
        }
      } else if (paso.tipo_de_paso === tiposDePasosEnum.DIRECCION_PRINCIPAL) {
        output[1] = {
          parentID: padronAfectado?.id || padronSolicitante?.id,
          currentURI: tipoPadronAfectado ? urlsPadronesMap[tipoPadronAfectado]
            : urlsPadronesMap[tipoPadronSolicitante],
          addressPropName: tipoPadronAfectado ? direccionPrincipalEnum[tipoPadronAfectado]
            : direccionPrincipalEnum[tipoPadronSolicitante],
          mutable: !_disabled,
          permission: addressPermission,
          form,
          valuesCallback: (values) => form.setFieldsValue(values),
          noAfectarPadron: paso.no_afectar_padron,
        };
      } else if (paso.tipo_de_paso === tiposDePasosEnum.DIRECCION_SECUNDARIA) {
        output[1] = {
          parentID: padronAfectado?.id || padronSolicitante?.id,
          currentURI: tipoPadronAfectado ? urlsPadronesMap[tipoPadronAfectado]
            : urlsPadronesMap[tipoPadronSolicitante],
          addressPropName: tipoPadronAfectado ? direccionSecundariaEnum[tipoPadronAfectado]
            : direccionSecundariaEnum[tipoPadronSolicitante],
          mutable: !_disabled,
          permission: addressPermission,
          form,
          valuesCallback: (values) => form.setFieldsValue(values),
          noAfectarPadron: paso.no_afectar_padron,
          allowCloneFrom: tipoPadronAfectado ? direccionPrincipalEnum[tipoPadronAfectado]
            : direccionPrincipalEnum[tipoPadronSolicitante],
        };
      } else if (paso.tipo_de_paso === tiposDePasosEnum.OBLIGACIONES) {
        output[1] = {
          contribuyente: padronSolicitante?.id,
          contribuyenteRFC: padronSolicitante?.rfc,
          tipoDePadron: tipoPadronAfectado,
          padron: padronAfectado,
          permission: permission.tabs[permissionObligaciones.model],
          mutable: _disabled ? false : !hasComentarioDeCapturaFinalizada,
          callback: async (record) => logWithLoading(record.message, false),
          fetchCallback: (_data) => setHasObligaciones(!!_data.count),
        };
      } else if (paso.tipo_de_paso === tiposDePasosEnum.EMPRESAS) {
        output[1] = {
          direccionFiscal: (padronAfectado || padronSolicitante)?.direcciones,
          direccionNotificacion: (padronAfectado || padronSolicitante)?.direcciones_de_notificacion,
          contribuyente: padronAfectado || padronSolicitante,
          permission: permission.tabs[permissionEmpresas.model],
          mutable: _disabled ? false : !hasComentarioDeCapturaFinalizada,
          callback: (_message) => logWithLoading(_message, false),
          fetchCallback: (_data) => setHasEmpresas(!!_data.count),
        };
      } else if (paso.tipo_de_paso === tiposDePasosEnum.PARTICIPES) {
        output[1] = {
          predio: includeJsonInfo(padronAfectado),
          mutable: _disabled ? false : !hasComentarioDeCapturaFinalizada,
          permission: permission.tabs[permissionParticipe.model],
          callback: async (_message) => logWithLoading(_message, false),
          fetchCallback: (_data, json_predio) => {
            setHasParticipes(_data.some((e) => e.es_participe_principal));
            if (json_predio) setPadronAfectado({ ...padronAfectado, json_predio });
          },
          noAfectarPadron: pasoActual.no_afectar_padron,
        };
      } else if (paso.tipo_de_paso === tiposDePasosEnum.FOTOGRAFIA) {
        const photo = _disabled
          ? getFileExpediente(tipoDeDocumentoExpedienteEnum.FOTOGRAFIA, paso.id)?.archivo
          : null;
        output[1] = {
          mutable: !_disabled,
          photo,
          disabled: _disabled,
        };
      } else if (paso.tipo_de_paso === tiposDePasosEnum.CARGA_DE_DOCUMENTO) {
        const file = _disabled
          ? getFileExpediente(tipoDeDocumentoExpedienteEnum.DOCUMENTO, pasoActual?.id)?.archivo
          : null;
        output[1] = {
          disabled: _disabled,
          file,
        };
      } else if (paso.tipo_de_paso === tiposDePasosEnum.CONSTRUCCIONES) {
        output[1] = {
          permission: permission.tabs[permissionConfigConstrucciones.model],
          mutable: !hasComentarioDeCapturaFinalizada && !_disabled,
          predio: includeJsonInfo(padronAfectado),
          onUpdatePredio: (values) => setPadronAfectado({ ...padronAfectado, ...values }),
          callback: async (_message) => logWithLoading(_message, false),
          noAfectarPadron: pasoActual.no_afectar_padron,
          fetchCallback: (_, json_predio) => {
            if (json_predio) setPadronAfectado({ ...padronAfectado, json_predio });
          },
          changePredioPermission: true,
        };
      } else if (paso.tipo_de_paso === tiposDePasosEnum.AVALUO_TERRENO) {
        output[1] = {
          permission: permission.tabs[permissionConfigTerreno.model],
          mutable: !hasComentarioDeCapturaFinalizada && !_disabled,
          predio: includeJsonInfo(padronAfectado),
          onUpdatePredio: (values) => setPadronAfectado({ ...padronAfectado, ...values }),
          fetchCallback: (_data, json_predio) => {
            setHasZonasHomogeneas(!!_data.length);
            if (json_predio) setPadronAfectado({ ...padronAfectado, json_predio });
          },
          callback: async (_message) => logWithLoading(_message, false),
          noAfectarPadron: pasoActual.no_afectar_padron,
          changePredioPermission: true,
        };
      } else if (paso.tipo_de_paso === tiposDePasosEnum.AREAS_COMUNES_DE_PREDIOS) {
        output[1] = {
          permission: permission.tabs[permissionAreasComunes.model],
          mutable: !hasComentarioDeCapturaFinalizada && !_disabled,
          predio: includeJsonInfo(padronAfectado),
          callback: async (_message) => logWithLoading(_message, false),
          noAfectarPadron: pasoActual.no_afectar_padron,
          fetchCallback: (_, json_predio) => {
            if (json_predio) setPadronAfectado({ ...padronAfectado, json_predio });
          },
        };
      } else if (paso.tipo_de_paso === tiposDePasosEnum.VALORES_REFERIDOS_DE_PREDIOS) {
        output[1] = {
          permission: permission.tabs[permissionValoresReferidos.model],
          mutable: !hasComentarioDeCapturaFinalizada && !_disabled,
          predio: includeJsonInfo(padronAfectado),
          callback: async (_message) => logWithLoading(_message, false),
          noAfectarPadron: pasoActual.no_afectar_padron,
          fetchCallback: (_, json_predio) => {
            if (json_predio) setPadronAfectado({ ...padronAfectado, json_predio });
          },
        };
      } else if (paso.tipo_de_paso === tiposDePasosEnum.COLINDANCIAS) {
        output[1] = {
          permission: permission.tabs[permissionConfigColindancias.model],
          mutable: !hasComentarioDeCapturaFinalizada && !_disabled,
          predio: includeJsonInfo(padronAfectado),
          onUpdatePredio: (values) => setPadronAfectado({ ...padronAfectado, ...values }),
          fetchCallback: (_data, json_predio) => {
            setHasColindancias(!!_data.length);
            if (json_predio) setPadronAfectado({ ...padronAfectado, json_predio });
          },
          colindancias: includeJsonInfo(padronAfectado).colindancias,
          callback: async (_message) => logWithLoading(_message, false),
          noAfectarPadron: pasoActual.no_afectar_padron,
          changePredioPermission: true,
        };
        // eslint-disable-next-line max-len
      } else if ([tiposDePasosEnum.ACTIVIDADES_ECONOMICAS, tiposDePasosEnum.ACTIVIDADES_ECONOMICAS_SAT].includes(paso.tipo_de_paso)) {
        output[1] = {
          permission: permission.tabs[
            paso.tipo_de_paso === tiposDePasosEnum.ACTIVIDADES_ECONOMICAS_SAT
              ? permissionActividadesEconomicasContribuyentes.model
              : permissionActividadesContribuyentes.model
          ],
          mutable: _disabled ? false : !hasComentarioDeCapturaFinalizada,
          callback: async (record) => logWithLoading(record.message, false),
          fetchCallback: (_data) => setHasActividades(!!_data.length),
          contribuyente: (padronAfectado || padronSolicitante)?.id,
          sat: paso.tipo_de_paso === tiposDePasosEnum.ACTIVIDADES_ECONOMICAS_SAT,
        };
      } else if (paso.tipo_de_paso === tiposDePasosEnum.CONTRIBUYENTES_VINCULADOS) {
        output[1] = {
          permission: permission.tabs[permissionContribuyentesVinculados.model],
          mutable: _disabled ? false : !hasComentarioDeCapturaFinalizada,
          callback: async (record) => logWithLoading(record.message, false),
          contribuyente: padronAfectado?.id,
        };
      } else if (paso.tipo_de_paso === tiposDePasosEnum.VISTA_PADRON) {
        output[1] = {
          fields: paso.configuracion_de_padron.configuraciones_de_campos_de_padrones,
          tipoDeAfectacion: afectacionesEnum.CONSULTA,
          plantillaDeTramite,
          setLoading,
          tipoDePadron: tipoPadronAfectado,
          padron: padronAfectado,
          tipoDePadronSolicitante: tipoPadronSolicitante,
          disabled: true,
        };
      } else if (paso.tipo_de_paso === tiposDePasosEnum.CITA) {
        output[1] = !citaPaso ? {
          plantilla: plantillaDeTramite?.id,
          setLoading,
        } : {
          cita: citaPaso,
          plantilla: plantillaDeTramite?.id,
        };
      } else if (paso.tipo_de_paso === tiposDePasosEnum.ASIGNACION_CONSTANCIA) {
        output[1] = {
          tramite,
          disabled: _disabled,
          constancia: tramite?.constancia_de_inscripcion,
          callback: async (constanciaId) => {
            await logWithLoading('Constancia de inscripción asignada', true);
            setTramite({ ...tramite, constancia_de_inscripcion: constanciaId });
          },
          sendMessage,
          lastMessage: _lastMessage,
          readyState,
          vehiculo: padronAfectado,
        };
      } else if (paso.tipo_de_paso === tiposDePasosEnum.SINCRONIZACION_DE_DATOS_FINANZAS) {
        output[1] = {
          disabled: _disabled,
          historialDePlacas: (tramite?.historial_vehicular
            ? JSON.parse(tramite?.historial_vehicular) : padronAfectado).historial_de_placas || [],
        };
      } else if (paso.tipo_de_paso === tiposDePasosEnum.SUBDIVISION) {
        output[1] = {
          disabled: _disabled,
          tramites,
          cantidad: tramite.numero_a_subdividir,
          cantidadMaxima: paso.numero_max_a_subdividir,
          requierePreguntarHeredarCampos: paso.requiere_preguntar_geredar_campos,
          cargaExcel: paso.es_subdivision_disolucion,
          // numExpediente: complementos[0]?.valor,
          basesGravablesJson: tramite?.bases_gravables_json,
          observaciones_subdivision: includeJsonInfo(padronAfectado)?.observaciones_subdivision,
          observaciones_cancelacion: includeJsonInfo(padronAfectado)?.observaciones_cancelacion,
          aplicaObservacionCancelacion: paso.aplica_observaciones_cancelacion,
          predio: includeJsonInfo(padronAfectado),
        };
      } else if (paso.tipo_de_paso === tiposDePasosEnum.FUSION) {
        output[1] = {
          disabled: _disabled,
          cantidad: tramite.numero_a_subdividir,
          cantidadMaxima: paso.maximo_a_fusionar,
          prediosTramite: tramite.predios_relacionados,
          prediosRelacionados,
          predio: padronAfectado,
        };
      } else if (paso.tipo_de_paso === tiposDePasosEnum.ALERTAS) {
        output[1] = {
          disabled: _disabled,
          padron: padronAfectado || padronSolicitante,
          permission: permission.tabs[permissionAlertas.model],
          tipoDePadron: tipoPadronAfectado || tipoPadronSolicitante,
          callback: async (_message) => logWithLoading(_message, false),
          tramite,
        };
      } else {
        output[1] = {
          children: 'Componente para paso no definido',
        };
      }
      return output;
    }) || []),
  };

  const CurrentStepComponent = useMemo(() => stepComponents[currentStep] || React.Fragment,
    [currentStep, tipoPadronSolicitante, padronSolicitante, padronAfectado, casoDeRequisitos,
      selectedKeysTiposCargos, periodosSeleccionados, cargosTramite, complementos, tramite, citas]);

  const afectadoToVariables = (_variables = []) => {
    if (!padronAfectado) return null;
    const entries = Object.entries(padronAfectado);
    const filtered = entries.filter(([k]) => _variables.some((v) => v.nombre_de_variable === k));
    return Object.fromEntries(filtered);
  };

  const setStepValues = () => {
    const valuesForStepMap = {
      [stepsEnum.PADRON_SOLICITANTE]: {
        tipo_de_padron_solicitante: tipoPadronSolicitante || padronesSolicitantes[0]?.id,
        object_id_solicitante: padronSolicitante?.id,
      },
      [stepsEnum.PADRON_AFECTADO]: {
        tipo_de_padron_afectado: tipoPadronAfectado,
        object_id_afectado: padronAfectado?.id,
      },
    };
    const stepChanged = prevStepRef.current !== currentStep;
    prevStepRef.current = currentStep;
    if (stepChanged) {
      form.resetFields();
    }
    form.setFieldsValue(valuesForStepMap[currentStep]);
    if (currentStep === stepsEnum.PADRON_SOLICITANTE) {
      setTipoPadronSolicitante(valuesForStepMap[currentStep].tipo_de_padron_solicitante);
    }
    const _padrones = [
      padronesEnum.HOSPEDAJE,
      padronesEnum.ARRENDAMIENTO,
      padronesEnum.NOMINA,
      padronesEnum.CEDULAR,
      padronesEnum.ALCOHOL,
      padronesEnum.JUEGO_DE_AZAR,
      padronesEnum.NOTARIO,
      padronesEnum.AGENCIA,
      padronesEnum.CASA_DE_EMPENIO,
      padronesEnum.RETENEDOR_DE_NOMINA,
      padronesEnum.RETENEDOR_DE_CEDULA,
      padronesEnum.VENDEDOR_DE_ALCOHOLES,
    ];
    if (currentStep === stepsEnum.PADRON_AFECTADO && tipoDeAfectacion === afectacionesEnum.ALTA
      && _padrones.includes(tipoPadronAfectado)) {
      form.setFieldsValue({ descripcion: `IMPUESTO ${labelTipoDePadronAfectado.toUpperCase()}` });
    }
    if (!pasoActual) return;
    if (pasoActual.tipo_de_paso === tiposDePasosEnum.ALTA_AFECTADO
      && _padrones.includes(tipoPadronAfectado)) {
      form.setFieldsValue({ descripcion: `IMPUESTO ${labelTipoDePadronAfectado.toUpperCase()}` });
    }
    if (pasoActual.tipo_de_paso === tiposDePasosEnum.MODIFICACION_SOLICITANTE) {
      form.setFieldsValue(padronSolicitante);
    }
    if (pasoActual.tipo_de_paso === tiposDePasosEnum.VARIABLES) {
      const afectadoComplementos = afectadoToVariables(catalogoDeVariables
        .filter((v) => pasoActual.variables.includes(v.id)));
      form.setFieldsValue({ ...afectadoComplementos, ...valuesComplementos });
    }
    if (pasoActual.tipo_de_paso === tiposDePasosEnum.CARGOS) {
      setTimeout(() => form.setFieldsValue(valuesVariablesCargos));
    }
    if (pasoActual.tipo_de_paso === tiposDePasosEnum.CITA) {
      form.setFieldsValue({ plantilla: plantillaDeTramite.id });
    }
    if (pasoActual.tipo_de_paso === tiposDePasosEnum.SINCRONIZACION_DE_DATOS_FINANZAS) {
      form.setFieldsValue({ placa_manual: false });
    }
    if (pasoActual.tipo_de_paso === tiposDePasosEnum.EMISION_DE_DOCUMENTO
      && pasoActual.aplica_observaciones_cancelacion) {
      form.setFieldsValue({ observaciones: tramite.bases_gravables_json });
    }
  };

  useEffect(() => { setStepValues(); }, [
    currentStep, padronSolicitante, padronAfectado, tramite, complementos,
  ]);

  const saveGIS = async () => {
    if (!loading) {
      setLoading(true);
    }
    const _base64 = form.getFieldValue('base64');
    const file = await dataUrlToFile(_base64, 'GIS');
    const values = {
      tipo_de_documento_para_expediente: tipoDeDocumentoExpedienteEnum.GIS,
      archivo: { file, name: 'GIS.png' },
    };
    const [savedFile, _log] = await saveFile(null, values);
    if (!_log || !savedFile) {
      message.info('Intentelo de nuevo');
    }
    setLoading(false);
  };

  useEffect(() => {
    setTimeout(() => form.setFieldsValue(valuesVariablesCargos));
  }, [selectedKeysTiposCargos]);

  // auto guardado de captura de gis
  useEffect(() => {
    if (validateGISInfo && !!tramite?.attrs && currentStep === stepsEnum.PADRON_AFECTADO
      && !getFileExpediente(tipoDeDocumentoExpedienteEnum.GIS) && base64GIS) {
      saveGIS();
    }
  }, [currentStep, tramite, base64GIS]);

  const resetLastMessage = () => {
    if (typeof currentStep === 'number' && pasoActual.tipo_de_paso === tiposDePasosEnum.ASIGNACION_CONSTANCIA) {
      setLastMessage(undefined);
    }
  };

  const resetCargosSaldados = () => (currentStep === stepsEnum.GENERAR_CARGOS
    || pasoActual?.tipo_de_paso === tiposDePasosEnum.CARGOS) && setCargosSaldados(false);

  const nextStep = () => {
    let idx = stepsTimelineItems.findIndex((e) => e.key === currentStep);
    let next = stepsTimelineItems[idx + 1]?.key;
    if (tramite?.estados_globales === 4) {
      setCurrentStep(next);
      return;
    }
    if (typeof next === 'number' && typeof currentStep === 'number') {
      // eslint-disable-next-line no-loop-func
      while (next && !historial.find((h) => h.paso_a_mandar === next)) {
        idx += 1;
        next = stepsTimelineItems[idx]?.key;
      }
    }
    if (lastLog && currentStep === lastLog.paso && lastLog.paso_a_mandar !== currentStep
      && !pasosVerificados.includes(next)) {
      setCurrentStep(lastLog?.paso_a_mandar);
      resetCargosSaldados();
      return;
    }
    if (next) {
      resetLastMessage();
      setCurrentStep(next);
      resetCargosSaldados();
    }
  };

  const getMovRepuve = (_consultaRepuve) => {
    if (REPUVE && tipoPadronAfectado === padronesEnum.VEHICULO) {
      if (altaEnPaso) {
        // SI se encontro vehiculo
        if (_consultaRepuve) return 'actualizacion';
        // NO se encontro vehiculo
        if (_consultaRepuve === false) return 'inscripcion';
        // fallo consulta, volver a realizarla antes de impactar datos
        if (_consultaRepuve === null) return '';
      } else {
        // NO se encontro vehiculo
        if (_consultaRepuve === false) return 'inscripcion';
        // fallo consulta, volver a realizarla antes de impactar datos
        if (_consultaRepuve === null) return '';
        // se encontro vehiculo y no hay reporte de robo
        return 'actualizacion';
      }
    }
    return '';
  };

  const iniciarTramite = async (_padronAfectado = padronAfectado) => {
    setLoading(true);
    const _tipoSolicitante = padronSolicitante ? tipoPadronSolicitante : tipoPadronAfectado;
    const values = {
      plantilla: plantillaDeTramite.id,
      tipo_padron_id: tipoPadronAfectado,
      solicitante_ciudadano: _tipoSolicitante === solicitantesEnum.CIUDADANO,
      [_tipoSolicitante === solicitantesEnum.CIUDADANO ? 'ciudadano' : 'contribuyente']: (padronSolicitante || _padronAfectado).id,
      tipos_de_registros_de_tramite: 1,
      estados_globales: 2,
      fecha_de_inicio: toMoment(new Date()).format(DATE_FORMAT),
      procedencia: procedenciasEnum.GPM,
      es_repuve: REPUVE,
      recibos_del_tramite: foliosRecibos.join(','),
      bloquear_adeudos: plantillaDeTramite.bloquear_adeudos,
      aplica_avaluo: plantillaDeTramite.aplica_avaluo,
    };
    if (_padronAfectado) {
      values.content_type_a_padron = getContenTypePorTipoDePadron(tipoPadronAfectado);
      values.object_id_padron = _padronAfectado?.id;
    }
    if (esConsultaDeAdeudo) {
      values.cargos = cargosTramite.map((c) => c.id);
    }
    if (plantillaDeTramite.casos.length === 1) {
      values.caso = plantillaDeTramite.casos[0].id;
    }
    values.mov_repuve = getMovRepuve(valuesRepuve);
    const _tramite = await postTramite(values, { clave: _padronAfectado?.clave });
    if (_tramite) {
      if (pasosDelTramite.some((p) => p.no_afectar_padron) && _padronAfectado) {
        const json_predio = JSON
          .stringify(formatValues(removeIndexes(_padronAfectado), { clean: false }));
        await patchPadronesMap[tipoPadronAfectado](_padronAfectado.id, { json_predio });
      }
      if (citaParam) await patchCita(citaParam, { tramite: _tramite.id });
      message.info('Trámite generado correctamente');
      setTimeout(() => onFinishSearchTramite({ id: _tramite.id }));
    }
    setLoading(false);
  };

  const saveCargos = async () => {
    const _cargos = selectedKeysTiposCargos.filter((e) => e !== tipoCargoTotalizado?.id)
      .map((t) => tiposDeCargosToValuesGenerarCargos(t));
    if (!_cargos.length) return false;
    setLoading(true);
    await checkToken();
    const promises = _cargos.map((e) => postGenerarCargos(e));
    const responses = _cargos.length ? await Promise.all(promises) : [];
    const cargos = responses.flat(2);
    if (cargos.length) {
      let [, _cargosTramite] = await _getCargos(true);
      _cargosTramite = await generarCargoTotalizado(_cargosTramite);
      setCargosTramite(_cargosTramite);
      setSelectedKeysTiposCargos(selectedKeysTiposCargos
        .filter((tc) => !_cargosTramite.some((c) => c.tipo_de_cargo.id === tc)));
      message.info('Cargos generados correctamente');
      base64Ref.current[srcPaymentOrder] = null;
      cargosTramiteTextRef.current?.scrollIntoView({ block: 'center', behavior: 'smooth' });
      if (pasoActual) {
        await postLog(`Cargos generados por funcionario: (${listToString(_cargosTramite
          .map((c) => c.id.toString()))})`, false);
      }
    }
    setLoading(false);
    return false;
  };

  const extraPropsAltaPadron = {
    [padronesEnum.VEHICULO]: {
      es_propietario_ciudadano: tipoPadronSolicitante === solicitantesEnum.CIUDADANO,
      [tipoPadronSolicitante === solicitantesEnum.CIUDADANO
        ? 'propietario' : 'contribuyente_propietario']: padronSolicitante?.id,
    },
    [padronesEnum.MOTOCICLETA]: {
      es_propietario_ciudadano: tipoPadronSolicitante === solicitantesEnum.CIUDADANO,
      [tipoPadronSolicitante === solicitantesEnum.CIUDADANO
        ? 'propietario' : 'contribuyente_propietario']: padronSolicitante?.id,
    },
    [padronesEnum.REMOLQUE]: {
      es_propietario_ciudadano: tipoPadronSolicitante === solicitantesEnum.CIUDADANO,
      [tipoPadronSolicitante === solicitantesEnum.CIUDADANO
        ? 'ciudadano_propietario' : 'contribuyente_propietario']: padronSolicitante?.id,
    },
    [padronesEnum.PREDIO]: {
      [tipoPadronSolicitante === solicitantesEnum.CIUDADANO
        ? 'ciudadano' : 'contribuyente']: padronSolicitante?.id,
    },
    [padronesEnum.CONTRIBUYENTE]: {
      estado_del_padron: 1, // Ingresado,
    },
    [padronesEnum.EXPEDIENTE_LICENCIA_FUNCIONAMIENTO]: {
      estado_del_padron: 1, // Ingresado,
    },
  };

  const createPlaca = async (_padronAfectado = padronAfectado) => {
    if (padronAfectado) setLoading(true);
    const placa = await postPlaca({
      numero_de_placa: _padronAfectado.numero_de_placa_vigente,
      fecha_expedicion_placa: _padronAfectado.fecha_expedicion_placa,
      contribuyente_propietario: _padronAfectado.contribuyente_propietario.id,
      estado_de_la_placa: 1, // activo
      vehiculo: _padronAfectado.id,
      tramite: tramite?.id,
    });
    if (placa && padronAfectado) {
      setTimeout(() => setPadronAfectado({
        ...padronAfectado,
        historial_de_placas: (padronAfectado.historial_de_placas || []).concat(placa),
      }));
    }
    if (padronAfectado) setLoading(false);
  };

  const postPadron = async () => {
    setLoading(true);
    const { valuesRepuve: _valuesRepuve, ...values } = {
      ...extraPropsAltaPadron[tipoPadronAfectado],
      estados_globales: ESTADOS_GLOBALES_MAP.EN_PROCESO,
      ...form.getFieldsValue(),
    };
    let _padronAfectado = await postPadronesMap[tipoPadronAfectado](values);
    if (_padronAfectado) {
      if (tipoPadronAfectado === padronesEnum.VEHICULO && values.numero_de_placa_vigente
        && values.fecha_expedicion_placa) {
        await createPlaca(_padronAfectado);
      }
      if (pasoActual) {
        const valuesPatchTramite = {
          content_type_a_padron: getContenTypePorTipoDePadron(tipoPadronAfectado),
          object_id_padron: _padronAfectado.id,
        };
        valuesPatchTramite.mov_repuve = getMovRepuve(_valuesRepuve);
        const _tramite = await patchTramite(tramite.id, valuesPatchTramite);
        setTramite(_tramite);
      }
      if (aplicaCambioDeAfectado) {
        // cancela predio inicial
        await patchPadronesMap[tipoPadronAfectado](padronAfectado.id, { estados_globales: 5 });
      }
      _padronAfectado = await searchPadron(_padronAfectado.id, tipoPadronAfectado);
      setPadronAfectado(_padronAfectado);
      const padronAsString = padronToString(
        includeJsonInfo(padronAfectado),
        tipoPadronAfectado,
        true,
        false,
      );
      message.info(`${labelTipoDePadronAfectado} registrado correctamente`);
      await postLog(`${padronAsString} agregado`, true);
      if (!pasoActual || !tramite) {
        await iniciarTramite(_padronAfectado);
      }
    }
    setLoading(false);
  };

  const affectPrediosFusion = async () => {
    const promises = prediosRelacionados.map((p) => {
      if (p.estados_globales === ESTADOS_GLOBALES_MAP.CANCELADO) {
        return { ...p, justAffected: false }; // ya afectado
      }
      const values = formatReceived(p.json_predio);
      values.json_predio = '';
      return patchPredio(p.id, values);
    });
    const responses = await Promise.all(promises);
    const allAfected = responses.every((r) => r);
    setPrediosRelacionados(prediosRelacionados.map((p, i) => responses[i] || p));
    if (responses.some((r) => r?.justAffected)) {
      const _predios = listToString(responses.filter((e) => e?.justAffected).map((e) => e.clave)) || 'Ninguno';
      await postLog(`Predios relacionados modificados correctamente (${_predios})`, allAfected);
    }
    return allAfected;
  };

  const patchAfectado = async (soloPropietario, _values = form.getFieldsValue(), isTempInfo) => {
    setLoading(true);
    let values = soloPropietario ? _values.valuesCambio : { ..._values };
    let folio_trm_repuve;
    if (TLAJOMULCO && values.valor_catastral_calculado && !isTempInfo) {
      [folio_trm_repuve, values.valor_catastral_calculado] = values.valor_catastral_calculado.split('_');
    }
    if (pasoActual?.no_afectar_padron) {
      let json_predio = padronAfectado.json_predio
        ? padronAfectado.json_predio : removeIndexes(padronAfectado);
      const deletableKeys = deletableKeysPadronesMap[tipoPadronAfectado] || [];
      json_predio = { ...json_predio, ...values };
      json_predio = JSON.stringify(formatValues(json_predio, { deletableKeys }, dateKeysPredio));
      values = { json_predio };
    }
    if (isTempInfo) {
      // predio ya fue afectado, falta afectar predios relacionados
      if (!padronAfectado.json_predio && hasFusionStep) {
        const allAfected = await affectPrediosFusion();
        if (!allAfected) {
          setLoading(false);
          return;
        }
      }
      const addressPropName = direccionPrincipalEnum[tipoPadronAfectado];
      const altAddressPropName = direccionSecundariaEnum[tipoPadronAfectado];
      if (values[addressPropName]) {
        values[addressPropName] = formatValues(values[addressPropName], { clean: false });
      }
      if (values[altAddressPropName]) {
        values[altAddressPropName] = formatValues(values[altAddressPropName], { clean: false });
      }
      if (tipoPadronAfectado === padronesEnum.PREDIO) {
        const keysAfectaciones = ['participes', 'zonas_homogeneas_de_predios',
          'construcciones', 'colindancias', 'meritos_demeritos_de_predios',
          'bloques_de_construccion', 'bloques_de_terreno', 'areas_comunes_de_predios',
          'valores_referidos_de_predios'];
        values.tramite = null;

        const saved = await aplicarAfectacionesPredio(values);
        if (!saved) {
          setLoading(false);
          return;
        }
        keysAfectaciones.forEach((key) => {
          delete values[key];
          delete values[`${key}_a_eliminar`];
          delete values[`${key}_a_agregar`];
          delete values[`${key}_a_modificar`];
          delete values[`${key}_principal_anterior`.replace(/s_/, '_')];
        });

        values.cleanJson = true;
        values.clean = false;
      }
    }
    const _padron = await patchPadronesMap[tipoPadronAfectado](padronAfectado.id, values);
    if (!_padron) {
      setLoading(false);
      return;
    }
    if (folio_trm_repuve) {
      const _tramite = await patchTramite(tramite.id, { folio_trm_repuve });
      if (!_tramite?.folio_trm_repuve) {
        setLoading(false);
        return;
      }
    }
    const padronAsString = padronToString(
      includeJsonInfo(padronAfectado),
      tipoPadronAfectado,
      true,
      false,
    );
    const _padronAfectado = await searchPadron(_padron.id, tipoPadronAfectado);
    setPadronAfectado(_padronAfectado);
    if (isTempInfo) {
      if (hasFusionStep) {
        const allAfected = await affectPrediosFusion();
        await postLog(`${padronAsString} modificado con datos en json temporal`, !!allAfected);
        if (updateCartera) setTimeout(() => confirmUpdateCartera());
        message.info(`${padronAsString} actualizado correctamente`);
        setLoading(false);
        return;
      }
      await postLog(`${padronAsString} modificado con datos en json temporal`, true);
      if (updateCartera) setTimeout(() => confirmUpdateCartera());
    } else {
      if (pasoActual.tipo_de_paso === tiposDePasosEnum.CAMBIO_DE_PROPIETARIO) {
        await postLog(`Propietario de ${padronAsString} modificado`, true);
      } else {
        await postLog(`${padronAsString} modificado`, true);
      }
      message.info(`${padronAsString} actualizado correctamente`);
    }
    if (folio_trm_repuve) setTramite({ ...tramite, folio_trm_repuve });
    setLoading(false);
  };

  const patchSolicitante = async (_values) => {
    setLoading(true);
    const values = _values || form.getFieldsValue();
    const _padron = await patchPadronesMap[tipoPadronSolicitante](padronSolicitante.id, values);
    if (_padron) {
      const padronAsString = padronToString(padronSolicitante, tipoPadronSolicitante, true);
      await postLog(`${padronAsString} modificado`, true);
      setPadronSolicitante(_padron);
      message.info(`${padronAsString} actualizado correctamente`);
    }
    setLoading(false);
  };

  const saveVariablesTramite = async () => {
    setLoading(true);
    const values = form.getFieldsValue();
    const variablesData = valuesToVariablesComplementos(
      values,
      plantillaDeTramite.variables,
      catalogoDeVariables,
      tramite.id,
    );
    const variablesToPost = variablesData
      .filter((vd) => !complementos.some((vt) => vt.variable === vd.variable));
    const responses = await Promise.all(variablesToPost.map((vd) => postComplementoDeTramite(vd)));
    const complementosGuardados = responses.filter((r) => r);
    setComplementos([...complementos, ...complementosGuardados]);
    setLoading(false);
  };

  const saveVariablesPaso = async () => {
    setLoading(true);
    const values = form.getFieldsValue();
    const variablesData = valuesToVariablesComplementos(
      values,
      pasoActual.variables,
      catalogoDeVariables,
      tramite.id,
    );
    const variablesToPost = variablesData
      .filter((vd) => !complementos.some((vt) => vt.variable === vd.variable));
    const variablesToPatch = variablesData.map((vd) => {
      const match = complementos.find((vt) => vt.variable === vd.variable);
      if (match) {
        return { ...vd, id: match.id };
      }
      return null;
    }).filter((vd) => vd);
    const responses = await Promise.all([
      ...variablesToPost.map((vd) => postComplementoDeTramite(vd)),
      ...variablesToPatch.map(({ id, ...vd }) => patchComplementoDeTramite(id, vd)),
    ]);
    const complementosGuardados = responses.filter((r) => r);
    if (complementosGuardados.length) {
      const variablesAsString = listToString(complementosGuardados
        .map((cv) => catalogoDeVariables.find((v) => v.id === cv.variable).nombre_de_variable));
      await postLog(`Variables capturadas: ${variablesAsString}`, responses.every((r) => r));
    } else if (pasoActual.tiene_tablas) {
      await postLog('Variables capturadas', true);
    }
    setComplementos([
      ...complementos.filter((c) => !complementosGuardados.some((_c) => c.d === _c.id)),
      ...complementosGuardados,
    ]);
    setLoading(false);
  };

  const esPasoDocumento = [
    tiposDePasosEnum.EMISION_DE_DOCUMENTO,
    tiposDePasosEnum.CARGA_DE_DOCUMENTO,
  ].includes(pasoActual?.tipo_de_paso);

  const finishTramite = async () => {
    setLoading(true);
    const valuesTramite = {
      estados_globales: 4, // Autorizado
      expediente_de_tramite: getFileExpediente(
        tipoDeDocumentoExpedienteEnum.DOCUMENTO,
        pasoActual?.id,
      )?.id,
    };
    if (tramite.bloquear_adeudos) {
      valuesTramite.bloquear_adeudos = false;
    }
    if (REPUVE && tipoPadronAfectado === padronesEnum.VEHICULO) {
      valuesTramite.estatus_repuve = estatusEnvioWs.PENDIENTE; // pendiente de envio
    }
    if (esPasoDocumento && !pasoActual.no_enviar_correo && !valuesTramite.expediente_de_tramite) {
      message.warn('No se ha podido finalizar el trámite, verifique la información');
      return;
    }
    if (pasoActual?.no_enviar_correo) delete valuesTramite.expediente_de_tramite;
    const saved = await patchTramite(tramite.id, valuesTramite);
    if (saved) {
      const { aplica_cambio_de_estado_padron } = plantillaDeTramite;
      const useTempInfo = padronAfectado && hasWritingJsonStep && !hasImpactJsonStep;
      let values = useTempInfo ? formatReceived(padronAfectado.json_predio) : null;
      if (aplica_cambio_de_estado_padron && tipoDeAfectacion === afectacionesEnum.BAJA) {
        values = { estados_globales: 5 }; // cancelado
      } else if (aplica_cambio_de_estado_padron || tipoDeAfectacion === afectacionesEnum.ALTA) {
        values = values || {};
        if (tipoDeAfectacion === afectacionesEnum.ALTA || aplica_cambio_de_estado_padron) {
          values.estados_globales = 1; // Activo
        }
        if ([padronesEnum.CONTRIBUYENTE, padronesEnum.EXPEDIENTE_LICENCIA_FUNCIONAMIENTO]
          .includes(tipoPadronAfectado) || aplica_cambio_de_estado_padron) {
          values.estado_del_padron = 2; // Activo
        }
      }
      if (plantillaDeTramite.id === 1) {
        values = values || {};
        values.folio_traslado = tramite.folio;
      }
      if (plantillaDeTramite.aplica_avaluo) {
        values = values || {};
        values.numero_de_avaluo = `${tramite.folio} - ${toMoment(new Date()).format(DATETIME_FRONTEND_FORMAT)}`;
      }
      if (values) {
        if (padronAfectado) {
          await patchAfectado(
            false,
            useTempInfo
              ? removeIndexes({ ...formatReceived(padronAfectado.json_predio), ...values })
              : values,
            useTempInfo,
          );
        } else {
          await patchSolicitante(values);
        }
      }
      await postLog('Trámite finalizado');
      message.success('Trámite finalizado con éxito');
      if (tipoPadronAfectado === padronesEnum.VEHICULO && realizarEnvioWS) {
        await postEnviarInformacionWS(tramite.id, 'Falló envío de información a base de datos nacional');
      }
      setTramite({ ...tramite, ...saved });
    }
    setLoading(false);
    setVisibleConfirmFinish(false);
  };

  const prevStep = (_currentStep = currentStep) => {
    const currIdx = stepsTimelineItems.findIndex((e) => e.key === _currentStep);
    const prevInTimeline = stepsTimelineItems[currIdx - 1];
    const prev = prevInTimeline?.key;
    if (prev) {
      if (typeof prev === 'number' && !historial.some((h) => h.paso === prev)) {
        prevStep(prev);
      } else {
        setCurrentStep(prev);
      }
      resetLastMessage();
    }
  };

  const canContinue = (_currentStep = currentStep) => {
    if (tramite?.estados_globales === 4) return true;
    if (pasosVerificados.includes(_currentStep)) return true;
    if (typeof currentStep === 'string') {
      if (_currentStep === stepsEnum.PADRON_SOLICITANTE) {
        if (tipoPadronAfectado && !altaEnPaso) {
          return !!padronSolicitante && !hasAlertasRestrictivas;
        }
        return !!tramite;
      }
      if (_currentStep === stepsEnum.PADRON_AFECTADO) {
        if (!tramite) return false;
        return !validateGISInfo || getFileExpediente(tipoDeDocumentoExpedienteEnum.GIS);
      }
      if (_currentStep === stepsEnum.REQUISITOS_GENERALES) {
        return requisitosStatusContinue.includes(statusRequisitos.generales)
          || pasosVerificados.includes(stepsEnum.REQUISITOS_GENERALES);
      }
      if (_currentStep === stepsEnum.CASOS_DE_REQUISITOS) {
        return !!casoDeRequisitos || pasosVerificados.includes(stepsEnum.REQUISITOS_DEL_CASO);
      }
      if (_currentStep === stepsEnum.REQUISITOS_DEL_CASO) {
        return requisitosStatusContinue.includes(statusRequisitos.caso)
          || pasosVerificados.includes(stepsEnum.REQUISITOS_GENERALES);
      }
      if (_currentStep === stepsEnum.VARIABLES) {
        return tramiteHasAllVariables || pasosVerificados.includes(stepsEnum.VARIABLES);
      }
      if (_currentStep === stepsEnum.GENERAR_CARGOS) {
        return cargosSaldados;
      }
      return false;
    }
    if (pasoActual) {
      if (pasoActual.tipo_de_paso === tiposDePasosEnum.ALTA_AFECTADO
        && tipoPadronAfectado === padronesEnum.VEHICULO && !hasPlaca) return false;
      if (pasoActual.tipo_de_paso === tiposDePasosEnum.CITA) return citaEnProcesoOFinalizada;
      if (pasoActual.tipo_de_paso === tiposDePasosEnum.REQUISITOS
        && requisitosStatusContinue.includes(statusRequisitos[`paso_${pasoActual.id}`])) return true;
      const hasLog = existingValidLogForStep(pasoActual.id);
      if (!hasLog) return false;
      if (tramite?.procedencia === procedenciasEnum.LAYOUT && hasLog) return true;
      const canContinueMap = {
        [tiposDePasosEnum.EMISION_DE_DOCUMENTO]: getFileExpediente(
          tipoDeDocumentoExpedienteEnum.DOCUMENTO,
          pasoActual.id,
        ),
        [tiposDePasosEnum.FIRMA_ELECTRONICA]: pasoActualHasFirma,
        [tiposDePasosEnum.GIS]: getFileExpediente(tipoDeDocumentoExpedienteEnum.GIS),
        [tiposDePasosEnum.CARGOS]: cargosSaldados,
        [tiposDePasosEnum.ALTA_AFECTADO]: padronAfectado,
        [tiposDePasosEnum.OBLIGACIONES]: hasComentarioDeCapturaFinalizada,
        [tiposDePasosEnum.EMPRESAS]: hasComentarioDeCapturaFinalizada,
        [tiposDePasosEnum.PARTICIPES]: hasComentarioDeCapturaFinalizada,
        [tiposDePasosEnum.FOTOGRAFIA]: getFileExpediente(
          tipoDeDocumentoExpedienteEnum.FOTOGRAFIA,
          pasoActual.id,
        ),
        [tiposDePasosEnum.CONSTRUCCIONES]: hasComentarioDeCapturaFinalizada,
        [tiposDePasosEnum.AREAS_COMUNES_DE_PREDIOS]: hasComentarioDeCapturaFinalizada,
        [tiposDePasosEnum.VALORES_REFERIDOS_DE_PREDIOS]: hasComentarioDeCapturaFinalizada,
        [tiposDePasosEnum.AVALUO_TERRENO]: hasComentarioDeCapturaFinalizada,
        [tiposDePasosEnum.COLINDANCIAS]: hasComentarioDeCapturaFinalizada,
        [tiposDePasosEnum.ACTIVIDADES_ECONOMICAS]: hasComentarioDeCapturaFinalizada,
        [tiposDePasosEnum.ACTIVIDADES_ECONOMICAS_SAT]: hasComentarioDeCapturaFinalizada,
        [tiposDePasosEnum.CONTRIBUYENTES_VINCULADOS]: hasComentarioDeCapturaFinalizada,
        [tiposDePasosEnum.CITA]: [2, 4].includes(citaPaso?.estado_de_cita), // proceso, finalizada
      };
      return pasoActual.tipo_de_paso in canContinueMap
        ? !!canContinueMap[pasoActual.tipo_de_paso] : true;
    }
    return false;
  };

  const patchFlujoInicialConcluido = async () => {
    setLoading(true);
    refPatch.current = true;
    const _tramite = await patchTramite(tramite.id, { flujo_inicial_concluido: true });
    if (_tramite) {
      message.destroy();
      setTramite({ ...tramite, ..._tramite });
    }
    refPatch.current = false;
    setLoading(false);
  };

  useEffect(() => {
    const idx = stepsTimelineItems.findIndex((e) => e.key === currentStep);
    const _nextStep = stepsTimelineItems[idx + 1]?.key;
    if (tramiteEnProceso && !loading && canContinue() && typeof _nextStep === 'number'
      && !tramite.flujo_inicial_concluido && !refPatch.current) {
      patchFlujoInicialConcluido();
    }
  }, [canContinue(), loading]);

  const getButtonLabel = () => {
    if (!plantillaDeTramite) return saveLabelEnum.NOT_SUPPORTED;

    if (typeof currentStep === 'string') {
      if (currentStep === stepsEnum.PADRON_SOLICITANTE) {
        if (tramite) return saveLabelEnum.CONTINUE;
        if (padronSolicitante && (!tipoPadronAfectado || altaEnPaso) && permission.add) {
          if (!esConsultaDeAdeudo) return saveLabelEnum.START_TRAMITE;
          if ((permiteGenerarSinAdeudo && !noIniciarConAdeudo && !cargosTramite.length)
            || (!permiteGenerarSinAdeudo && !noIniciarConAdeudo && cargosTramite.length)
            || (noIniciarConAdeudo && !cargosTramite.length)) {
            return saveLabelEnum.START_TRAMITE;
          }
        }
        return saveLabelEnum.NOT_SUPPORTED;
      }
      if (currentStep === stepsEnum.PADRON_AFECTADO) {
        if (tramite) {
          return !validateGISInfo || getFileExpediente(tipoDeDocumentoExpedienteEnum.GIS)
            ? saveLabelEnum.CONTINUE : saveLabelEnum.NOT_SUPPORTED;
        }
        if (valuesRepuve?.Error_descripcion || valuesRepuve?.reporteRobo) {
          return saveLabelEnum.NOT_SUPPORTED;
        }
        if (tipoDeAfectacion === afectacionesEnum.ALTA) {
          if (permission.add) return saveLabelEnum.SAVE;
          if (padronAfectado) return saveLabelEnum.CONTINUE;
        }
        if (padronAfectado) {
          if (validateGISInfo && !hasGISInfo) return saveLabelEnum.NOT_SUPPORTED;
          if (!esConsultaDeAdeudo && !esConsultaDeRecibos) return saveLabelEnum.START_TRAMITE;
          if (esConsultaDeRecibos && foliosRecibos.length) return saveLabelEnum.START_TRAMITE;
          if ((permiteGenerarSinAdeudo && !noIniciarConAdeudo && !cargosTramite.length)
            || (!permiteGenerarSinAdeudo && !noIniciarConAdeudo && cargosTramite.length)
            || (noIniciarConAdeudo && !cargosTramite.length)) {
            return saveLabelEnum.START_TRAMITE;
          }
        }
        return saveLabelEnum.NOT_SUPPORTED;
      }
      if (currentStep === stepsEnum.REQUISITOS_GENERALES) {
        if (requisitosStatusContinue.includes(statusRequisitos.generales)) {
          return saveLabelEnum.CONTINUE;
        }
        if (requisitosStatusAuthorize.includes(statusRequisitos.generales)
          && permission.tabs[permissionRequisitos.model].authorize) {
          return saveLabelEnum.AUTHORIZE;
        }
      }
      if (currentStep === stepsEnum.CASOS_DE_REQUISITOS) {
        return casoDeRequisitos ? saveLabelEnum.CONTINUE : saveLabelEnum.NOT_SUPPORTED;
      }
      if (currentStep === stepsEnum.REQUISITOS_DEL_CASO) {
        if (requisitosStatusContinue.includes(statusRequisitos.caso)) {
          return saveLabelEnum.CONTINUE;
        }
        if (requisitosStatusAuthorize.includes(statusRequisitos.caso)
          && permission.tabs[permissionRequisitos.model].authorize) {
          return saveLabelEnum.AUTHORIZE;
        }
        return saveLabelEnum.NOT_SUPPORTED;
      }
      if (currentStep === stepsEnum.VARIABLES) {
        return tramiteHasAllVariables ? saveLabelEnum.CONTINUE : saveLabelEnum.SAVE;
      }
      if (currentStep === stepsEnum.GENERAR_CARGOS) {
        if (selectedKeysTiposCargos.length) {
          return saveLabelEnum.GENERATE_CHARGES;
        }
        if (cargosSaldados) {
          return saveLabelEnum.CONTINUE;
        }
      }
    }

    if (pasoActual) {
      const pasosSoloLog = [
        tiposDePasosEnum.VALIDACION,
        tiposDePasosEnum.VARIABLES,
        tiposDePasosEnum.MODIFICACION_AFECTADO,
        tiposDePasosEnum.MODIFICACION_SOLICITANTE,
        tiposDePasosEnum.CAMBIO_DE_PROPIETARIO,
        tiposDePasosEnum.DIRECCION_PRINCIPAL,
        tiposDePasosEnum.DIRECCION_SECUNDARIA,
        tiposDePasosEnum.FOTOGRAFIA,
        tiposDePasosEnum.VISTA_PADRON,
        tiposDePasosEnum.SINCRONIZACION_DE_DATOS_FINANZAS,
        tiposDePasosEnum.SUBDIVISION,
        tiposDePasosEnum.FUSION,
      ];
      const _log = existingValidLogForStep(pasoActual.id);
      if (pasosSoloLog.includes(pasoActual.tipo_de_paso)) {
        return _log ? saveLabelEnum.CONTINUE : saveLabelEnum.SAVE;
      }
      const logCaptura = _log && hasComentarioDeCapturaFinalizada;
      if (pasoActual.tipo_de_paso === tiposDePasosEnum.FIRMA_ELECTRONICA) {
        if (pasoActual.firma_automatica) return saveLabelEnum.SIGN;
        if (!pasoActualHasFirma) return saveLabelEnum.SAVE;
        return saveLabelEnum.CONTINUE;
      }
      if (pasoActual.tipo_de_paso === tiposDePasosEnum.GIS) {
        if (tramite.attrs) {
          return getFileExpediente(tipoDeDocumentoExpedienteEnum.GIS)
            ? saveLabelEnum.CONTINUE : saveLabelEnum.SAVE;
        }
        return saveLabelEnum.NOT_SUPPORTED;
      }
      if (pasoActual.tipo_de_paso === tiposDePasosEnum.EMISION_DE_DOCUMENTO) {
        return _log && getFileExpediente(tipoDeDocumentoExpedienteEnum.DOCUMENTO, pasoActual.id)
          ? saveLabelEnum.CONTINUE : saveLabelEnum.SAVE;
      }
      if (pasoActual.tipo_de_paso === tiposDePasosEnum.VALIDACION_REQUISITOS) {
        const generalesAuthorized = !plantillaDeTramite.requisitos_generales.length
          || statusRequisitos.generales === statusRequisitosEnum.AUTORIZED;
        const casoAuthorized = !plantillaDeTramite.casos.length
          || statusRequisitos.caso === statusRequisitosEnum.AUTORIZED;
        if (generalesAuthorized && casoAuthorized
          && permission.tabs[permissionRequisitos.model].authorize) {
          return saveLabelEnum.AUTHORIZE;
        }
        if (_log) return saveLabelEnum.CONTINUE;
      }
      if (pasoActual.tipo_de_paso === tiposDePasosEnum.REQUISITOS) {
        if (requisitosStatusAuthorize.includes(statusRequisitos[`paso_${pasoActual.id}`])) {
          return saveLabelEnum.AUTHORIZE;
        }
        if (_log) return saveLabelEnum.CONTINUE;
      }
      if (pasoActual.tipo_de_paso === tiposDePasosEnum.CARGOS) {
        if (selectedKeysTiposCargos.length) return saveLabelEnum.GENERATE_CHARGES;
        if (cargosSaldados) return saveLabelEnum.CONTINUE;
      }
      if (pasoActual.tipo_de_paso === tiposDePasosEnum.ALTA_AFECTADO) {
        if (tipoPadronAfectado === padronesEnum.VEHICULO && padronAfectado && !hasPlaca) {
          return saveLabelEnum.NOT_SUPPORTED;
        }
        if (aplicaCambioDeAfectado) return _log ? saveLabelEnum.CONTINUE : saveLabelEnum.SAVE;
        return padronAfectado ? saveLabelEnum.CONTINUE : saveLabelEnum.SAVE;
      }
      if (pasoActual.tipo_de_paso === tiposDePasosEnum.OBLIGACIONES) {
        if (logCaptura) return saveLabelEnum.CONTINUE;
        if (hasObligaciones) return saveLabelEnum.SAVE;
      }
      if (pasoActual.tipo_de_paso === tiposDePasosEnum.EMPRESAS) {
        if (logCaptura) return saveLabelEnum.CONTINUE;
        if (hasEmpresas) return saveLabelEnum.SAVE;
      }
      if (pasoActual.tipo_de_paso === tiposDePasosEnum.PARTICIPES) {
        if (logCaptura) return saveLabelEnum.CONTINUE;
        if (pasoActual.no_afectar_padron && !includeJsonInfo(padronAfectado)?.participes?.length) {
          return saveLabelEnum.NOT_SUPPORTED;
        }
        if (hasParticipes) return saveLabelEnum.SAVE;
      }
      if (pasoActual.tipo_de_paso === tiposDePasosEnum.CONSTRUCCIONES) {
        if (logCaptura) return saveLabelEnum.CONTINUE;
        return saveLabelEnum.SAVE;
      }
      if (pasoActual.tipo_de_paso === tiposDePasosEnum.AREAS_COMUNES_DE_PREDIOS) {
        if (logCaptura) return saveLabelEnum.CONTINUE;
        return saveLabelEnum.SAVE;
      }
      if (pasoActual.tipo_de_paso === tiposDePasosEnum.VALORES_REFERIDOS_DE_PREDIOS) {
        if (logCaptura) return saveLabelEnum.CONTINUE;
        return saveLabelEnum.SAVE;
      }
      if (pasoActual.tipo_de_paso === tiposDePasosEnum.AVALUO_TERRENO) {
        if (logCaptura) return saveLabelEnum.CONTINUE;
        if (hasZonasHomogeneas) return saveLabelEnum.SAVE;
      }
      if (pasoActual.tipo_de_paso === tiposDePasosEnum.COLINDANCIAS) {
        if (logCaptura) return saveLabelEnum.CONTINUE;
        if (hasColindancias) return saveLabelEnum.SAVE;
      }
      if ([tiposDePasosEnum.ACTIVIDADES_ECONOMICAS, tiposDePasosEnum.ACTIVIDADES_ECONOMICAS_SAT]
        .includes(pasoActual.tipo_de_paso)) {
        if (logCaptura) return saveLabelEnum.CONTINUE;
        if (hasActividades) return saveLabelEnum.SAVE;
      }
      if (pasoActual.tipo_de_paso === tiposDePasosEnum.CONTRIBUYENTES_VINCULADOS) {
        if (logCaptura) return saveLabelEnum.CONTINUE;
        return saveLabelEnum.SAVE;
      }
      if (pasoActual.tipo_de_paso === tiposDePasosEnum.CARGA_DE_DOCUMENTO) {
        return _log
          && getFileExpediente(tipoDeDocumentoExpedienteEnum.DOCUMENTO, pasoActual.id)
          ? saveLabelEnum.CONTINUE : saveLabelEnum.SAVE;
      }
      if (pasoActual.tipo_de_paso === tiposDePasosEnum.CITA) {
        if (!citaPaso) return saveLabelEnum.SAVE;
        // en proceso, finalizada
        if ([2, 4].includes(citaPaso.estado_de_cita)) return saveLabelEnum.CONTINUE;
        return saveLabelEnum.NOT_SUPPORTED;
      }
      if (pasoActual.tipo_de_paso === tiposDePasosEnum.AFECTAR_PADRON_JSON) {
        return _log && !padronAfectado.json_predio ? saveLabelEnum.CONTINUE : saveLabelEnum.SAVE;
      }
      if (pasoActual.tipo_de_paso === tiposDePasosEnum.ALERTAS) {
        if (logCaptura) return saveLabelEnum.CONTINUE;
        return saveLabelEnum.SAVE;
      }
    }

    return saveLabelEnum.NOT_SUPPORTED;
  };

  const canFinish = () => {
    if (!currentStepIsLastStep || !tramite || !tramiteEnProceso) return false;
    if (typeof currentStep === 'string') {
      const canFinishMap = {
        [stepsEnum.PADRON_AFECTADO]: padronAfectado,
        [stepsEnum.REQUISITOS_GENERALES]: requisitosStatusContinue
          .includes(statusRequisitos.generales),
        [stepsEnum.REQUISITOS_DEL_CASO]: requisitosStatusContinue.includes(statusRequisitos.caso),
        [stepsEnum.VARIABLES]: tramiteHasAllVariables,
        [stepsEnum.GENERAR_CARGOS]: cargosSaldados,
      };
      return !!canFinishMap[currentStep];
    }
    if (pasoActual) {
      if (pasosCruds.includes(pasoActual.tipo_de_paso)) return hasComentarioDeCapturaFinalizada;
      if (!existingValidLogForStep(pasoActual.id)) return false;
      return canContinue();
    }
    return false;
  };

  const getNextOrSaveButton = () => {
    const _canContinue = canContinue();
    const _canFinish = currentStepIsLastStep && canFinish();
    const buttonProps = {};

    if (_canFinish) {
      buttonProps.onClick = () => setVisibleConfirmFinish(true);
      buttonProps.disabled = hasAlertasRestrictivas || !tramiteEnProceso
        || !permission.autorizar_tramite;

      return (
        // eslint-disable-next-line react/jsx-props-no-spreading
        <Button {...buttonProps}>
          {saveLabelEnum.FINISH}
          <CheckCircleOutlined />
        </Button>
      );
    }

    if (_canContinue) {
      buttonProps.onClick = nextStep;
      buttonProps.disabled = currentStepIsLastStep;

      return (
        // eslint-disable-next-line react/jsx-props-no-spreading
        <Button {...buttonProps}>
          Siguiente
          <RightOutlined />
        </Button>
      );
    }

    const icons = {
      [saveLabelEnum.SAVE]: SaveOutlined,
      [saveLabelEnum.START_TRAMITE]: SaveOutlined,
      [saveLabelEnum.AUTHORIZE]: CheckCircleOutlined,
      [saveLabelEnum.GENERATE_CHARGES]: SyncOutlined,
      [saveLabelEnum.NOT_SUPPORTED]: RightOutlined,
      [saveLabelEnum.CONTINUE]: RightOutlined,
      [saveLabelEnum.SIGN]: SaveOutlined,
    };
    const _label = getButtonLabel();
    const Icon = icons[_label];
    buttonProps.disabled = !hasPermissionForStep
      || (hasAlertasRestrictivas && !hasPasoAlertas) || !_label;

    if (_label && _label !== saveLabelEnum.CONTINUE) {
      buttonProps.onClick = form.submit;
    }
    // if (tramite && !tramiteEnProceso && _label && _label !== saveLabelEnum.CONTINUE) {
    //   buttonProps.disabled = true;
    //   const { tipo_de_paso: tipoDePaso, id: idPaso } = pasoActual || {};
    //   if ([tiposDePasosEnum.GIS, tiposDePasosEnum.EMISION_DE_DOCUMENTO].includes(tipoDePaso)) {
    //     const hasLog = existingValidLogForStep(idPaso);
    //     const hasFile = getFileExpediente(tipoDePaso === tiposDePasosEnum.GIS
    //       ? tipoDeDocumentoExpedienteEnum.GIS : tipoDeDocumentoExpedienteEnum.DOCUMENTO, idPaso);
    //     if (hasLog && !hasFile) {
    //       buttonProps.disabled = buttonProps.disabled || false;
    //     }
    //   }
    // }

    return (
      <Button
        disabled={buttonProps.disabled || loading}
        loading={loading}
        onClick={buttonProps.onClick}
      >
        {_label || saveLabelEnum.CONTINUE}
        <Icon />
      </Button>
    );
  };

  const nextOrSaveButton = getNextOrSaveButton();

  const Controls = () => (
    <Row justify="space-between" style={{ position: 'relative' }}>
      <Button disabled={!currentStep} onClick={() => prevStep()}>
        <LeftOutlined />
        Anterior
      </Button>
      {nextOrSaveButton}
      {canSkipSolicitante && (
        <Button onClick={nextStep} style={{ position: 'absolute', right: 0, bottom: 40 }}>
          <Tooltip title="Omitir solicitante, se usará el mismo padrón que se registre en el siguiente paso">
            Omitir
            {' '}
            <DoubleRightOutlined />
          </Tooltip>
        </Button>
      )}
    </Row>
  );

  const firmarCadena = async () => {
    setLoading(true);
    const values = form.getFieldsValue();
    values.paso = pasoActual.id;
    if (pasoActual.firma_automatica) {
      [values.usuario] = pasoActual.usuarios;
    }
    const [_logValues] = generateValues(pasoActual, pasosDelTramite, true);
    const logValues = {
      ..._logValues,
      tramite: tramite.id,
      comentario: `Firmado ${pasoActual.firma_automatica ? 'automáticamente ' : ''}por funcionario desde paso`,
    };
    const updated = await patchFirmarTramite(tramite, values, logValues);
    if (updated) {
      await getHistorial();
      message.info('Trámite firmado correctamente');
      setTramite({
        ...tramite,
        firma_electronica: updated.firma_electronica,
      });
    }
    setLoading(false);
  };

  const humanizeProp = (str = '') => str.replace('direccion_', 'dirección_').replace(/_/g, ' ');

  const saveAddress = async (
    { colindancias, ..._values } = form.getFieldsValue(),
    { addressPropName, parentID } = stepsPropsMap[currentStep],
  ) => {
    setLoading(true);
    const valuesColindancias = colindancias?.filter((c) => c.distancia);
    if (valuesColindancias?.length) {
      const requests = valuesColindancias.map(({ id, ..._colindancia }) => (id
        ? patchColindancia(id, _colindancia)
        : postColindancia({ ..._colindancia, predio: padronAfectado.id })));
      const responses = await Promise.all(requests);
      if (responses.some((r) => !r)) {
        if (responses.some((r) => r)) form.setFieldsValue({ colindancias: responses });
        setLoading(false);
        message.warn('Ha ocurrido un error al guardar las colindancias, intentelo de nuevo');
        return;
      }
    }
    const initJson = padronAfectado.json_predio
      ? formatReceived(padronAfectado.json_predio) : removeIndexes(padronAfectado);
    const json_predio = { ...initJson };
    const valuesDireccion = formatValues(_values, { clean: false });
    const values = {};
    if (tipoPadronAfectado === padronesEnum.PREDIO) {
      fieldsDetalle.forEach(([name]) => {
        json_predio[name] = valuesDireccion[name];
        // Para aplicar valores en props de detalle de dirección en predio
        if (!pasoActual.no_afectar_padron) {
          values[name] = valuesDireccion[name];
        }
        delete valuesDireccion[name];
      });
    }
    const _tipoDePadron = tipoPadronAfectado || tipoPadronSolicitante;
    if (pasoActual.no_afectar_padron) {
      values.json_predio = {};
      const deletableKeys = deletableKeysPadronesMap[_tipoDePadron] || [];
      json_predio[addressPropName] = valuesDireccion;
      values.json_predio = formatValues(json_predio, { deletableKeys }, dateKeysPredio);
      values.json_predio = JSON.stringify(values.json_predio);
    } else {
      values[addressPropName] = valuesDireccion;
    }
    const saved = await patchPadronesMap[_tipoDePadron](parentID, values);
    if (saved) {
      const action = (padronAfectado || padronSolicitante)[addressPropName] ? 'modificada' : 'agregada';
      const _message = `${humanizeProp(addressPropName)} ${action}`.toUpperCase();
      await postLog(_message, true);
      message.info(_message);
      const _padronAfectado = await searchPadron(padronAfectado.id, tipoPadronAfectado);
      setPadronAfectado(_padronAfectado);
    }
    setLoading(false);
  };

  useEffect(() => {
    if (plantillaDeTramite?.requiere_gis && (padronAfectado && (padronAfectado?.direccion_index
      || padronAfectado?.direccion_notificacion_index))) {
      if (currentStep === stepsEnum.PADRON_AFECTADO && !form.getFieldValue('base64')
        && !loading) {
        setLoading(true);
      }
      if ((form.getFieldValue('base64') && loading) || tramite) {
        setLoading(false);
      }
    }
  }, [
    currentStep,
    form.getFieldValue('base64'),
    padronAfectado,
    <ArcGisMap />,
    tramite,
  ]);

  const savePicture = async () => {
    const comment = 'Fotografía capturada';
    const [savedFile, _log] = await saveFile(existingValidLogForStep(pasoActual.id)
      ? null : comment);
    if (!_log || !savedFile) {
      message.info('Intentelo de nuevo');
    }
    setLoading(false);
  };

  const saveCita = async () => {
    setLoading(true);
    const formValues = form.getFieldsValue();
    const [horario_inicio, horario_fin] = formValues.horario.split('-');
    const values = {
      plantilla_de_tramite: plantillaDeTramite.id,
      oficina: formValues.oficina,
      entidad: entidad.id,
      estado_de_cita: 1, // Programada
      fecha_alta: toMoment(new Date()),
      fecha_cita: toMoment(formValues.fecha, [DATE_FRONTEND_FORMAT]),
      horario_inicio,
      horario_fin,
      paso: pasoActual.id,
      tramite: tramite.id,
      ventanilla: null,
      [tipoPadronSolicitante === padronesEnum.CIUDADANO
        ? 'ciudadano' : 'contribuyente']: padronSolicitante.id,
    };
    const _cita = await postCita(values);
    if (_cita) {
      postLog(`Cita con folio ${_cita.folio} programada por solicitante`);
      await fetchCitas();
    }
    setLoading(false);
  };

  const sincronizacionDeDatosFinanzas = async () => {
    setLoading(true);
    let ultimaPlacaFinanzas;
    let _tramite;
    const { placa_manual, ...values } = form.getFieldsValue();
    if (placa_manual && !values.fecha_de_baja) {
      message.info('Ingrese Fecha de baja de placa anterior');
      return false;
    }
    if (placa_manual) {
      ultimaPlacaFinanzas = {
        numero_de_placa: values.numero_de_placa,
        fecha_expedicion_placa: values.fecha_expedicion_placa,
      };
    } else {
      setLoading(true);
      _tramite = await consultaTramiteFinanzas(tramite.folio);
      if (!_tramite || _tramite.estados_globales !== 4) {
        if (!_tramite) message.info('No se encontró trámite en finanzas');
        if (_tramite && _tramite.estados_globales !== 4) message.info('Trámite en finanzas aun no está finalizado');
        setLoading(false);
        return false;
      }
      ultimaPlacaFinanzas = _tramite.padron.historial_de_placas
        ?.[_tramite.padron.historial_de_placas.length - 1];
    }

    setLoading(true);
    const saved = await generarPlaca(ultimaPlacaFinanzas, _tramite, values.fecha_de_baja);
    if (saved) {
      await logWithLoading();
    }
    setLoading(false);
    return true;
  };

  const postSubdivisiones = async () => {
    const { observaciones_cancelacion, observaciones_subdivision } = form.getFieldsValue();

    const valuesPredio = {};
    if (pasoActual.no_afectar_padron) {
      valuesPredio.json_predio = JSON.parse(padronAfectado.json_predio_raw);
      valuesPredio.json_predio.observaciones_subdivision = observaciones_subdivision;
      valuesPredio.json_predio.observaciones_cancelacion = observaciones_cancelacion;
      valuesPredio.json_predio = JSON.stringify(valuesPredio.json_predio);
    } else {
      valuesPredio.observaciones_subdivision = observaciones_subdivision;
      valuesPredio.observaciones_cancelacion = observaciones_cancelacion;
    }

    const _predio = includeJsonInfo(padronAfectado);

    if ((_predio.observaciones_subdivision !== observaciones_subdivision)
      || (_predio.observaciones_cancelacion !== observaciones_cancelacion)) {
      const updatedPredio = await patchPredio(padronAfectado.id, valuesPredio);
      if (!updatedPredio) {
        setLoading(false);
        return;
      }
      const copy = { ...padronAfectado };
      if (pasoActual.no_afectar_padron) {
        copy.json_predio = updatedPredio.json_predio;
      } else {
        copy.observaciones_subdivision = updatedPredio.observaciones_subdivision;
        copy.observaciones_cancelacion = updatedPredio.observaciones_cancelacion;
      }
      setPadronAfectado(copy);
    }

    setLoading(true);
    if (pasoActual.es_subdivision_disolucion) {
      const _predios = form.getFieldValue('predios');
      setLoadingMessage('Procesando el archivo');
      const encolado = await postImportacionMasivaPredios(_predios);
      if (!encolado?.job_id) {
        setLoadingMessage();
        setLoading(false);
        return;
      }
      const resultado = await getEstadoImportacionMasivaPredios(encolado.job_id);
      setLoadingMessage();
      if (resultado?.predios_creados) {
        await postLog(`Predios ${listToString(resultado.predios_creados)} generados`, true);
      }
      setLoading(false);
      return;
    }

    const {
      clonar_direccion,
      clonar_participes,
      clonar_info_general,
      cantidad,
      BASES_GRAVABLES = [],
      SUMA,
      MEDIA,
    } = form.getFieldsValue();
    const numero_a_subdividir = parseInt(cantidad, 10);
    const tramiteValues = {};
    if (tramite.numero_a_subdividir !== numero_a_subdividir) {
      tramiteValues.numero_a_subdividir = numero_a_subdividir;
    }
    if (tramites.length) {
      const _predios_relacionados = tramites.map((t) => t.object_id_padron);
      if (tramite.predios_relacionados?.join() !== _predios_relacionados.join()) {
        tramiteValues.predios_relacionados = _predios_relacionados;
      }
      if (BASES_GRAVABLES.length) {
        const bases_gravables_json = {
          BASES_GRAVABLES,
          SUMA,
          MEDIA,
          TRAMITES: [tramite.id, ...tramites.map((t) => t.id)],
        };
        tramiteValues.bases_gravables_json = JSON.stringify(bases_gravables_json);
      }
      if (Object.keys(tramiteValues).length) {
        const updated = await patchTramite(tramite.id, tramiteValues);
        if (!updated) {
          setLoading(false);
          return;
        }
        setTramite({ ...tramite, ...tramiteValues });
      }
      await postLog(`Trámites ${listToString(tramites.map((t) => t.folio))} generados`, true);
      setLoading(false);
      return;
    }

    const plantillaHija = await getPlantillaTramite(pasoActual.plantilla_hija);
    if (!plantillaHija) {
      setLoading(false);
      return;
    }
    const payload = {
      direccion: null,
      participes: [],
      predio: {
        descripcion: 'General',
        // fks con _id suffix
        estados_globales_id: 2,
        entidad_id: entidad.id,
        subdivision_id: padronAfectado.id,
        // requrido desde base de datos
        uso_de_predio_id: padronAfectado.uso_de_predio,
        // requrido para asignación de clave
        recaudadora_id: padronAfectado.recaudadora || user.unidad_de_recaudacion,
        tipo_de_predio_id: padronAfectado.tipo_de_predio?.id,
        observaciones_subdivision,
      },
    };
    if (clonar_info_general) {
      // fks con _id suffix
      ['zona', 'clave_de_zonificacion', 'tipo_de_aseo', 'tipo_de_predio', 'regimen_de_propiedad'].forEach((key) => {
        payload.predio[`${key}_id`] = padronAfectado[key]?.id || padronAfectado[key];
      });
      ['escritura', 'volumen', 'tomo'].forEach((key) => {
        payload.predio[key] = padronAfectado[key];
      });
    }
    if (clonar_direccion && padronAfectado.direccion) {
      payload.direccion = { ...padronAfectado.direccion, entidad_id: payload.predio.entidad_id };
      // fks con _id suffix
      ['codigo_postal', 'tipo_de_vialidad', 'tipo_de_vialidad_entre', 'tipo_de_vialidad_y_calle'].forEach((key) => {
        payload.direccion[`${key}_id`] = payload.direccion[key];
        delete payload.direccion[key];
      });
    }
    if (clonar_participes) {
      payload.participes = padronAfectado.participes.map(({ id, ...e }) => ({
        apellido_materno: e.apellido_materno,
        apellido_paterno: e.apellido_paterno,
        descripcion: e.descripcion,
        es_participe_principal: e.es_participe_principal,
        nombre_participe: e.nombre_participe,
        porcentaje: e.porcentaje,
        porcentaje_nuevo: e.porcentaje_nuevo,
        object_id_participe: e.object_id_participe,
        // fks con _id suffix
        // predio_id: padronAfectado.id,
        entidad_id: payload.predio.entidad_id,
        estados_globales_id: 1,
        padron_id: e.padron,
        tipo_de_persona_id: e.tipo_de_persona,
        sigla_propietario_id: e.sigla_propietario,
      }));
    }

    payload.tramite = {
      // object_id_padron: 'Id del predio creado',
      solicitante_ciudadano: tramite.solicitante_ciudadano,
      fecha_de_inicio: toMoment(new Date()).format(DATE_FORMAT),
      // fks con _id suffix
      estados_globales_id: 2,
      [tramite.ciudadano ? 'ciudadano_id' : 'contribuyente_id']: tramite.ciudadano || tramite.contribuyente,
      plantilla_id: pasoActual.plantilla_hija,
      tipo_padron_id: tramite.tipo_padron,
      canal_de_pago_id: user.canal_de_pago,
      departamento_id: plantillaHija.departamentos[0].id,
      unidad_de_recaudacion_id: user.unidad_de_recaudacion,
      descripcion: plantillaHija.nombre,
      tipos_de_registros_de_tramite_id: tramite.tipos_de_registros_de_tramite,
      procedencia_id: procedenciasEnum.GPM,
      tramite_subdivision_madre_id: tramite.id,
      entidad_id: entidad.id,
    };
    payload.cantidad = numero_a_subdividir;
    payload.bases_gravables = BASES_GRAVABLES.filter((_, i) => i);

    let _tramites = await postTramitesHijas(payload);
    if (!_tramites.length) {
      setLoading(false);
      return;
    }
    if (BASES_GRAVABLES.length) {
      const bases_gravables_json = {
        BASES_GRAVABLES,
        SUMA,
        MEDIA,
        TRAMITES: [tramite.id, ..._tramites.map((t) => t.id)],
      };
      tramiteValues.bases_gravables_json = JSON.stringify(bases_gravables_json);
    }
    _tramites = await getAllPages(getTramites, { tramite_subdivision_madre: tramite.id });
    setTramites(_tramites);
    tramiteValues.predios_relacionados = _tramites.map((t) => t.object_id_padron);
    const updated = await patchTramite(tramite.id, tramiteValues);
    if (!updated) {
      setLoading(false);
      return;
    }
    await postLog(`Trámites ${listToString(_tramites.map((t) => t.folio))} generados`, true);
    setTramite({ ...tramite, ...tramiteValues });
    setLoading(false);
  };

  const postFusion = async () => {
    const { predios_relacionados, cantidad, predios_relacionados_objects } = form.getFieldsValue();
    const numero_a_subdividir = parseInt(cantidad, 10);
    if (!numero_a_subdividir) return;
    const values = {};
    // usando campo numero_a_subdividir pero en realidad es numero a fusionar para este caso
    if (tramite.numero_a_subdividir !== numero_a_subdividir) {
      values.numero_a_subdividir = numero_a_subdividir;
    }
    if (!tramite.predios_relacionados?.join() !== predios_relacionados.join()) {
      values.predios_relacionados = predios_relacionados;
    }
    setLoading(true);
    if (Object.keys(values).length) {
      const updated = await patchTramite(tramite.id, values);
      if (!updated) {
        setLoading(false);
        return;
      }
      setTramite((_tramite) => ({
        ..._tramite,
        numero_a_subdividir: updated.numero_a_subdividir,
        predios_relacionados: updated.predios_relacionados,
      }));
    }
    const promisesPredios = predios_relacionados_objects.map((p) => {
      const _predio = {
        estados_globales: ESTADOS_GLOBALES_MAP.CANCELADO,
        fusion: padronAfectado.id,
        observaciones_fusion: p.observaciones_fusion,
      };
      if (hasImpactJsonStep) {
        if (p.json_predio) return p;
        const json_predio = JSON.stringify(formatValues(_predio, { clean: false }, dateKeysPredio));
        return patchPredio(p.id, { json_predio });
      }
      if (p.estados_globales === ESTADOS_GLOBALES_MAP.CANCELADO) return p;
      return patchPredio(p.id, _predio);
    });
    const responsesPredios = await Promise.all(promisesPredios);
    const _predios = predios_relacionados_objects.map((_, idx) => responsesPredios[idx]);
    form.setFieldValue('predios_relacionados_objects', _predios);
    if (responsesPredios.some((r) => !r)) {
      setLoading(false);
      return;
    }
    const _message = `Predios ${listToString(predios_relacionados)} relacionados`;
    await postLog(_message, true);
    setPrediosRelacionados(_predios);
    setLoading(false);
  };

  const onFinish = async () => {
    if (isSubmittingRef.current) return null;
    isSubmittingRef.current = true;
    try {
      if (DEV) logger('[values]', form.getFieldsValue());
      try {
        if (pasoActual?.tipo_de_paso !== tiposDePasosEnum.VISTA_PADRON) {
          await form.validateFields();
        }
      } catch {
        return null;
      }
      if (typeof currentStep === 'string') {
        if (currentStep === stepsEnum.PADRON_SOLICITANTE) {
          if (padronSolicitante) {
            if (tipoPadronAfectado && !altaEnPaso) {
              return nextStep();
            }
            return await iniciarTramite();
          }
        }
        if (currentStep === stepsEnum.PADRON_AFECTADO) {
          if (tipoDeAfectacion === afectacionesEnum.ALTA) {
            return await postPadron();
          }
          return await iniciarTramite();
        }
        if (currentStep === stepsEnum.VARIABLES) return await saveVariablesTramite();
        if (currentStep === stepsEnum.REQUISITOS_GENERALES
          || currentStep === stepsEnum.REQUISITOS_DEL_CASO) return setShowMessagesRequisitos(true);
        if (currentStep === stepsEnum.GENERAR_CARGOS
          && selectedKeysTiposCargos.length) return await saveCargos();
      }
      const tipoDePaso = pasoActual?.tipo_de_paso;
      if (tipoDePaso === tiposDePasosEnum.VALIDACION) return setVisibleModalLog(true);
      if (tipoDePaso === tiposDePasosEnum.VARIABLES) return await saveVariablesPaso();
      if (tipoDePaso === tiposDePasosEnum.FIRMA_ELECTRONICA) return await firmarCadena();
      if (tipoDePaso === tiposDePasosEnum.MODIFICACION_AFECTADO) {
        if (pasoConsultaDeAdeudo === pasoActual.id || validateCNAaguaTlajo) {
          if (validateCNAaguaTlajo) {
            setLoading(true);
            const error = await validateCNAAgua(padronAfectado, () => patchAfectado());
            if (error) return null;
          }
          // omitimos si validateCNAaguaTlajo para hacerlo en validateCNAAgua
          // y usar la misma fecha_traslado usada para cna
          if ((esConsultaDeAdeudo || noIniciarConAdeudo) && !validateCNAaguaTlajo) {
            await getAdeudo(
              tipoPadronAfectado,
              padronAfectado.id,
              setPadronAfectado,
              padronAfectado,
              () => patchAfectado(),
            );
          }
          if (esConsultaDeRecibos) {
            await buscarRecibos(
              tipoPadronAfectado,
              padronAfectado?.id,
              setPadronAfectado,
              () => patchAfectado(),
            );
          }
          return null;
        }
        return await patchAfectado();
      }
      if (tipoDePaso === tiposDePasosEnum.MODIFICACION_SOLICITANTE) return await patchSolicitante();
      if (tipoDePaso === tiposDePasosEnum.GIS) return await saveGIS();
      if (tipoDePaso === tiposDePasosEnum.CAMBIO_DE_PROPIETARIO) return await patchAfectado(true);
      if (tipoDePaso === tiposDePasosEnum.REQUISITOS) return setShowMessagesRequisitos(true);
      if (tipoDePaso === tiposDePasosEnum.CARGOS
        && selectedKeysTiposCargos.length) return await saveCargos();
      if (tipoDePaso === tiposDePasosEnum.ALTA_AFECTADO) {
        if (aplicaCambioDeAfectado) return await postPadron();
        return await (padronAfectado ? createPlaca() : postPadron());
      }
      if ([tiposDePasosEnum.DIRECCION_PRINCIPAL, tiposDePasosEnum.DIRECCION_SECUNDARIA]
        .includes(tipoDePaso)) return await saveAddress();
      if (tiposDePasosLog.includes(tipoDePaso)) return await logWithLoading();
      if (tiposDePasosEnum.FOTOGRAFIA === tipoDePaso) return await savePicture();
      if (tipoDePaso === tiposDePasosEnum.EMISION_DE_DOCUMENTO) return await saveDocumento();
      if (tipoDePaso === tiposDePasosEnum.CARGA_DE_DOCUMENTO) return await saveFile('Documento cargado por funcionario');
      if (tipoDePaso === tiposDePasosEnum.VISTA_PADRON) return await logWithLoading();
      if (tipoDePaso === tiposDePasosEnum.CITA) return await saveCita();
      if (tipoDePaso === tiposDePasosEnum.SINCRONIZACION_DE_DATOS_FINANZAS) {
        return await sincronizacionDeDatosFinanzas();
      }
      if (tipoDePaso === tiposDePasosEnum.AFECTAR_PADRON_JSON) {
        return await patchAfectado(
          false, formatReceived(removeIndexes(padronAfectado.json_predio)), true,
        );
      }
      if (tipoDePaso === tiposDePasosEnum.SUBDIVISION) return await postSubdivisiones();
      if (tipoDePaso === tiposDePasosEnum.FUSION) return await postFusion();
      return logger('onFinish not defined');
    } finally {
      isSubmittingRef.current = false;
    }
  };

  useEffect(() => {
    if (padronSolicitante && tipoPadronSolicitante) {
      localStorage.setItem('padronSolicitante', JSON.stringify({
        ...padronSolicitante,
        tipo_de_padron: tipoPadronSolicitante,
      }));
    }
  }, [padronSolicitante, tipoPadronSolicitante]);

  const ConsultaButton = REPUVE ? (
    <Col>
      <Button style={{ padding: '4px 8px ' }} type="link" onClick={() => setVisibleModalInfoRepuve(true)}>
        Consulta
        <SearchOutlined />
      </Button>
    </Col>
  ) : null;

  if (!plantillaDeTramite) {
    if (tramiteParam || citaParam || plantillaParam || (REPUVE && loadingFetch)) {
      return (
        <ThemeProvider theme={theme}>
          <Spin tip={loadingAdeudo || loadingMessage || 'Cargando...'} spinning={!!loadingAdeudo || loading}>
            <Row style={{ width: '100vw', height: '100vh' }} />
          </Spin>
        </ThemeProvider>
      );
    }
    if (REPUVE) {
      return (
        <ThemeProvider theme={theme}>
          <GlobalStyles />
          <Row style={{ width: '100vw', height: '100vh', padding: screens.md ? 30 : 5 }} align="middle" justify="center">
            <Col span={22}>
              <Button type="link" onClick={() => history.push('/dashboard')}>
                <HomeOutlined />
                Ir al Dashboard
              </Button>
              <br />
              <br />
              <Card
                title={<Typography.Title level={3}>Consulta REPUVE</Typography.Title>}
                bodyStyle={{ maxHeight: '80vh', overflow: 'scroll', paddingBottom: 25 }}
                style={{ border: '2px solid #cccccc ' }}
              >
                <ModalInfoRepuve
                  allowSearch
                  plantillasDeTramites={plantillasDeTramites.results}
                  onFinish={async (_plantilla, _valuesRepuve, _vehiculo, _solicitante) => {
                    setValuesRepuve(_valuesRepuve);
                    await onSelectPlantilla(_plantilla.id);
                    if (_vehiculo) await onAfectadoFound(_vehiculo, false, padronesEnum.VEHICULO);
                    if (_solicitante) await onSolicitanteFound(_solicitante, null, _vehiculo);
                    setLoading(false);
                  }}
                />
              </Card>
            </Col>
          </Row>
        </ThemeProvider>
      );
    }
    return (
      <ThemeProvider theme={theme}>
        <GlobalStyles />
        <Spin tip={loadingAdeudo || loadingMessage || 'Cargando...'} spinning={!!loadingAdeudo || loading}>
          <Container>
            <Row justify={REPUVE ? 'space-between' : 'start'}>
              <Col>
                <Button type="link" onClick={() => history.push('/dashboard')}>
                  <HomeOutlined />
                  Ir al Dashboard
                </Button>
              </Col>
              {REPUVE && (
                <Col>
                  <Button type="link" onClick={() => setVisibleModalInfoRepuve(true)}>
                    Consulta REPUVE
                    <SearchOutlined />
                  </Button>
                </Col>
              )}
            </Row>
            <Title level={getLevel(3)} className="primary-text">
              Trámites
              {isFiltered && (
                <>
                  {' - '}
                  {tiposDeFiltros.find((e) => e.id === tipoDeFiltro).descripcion}
                  {': '}
                  {filtros[tipoDeFiltro]?.find((e) => e.id === filtro).descripcion || filtro}
                </>
              )}
            </Title>
            <Form
              onFinish={() => onFinishSearchTramite()}
              form={formSearch}
              layout={tiposDePasosEnum.CITA && citaPaso ? 'horizontal' : 'vertical'}
              name="GPM"
            >
              <Row gutter={10}>
                <Col xs={16} sm={16} md={8}>
                  <Form.Item
                    label="Búsqueda por folio"
                    name="folio"
                    rules={rules.required}
                    tooltip="Búsqueda de trámite en proceso"
                    normalize={toUpper}
                  >
                    <Input
                      allowClear
                      ref={searchInputRef}
                      disabled={params.id === -1}
                      tabIndex="0"
                    />
                  </Form.Item>
                </Col>
                <Col span={8}>
                  <Form.Item style={{ marginTop: 22 }}>
                    <Space>
                      <Button htmlType="submit" disabled={params.id === -1}>
                        {screens.md && 'Buscar'}
                        <SearchOutlined />
                      </Button>
                      <Button htmlType="reset" disabled={params.id === -1}>
                        {screens.md && 'Limpiar'}
                        <DeleteOutlined />
                      </Button>
                    </Space>
                  </Form.Item>
                </Col>
              </Row>
            </Form>
            {showControls && (
              <Form
                onFinish={onFinishFilter}
                form={formFilter}
                layout="vertical"
                initialValues={{ tipoDeFiltro: 0 }}
              >
                <Row gutter={10}>
                  <Col xs={24} sm={24} md={8}>
                    <Form.Item
                      label="Filtrar por"
                      name="tipoDeFiltro"
                      tooltip="Filtrado de trámites disponibles"
                    >
                      <Select
                        dataSource={tiposDeFiltros}
                        onChange={() => formFilter.resetFields(['filtro'])}
                        allowClear={false}
                      />
                    </Form.Item>
                  </Col>
                  <Col xs={!tipoDeFiltro ? 0 : 24} sm={!tipoDeFiltro ? 0 : 24} md={8}>
                    <Form.Item
                      label={tiposDeFiltros.find((e) => e.id === tipoDeFiltro)?.descripcion || 'Filtro'}
                      name="filtro"
                      rules={[{ required: !!tipoDeFiltro }]}
                    >
                      {tipoDeFiltro === 'nombre' ? (
                        <Input allowClear />
                      ) : (
                        <Select
                          disabled={!tipoDeFiltro}
                          dataSource={filtros[tipoDeFiltro]}
                          allowClear={false}
                        />
                      )}
                    </Form.Item>
                  </Col>
                  <Col xs={24} sm={24} md={8}>
                    <Form.Item style={{ marginTop: 22 }}>
                      <Space>
                        <Button htmlType="submit" disabled={!filtro}>
                          Filtrar
                          <FilterOutlined />
                        </Button>
                        <Button onClick={() => setTimeout(() => formFilter.submit())} htmlType="reset">
                          Limpiar
                          <DeleteOutlined />
                        </Button>
                      </Space>
                    </Form.Item>
                  </Col>
                </Row>
              </Form>
            )}
            {!!plantillasDeTramites.count && (
              <Row gutter={[10, 10]} style={{ height: 'auto' }}>
                {plantillasDeTramites.results.map((_plantillaDeTramite) => {
                  const requirements = getRequirements(_plantillaDeTramite);
                  const height = (requirements ? 20 : 0)
                    + (PORTAL_CIUDADANO && _plantillaDeTramite.estado_de_ficha === 3 ? 20 : 0);
                  return (
                    <Col xs={12} sm={12} md={8} key={_plantillaDeTramite.id}>
                      <StyledButton
                        className={!!requirements && 'disabled'}
                        onClick={() => !requirements && onSelectPlantilla(_plantillaDeTramite.id)}
                        block
                      >
                        <span
                          style={{
                            width: `calc(100% - ${height}px)`,
                            paddingRight: height ? 10 : 0,
                          }}
                        >
                          {_plantillaDeTramite.nombre}
                        </span>
                        {!!requirements && (
                          <Tooltip
                            title={requirements}
                            overlayInnerStyle={{ fontWeight: 'bold' }}
                            color={theme.primaryText}
                            mouseEnterDelay={0.3}
                          >
                            <QuestionCircleOutlined />
                          </Tooltip>
                        )}
                        {!!PORTAL_CIUDADANO && _plantillaDeTramite.estado_de_ficha === 3 && (
                          <Tooltip
                            title="Ver detalle completo de trámite (link externo)"
                            overlayInnerStyle={{ fontWeight: 'bold' }}
                            color={theme.primaryText}
                            mouseEnterDelay={0.3}
                          >
                            <Button
                              type="link"
                              href={`${PORTAL_CIUDADANO}/tramites/tramite/${_plantillaDeTramite.id}`}
                              target="_blank"
                              className={`no-color ${requirements ? 'disabled' : ''}`}
                              onClick={(e) => e.stopPropagation()}
                            >
                              <EyeOutlined />
                            </Button>
                          </Tooltip>
                        )}
                      </StyledButton>
                    </Col>
                  );
                })}
                <Col span={24}>
                  <Pagination
                    onChange={(_page) => {
                      fetchPlantillasDeTramites(_page, null, plantillasDeTramites.params);
                    }}
                    total={plantillasDeTramites.count}
                    current={plantillasDeTramites.page}
                    showSizeChanger={false}
                    showQuickJumper
                  />
                </Col>
              </Row>
            )}
            {!plantillasDeTramites.count && !loading && (
              <Result
                title="Sin trámites para mostrar"
                icon={<InboxOutlined />}
                subTitle={params.id ? 'Usuario no cuenta con departamento o dependencia' : ''}
              />
            )}
          </Container>
        </Spin>
      </ThemeProvider>
    );
  }

  const ButtonAlertas = ({ visible }) => visible && (
    <Button type="text" onClick={showAlertas} style={{ fontSize: 'inherit', padding: 0 }}>
      <Tooltip title="Presione para ver alertas">
        <WarningOutlined className="warn" />
      </Tooltip>
    </Button>
  );

  const titlePadronSolicitante = padronSolicitante && (
    <Text className="primary-text" style={{ maxWidth: '100vw' }}>
      PADRÓN SOLICITANTE
      <br />
      {padronToString(padronSolicitante, tipoPadronSolicitante, true, false)}
      <ButtonAlertas visible={!!alertasSolicitante.length && !screens.md} />
    </Text>
  );

  const titlePadronAfectado = padronAfectado && (
    <Text className="primary-text" style={{ maxWidth: '100vw' }}>
      PADRÓN AFECTADO
      <br />
      {padronToString(includeJsonInfo(padronAfectado), tipoPadronAfectado, true, false)}
      <ButtonAlertas visible={!!alertasAfectado.length && !screens.md} />
    </Text>
  );

  const titleComments = tramiteEnProceso && pasoActual
    && !existingValidLogForStep(pasoActual.id, false)
    && (!lastLog || pasoActual.id === lastLog.paso_a_mandar)
    && (<Text className="primary-text">PRESIONE PARA AÑADIR COMENTARIOS</Text>);

  const titleVerHistorial = (
    <Text className="primary-text">
      PRESIONE PARA VER HISTORIAL DE SEGUIMIENTO
    </Text>
  );

  const componentRenderNeeded = () => {
    if (typeof currentStep === 'string') {
      return [stepsEnum.REQUISITOS_GENERALES, stepsEnum.REQUISITOS_DEL_CASO].includes(currentStep);
    }
    return [tiposDePasosEnum.EMISION_DE_DOCUMENTO, tiposDePasosEnum.GIS]
      .includes(pasoActual?.tipo_de_paso);
  };

  const isCancelable = () => {
    if (!tramiteEnProceso || tramite.tramite_subdivision_madre) return false;
    const pasosModificaciones = plantillaDeTramite.pasos_para_tramites
      .filter((p) => tiposPasosNoCancelable.includes(p.tipo_de_paso) && !p.no_afectar_padron);
    // No hay log autogenerados para ningun paso de modificacion, ni logs que permitieron avanzar
    return pasosModificaciones.every((p) => !historial.filter((l) => l.paso === p.id).some((l) => {
      const paso_a_mandar = plantillaDeTramite.pasos_para_tramites.find((_p) => _p.id === l.paso);
      return paso_a_mandar.orden > p.orden || /\[autogenerado\]/i.test(l.comentario?.comentario);
    }));
  };

  const showInstructions = pasoActual && !!pasoActual.instrucciones
    && pasoActual.tipo_de_paso !== tiposDePasosEnum.CARGOS;//  && !canContinue()

  const { key: currentStepComponentPropsKey, ...currentStepComponentProps } = {
    ...stepsPropsMap[currentStep],
    ...(stepsPropsMap[currentStep] ? {
      disabled: !tramiteEnProceso || !!stepsPropsMap[currentStep]?.disabled,
      mutable: !!stepsPropsMap[currentStep]?.mutable && tramiteEnProceso,
      hasPermission: hasPermissionForStep || canContinue(),
      estados_globales: tramite?.estados_globales,
    } : {}),
  };

  const beforeOnFinish = () => {
    const stepTypesWithConfirmation = [
      tiposDePasosEnum.VARIABLES,
      tiposDePasosEnum.ALTA_AFECTADO,
      tiposDePasosEnum.DIRECCION_PRINCIPAL,
      tiposDePasosEnum.DIRECCION_SECUNDARIA,
      tiposDePasosEnum.AFECTAR_PADRON_JSON,
      ...tiposPasosModificaciones,
    ];
    if (tipoDeAfectacion === afectacionesEnum.ALTA) {
      stepTypesWithConfirmation.push(stepsEnum.PADRON_SOLICITANTE);
    }
    const stepsWithConfirmation = [...pasosCruds, stepsEnum.VARIABLES];

    if (stepTypesWithConfirmation.includes(pasoActual?.tipo_de_paso)
      || stepsWithConfirmation.includes(currentStep)) {
      Modal.confirm({
        title: 'Confirmación',
        content: (
          <>
            <Text style={{ display: 'block' }}>
              ¿Seguro que desea guardar y continuar con la información capturada?
            </Text>
            {tiposPasosNoPuedeRetender.includes(pasoActual?.tipo_de_paso) && (
              <Text type="warning" style={{ marginTop: 20, display: 'block' }}>
                Esta acción no se puede revertir ni corregir
                y este paso no puede volver a ejecutarse.
              </Text>
            )}
          </>
        ),
        onOk: () => {
          Modal.destroyAll();
          onFinish();
        },
        okText: getButtonLabel(),
        okButtonProps: { className: 'no-color' },
      });
      return null;
    }
    return onFinish();
  };

  const download = (filename, data) => {
    const element = document.createElement('a');
    element.setAttribute('href', data);
    element.setAttribute('download', filename);

    element.style.display = 'none';
    document.body.appendChild(element);

    element.click();

    document.body.removeChild(element);
  };

  const downloadExpediente = async () => {
    const zipBase64 = await getZipExpediente(tramite.id);
    if (!zipBase64) return;
    const fileName = `expediente_digital_${tramite.folio}.zip`;
    download(fileName, zipBase64);
    message.info(`Descarga de ${fileName} iniciada`);
  };

  const tiposPasosExp = [
    tiposDePasosEnum.REQUISITOS,
    tiposDePasosEnum.CARGOS,
    tiposDePasosEnum.EMISION_DE_DOCUMENTO,
  ];

  const pasosInicialesExp = [
    stepsEnum.REQUISITOS_GENERALES,
    stepsEnum.REQUISITOS_DEL_CASO,
    stepsEnum.GENERAR_CARGOS,
  ];

  const firstStepExpIdx = stepsTimelineItems.findIndex((st) => pasosInicialesExp.includes(st.key)
    || pasosDelTramite.find((p) => p.id === st.key && tiposPasosExp.includes(p.tipo_de_paso)));
  const showDownload = firstStepExpIdx !== -1;

  const separator = screens.md ? ' — ' : ' ';

  const PadronAfectadoCustomIcon = () => {
    const customIcons = {
      [padronesEnum.CIUDADANO]: UserOutlined,
      [padronesEnum.EMPRESA]: TrademarkOutlined,
      [padronesEnum.PREDIO]: EnvironmentOutlined,
      [padronesEnum.VEHICULO]: CarOutlined,
      [padronesEnum.HOSPEDAJE]: KeyOutlined,
      [padronesEnum.ARRENDAMIENTO]: KeyOutlined,
      [padronesEnum.NOMINA]: DollarOutlined,
      [padronesEnum.ALCOHOL]: null,
      [padronesEnum.CEDULAR]: null,
      [padronesEnum.JUEGO_DE_AZAR]: DollarOutlined,
      [padronesEnum.NOTARIO]: FileProtectOutlined,
      [padronesEnum.CASA_DE_EMPENIO]: ShopOutlined,
      [padronesEnum.AGENCIA]: null,
      [padronesEnum.CONTRIBUYENTE]: UserOutlined,
      [padronesEnum.MOTOCICLETA]: CarOutlined,
      [padronesEnum.REMOLQUE]: CarOutlined,
      [padronesEnum.POLICIA_ESPECIAL]: AuditOutlined,
      [padronesEnum.INFRACCIONES]: AuditOutlined,
      [padronesEnum.COMERCIO_INFORMAL]: ShopOutlined,
      [padronesEnum.MERCADO]: ShopOutlined,
      [padronesEnum.EXPEDIENTE_LICENCIA_FUNCIONAMIENTO]: null,
      [padronesEnum.ZONA_EXCLUSIVA]: null,
      [padronesEnum.EXPEDIENTE_DE_ANUNCIO]: null,
      [padronesEnum.MULTAS]: null,
      [padronesEnum.VENDEDOR_DE_ALCOHOLES]: DollarOutlined,
      [padronesEnum.RETENEDOR_DE_CEDULA]: DollarOutlined,
      [padronesEnum.RETENEDOR_DE_NOMINA]: CarOutlined,
      [padronesEnum.ESTACIONAMIENTO]: CarOutlined,
    };
    const CustomIcon = customIcons[tipoPadronAfectado];
    return CustomIcon ? <CustomIcon style={{ marginRight: 5 }} /> : <QuestionCircleOutlined />;
  };

  const padronesContent = (
    <>
      {!!padronSolicitante && (
        <Tooltip
          title={titlePadronSolicitante}
          overlayStyle={{ maxWidth: 700 }}
          placement="bottom"
        >
          <UserOutlined />
          {screens.md && getPadronKey(padronSolicitante, tipoPadronSolicitante)}
          <ButtonAlertas visible={!!alertasSolicitante.length && screens.md} />
        </Tooltip>
      )}
      {!!padronAfectado && (
        <>
          {separator}
          <Tooltip
            title={titlePadronAfectado}
            overlayStyle={{ maxWidth: 700 }}
            placement="bottom"
          >
            <PadronAfectadoCustomIcon />
            {screens.md && getPadronKey(includeJsonInfo(padronAfectado), tipoPadronAfectado)}
            <ButtonAlertas visible={!!alertasAfectado.length && screens.md} />
          </Tooltip>
        </>
      )}
      {!!tramite?.tramiteMadre && (
        <>
          {separator}
          <Tooltip
            title="TRÁMITE MADRE"
            overlayStyle={{ maxWidth: 700 }}
            placement="bottom"
          >
            <ApartmentOutlined />
            {' '}
            {screens.md && tramite?.tramiteMadre?.folio}
          </Tooltip>
        </>
      )}
      {plantillaDeTramite.generar_tramite_posterior_a_cita && !!citas.length && (
        <>
          {separator}
          <CalendarOutlined />
          {' '}
          {citas[0].folio}
        </>
      )}
    </>
  );

  const nombrePlantilla = plantillaDeTramite.nombre.length > 30 ? (
    <Tooltip title={plantillaDeTramite.nombre}>
      {plantillaDeTramite.nombre.substr(0, 30)}
      ...
    </Tooltip>
  ) : plantillaDeTramite.nombre;

  const onToggleAdeudo = () => {
    const modal = Modal.confirm({
      title: `Confirmación de ${tramite.bloquear_adeudos ? 'desbloqueo' : 'bloqueo'}`,
      width: '60%',
      content: (
        <Text>
          ¿Seguro que desea
          {' '}
          {tramite.bloquear_adeudos ? 'desbloquear' : 'bloquear'}
          {' '}
          los adeudos del padrón?
        </Text>
      ),
      onOk: async () => {
        setLoading(true);
        modal.update({ cancelButtonProps: { disabled: true } });
        const saved = await patchTramite(tramite.id, {
          bloquear_adeudos: !tramite.bloquear_adeudos,
          [tramite.bloquear_adeudos
            ? 'ultimo_usuario_que_desbloqueo' : 'ultimo_usuario_que_bloqueo']: user.id,
        });
        setLoading(false);
        if (saved) {
          setTramite({ ...tramite, bloquear_adeudos: saved.bloquear_adeudos });
          Modal.destroyAll();
          message.info(`Adeudo ${!tramite.bloquear_adeudos ? 'bloqueado' : 'desbloqueado'} correctamente`);
        }
      },
      okText: tramite.bloquear_adeudos ? 'Desbloquear' : 'Bloquear',
      cancelText: 'Cancelar',
      okButtonProps: { className: 'no-color' },
      closable: false,
    });
  };

  const canToggleAdeudoBloqueado = tramiteEnProceso && plantillaDeTramite?.bloquear_adeudos;

  return (
    <ThemeProvider theme={theme}>
      <GlobalStyles />
      <Spin tip={loadingAdeudo || loadingMessage || 'Cargando...'} spinning={!!loadingAdeudo || loading}>
        <Container $timelineOpen={timelineOpen}>
          <>
            <Row justify="space-between">
              <div
                style={{
                  width: screens.md
                    ? `calc(100% - ${125 + (tramiteEnProceso ? 100 : 0) + (ConsultaButton ? 100 : 0)}px)`
                    : '100%',
                }}
              >
                <Title level={getLevel(3)} className="primary-text">
                  {nombrePlantilla}
                  {tramite && (
                    <>
                      {separator}
                      <Text className="primary-text" copyable>
                        {tramite.folio}
                      </Text>
                      {tramite && !tramiteEnProceso && (
                        <>
                          {' - '}
                          {tramite.estados_globales === 4
                            ? (<Text type="success">(FINALIZADO)</Text>)
                            : (<Text type="danger">(CANCELADO)</Text>)}
                        </>
                      )}
                      {titleComments && (
                        <>
                          {separator}
                          <Tooltip
                            title={titleComments}
                            overlayStyle={{ maxWidth: 700 }}
                          >
                            <CommentOutlined
                              style={{ cursor: 'pointer' }}
                              onClick={() => {
                                setVisibleModalLog('noPuedeContinuar');
                                // formComments.setFieldsValue(tramite);
                                // setVisibleAddComments(true);
                              }}
                            />
                          </Tooltip>
                        </>
                      )}
                      {canToggleAdeudoBloqueado && (
                        <>
                          {separator}
                          <Tooltip
                            title={`PRESIONE PARA ${tramite.bloquear_adeudos
                              ? 'DESBLOQUEAR' : 'BLOQUEAR'} ADEUDO`}
                          >
                            {tramite.bloquear_adeudos ? (
                              <LockOutlined style={{ cursor: 'pointer' }} onClick={onToggleAdeudo} />
                            ) : (
                              <UnlockOutlined style={{ cursor: 'pointer' }} onClick={onToggleAdeudo} />
                            )}
                          </Tooltip>
                        </>
                      )}
                      {!!pasoActual && (
                        <>
                          {separator}
                          <Tooltip
                            title={titleVerHistorial}
                            overlayStyle={{ maxWidth: 700 }}
                          >
                            <FieldTimeOutlined
                              style={{ cursor: 'pointer' }}
                              onClick={() => setVisibleSeguimiento(true)}
                            />
                          </Tooltip>
                        </>
                      )}
                      {showDownload && (
                        <>
                          {' - '}
                          <Tooltip title="Presione para descargar expediente dígital (zip), se recomienda navegar hacía el final del trámite para asegurar que el expedeinte cuente con todos los elementos">
                            <CloudDownloadOutlined
                              onClick={downloadExpediente}
                              style={{ cursor: 'pointer' }}
                            />
                          </Tooltip>
                        </>
                      )}
                    </>
                  )}
                  {screens.md ? (
                    <Text
                      level={getLevel(3)}
                      className="primary-text"
                      style={{ marginTop: 0, minHeight: 32, display: 'block' }}
                    >
                      {padronesContent}
                    </Text>
                  ) : padronesContent}
                </Title>
              </div>
              <Space style={{ marginLeft: 'auto' }}>
                {isCancelable() && (
                  <Button
                    danger
                    onClick={() => setVisibleCancelar(true)}
                    type="link"
                    className="no-color"
                    style={{ padding: '4px 8px ' }}
                  >
                    <StopOutlined />
                    Cancelar
                  </Button>
                )}
                <Button
                  onClick={onCancel}
                  type="link"
                  style={{ padding: '4px 8px ' }}
                >
                  <ArrowLeftOutlined />
                  Regresar
                </Button>
                {ConsultaButton}
              </Space>
            </Row>
            <Title level={getLevel(3)}>
              {currentStepTitle}
            </Title>
            <StepsContent $timelineOpen={timelineOpen}>
              <React.Suspense fallback={<span />}>
                <Form
                  layout="vertical"
                  form={form}
                  onFinish={beforeOnFinish}
                  onFinishFailed={(errorInfo) => {
                    if (errorInfo.errorFields.some((f) => f.name === '__no_fields_error__')) {
                      message.warning('No es posible realizar afectación al padrón sin información');
                    }
                    if ('base64' in errorInfo.values && !errorInfo.values.base64) {
                      if (currentStep === stepsEnum.PADRON_AFECTADO) {
                        message.warn('Por favor espere a que se procese la imagen del mapa para poder continuar');
                      }
                      if (pasoActual?.tipo_de_paso === tiposDePasosEnum.EMISION_DE_DOCUMENTO) {
                        message.warn('Por favor espere a que se procese el pdf para poder continuar');
                      }
                    }
                    logger('[onFinishFailed]', errorInfo);
                  }}
                  style={{ height: 'calc(100% - 55px)', marginBottom: 20 }}
                  labelWrap={false}
                  name="GPM"
                >
                  <Row gutter={10} style={{ overflow: 'hidden scroll', maxHeight: 'calc(100% - 20px)' }}>
                    {hasPermissionForStep || canContinue() || componentRenderNeeded() ? (
                      <>
                        {showInstructions && (
                          <Instrucciones
                            instrucciones={[
                              DEV ? `(${pasoActual.id})` : '',
                              DEV && pasoActual.no_afectar_padron ? '[[JSON]]' : '',
                              pasoActual.instrucciones,
                            ].join(' ')}
                          />
                        )}
                        <CurrentStepComponent
                          key={currentStepComponentPropsKey || currentStep}
                          // eslint-disable-next-line react/jsx-props-no-spreading
                          {...currentStepComponentProps}
                        />
                      </>
                    ) : (<NoPermission />)}
                  </Row>
                  <Form.Item hidden>
                    <Button htmlType="submit" />
                  </Form.Item>
                </Form>
              </React.Suspense>
              <Controls />
            </StepsContent>
          </>
        </Container>
      </Spin>
      <BusquedaAvanzadaPadrones
        visible={visibleBusquedaPadronSolicitante || visibleBusquedaPadronAfectado}
        setVisible={() => {
          setVisibleBusquedaPadronSolicitante(false);
          setVisibleBusquedaPadronAfectado(false);
        }}
        callback={(record) => {
          if (record.fromThisEntity !== false) {
            if (visibleBusquedaPadronSolicitante) {
              onSolicitanteFound(
                record,
                record.agregarDireccion
                  ? () => setTimeout(() => document.querySelector('#btn-direccion')?.click(), 2000)
                  : undefined,
              );
            }
            if (visibleBusquedaPadronAfectado) onAfectadoFound(record);
          }
        }}
        tipoDePadron={currentStep === stepsEnum.PADRON_AFECTADO
          ? tipoPadronAfectado : (tipoPadronSolicitante || padronesEnum.CIUDADANO)}
        extraParams={extraParams}
        gpm
        allowAdd
        allowAddAddress
        allowEdit={REPUVE && tipoPadronSolicitante === solicitantesEnum.CONTRIBUYENTE
          && currentStep === stepsEnum.PADRON_SOLICITANTE}
        datosContactoOpcionales
      />
      <ModalCancelarTramite
        tramite={tramite?.id}
        setVisible={setVisibleCancelar}
        visible={visibleCancelar}
        cancelarPadron={tipoDeAfectacion === afectacionesEnum.ALTA}
        callback={async () => {
          if (hasWritingJsonStep) {
            await patchPadronesMap[tipoPadronAfectado](
              padronAfectado.id, { json_predio: '' },
              false,
            );
          }
          onCancel();
        }}
        tipoDePadron={padrones.find((e) => e.id === tipoPadronAfectado)?.descripcion}
        // cargos={cargosTramite}
        cancelarCargos={!esConsultaDeAdeudo}
        esRefrendo={esConsultaDeAdeudo}
        placa={tipoPadronAfectado === padronesEnum.VEHICULO
          && tipoDeAfectacion === afectacionesEnum.ALTA
          ? padronAfectado?.numero_de_placa_vigente : null}
        tramites={tramites.map((e) => e.id)}
        limpiarJson={hasWritingJsonStep}
        limpiarJsonPrediosRelacionados={hasWritingJsonStep && hasFusionStep}
      />
      <ModalLog
        tramite={tramite?.id}
        paso={pasoActual}
        onCancel={() => setVisibleModalLog(false)}
        visible={!!visibleModalLog}
        puedeContinuar={visibleModalLog !== 'noPuedeContinuar'}
        pasos={pasosDelTramite}
        pasosIniciales={stepsTimelineItems.filter((e) => typeof e.key === 'string')}
        callback={async (paso_a_mandar, comentarios_del_tramite) => {
          await getHistorial();
          setCurrentStep(paso_a_mandar);
          if (comentarios_del_tramite) setTramite({ ...tramite, comentarios_del_tramite });
        }}
        pasosVerificados={pasosVerificados}
        historial={historial}
      />
      <Previewer
        visible={Boolean(base64Ref.current[visiblePreview])}
        setVisible={() => setVisiblePreview()}
        base64={isPDFBase64(base64Ref.current[visiblePreview])
          ? base64Ref.current[visiblePreview] : null}
        iFrameUrl={!isPDFBase64(base64Ref.current[visiblePreview])
          ? base64Ref.current[visiblePreview] : null}
        allowDownload={checkIfCanDownload(tramite)}
        fileName={base64Ref.current[visiblePreview]?.split('/').pop()}
        customFileNameFormat={() => buildFileName(tramite)}
      />
      <Modal
        footer={null}
        open={visibleSeguimiento}
        title={(
          <FormSubmitControls
            label="Historial de seguimiento"
            onCancel={() => setVisibleSeguimiento(false)}
          />
        )}
        closable={false}
        width="85%"
      >
        <Table
          data={historialesPasoActual}
          cols={[
            {
              titleText: 'Fecha',
              dataIndex: 'fecha_de_creacion',
              key: 'fecha_de_creacion',
              width: 180,
              render: (fecha_de_creacion) => fecha_de_creacion?.format(DATETIME_FRONTEND_FORMAT),
            },
            {
              titleText: 'Usuario',
              dataIndex: 'usuario_creo',
              key: 'usuario_creo',
              width: 200,
              render: (usuario_creo) => fullNameUser(usuario_creo),
            },
            {
              titleText: 'Movimiento',
              dataIndex: 'paso_a_mandar',
              key: 'paso_a_mandar',
              width: 350,
              render: (_, record) => {
                const paso = plantillaDeTramite
                  ?.pasos_para_tramites.find((p) => p.id === record.paso);
                const paso_a_mandar = plantillaDeTramite
                  ?.pasos_para_tramites.find((p) => p.id === record.paso_a_mandar);
                if (paso.id === paso_a_mandar.id) {
                  return (
                    <>
                      SE MANTUVO EN PASO
                      {' '}
                      <b>{paso.nombre}</b>
                    </>
                  );
                }
                return (
                  <>
                    {paso_a_mandar.orden > paso.orden ? 'AVANZÓ' : 'RETROCEDIÓ'}
                    {' DE PASO '}
                    <b>{paso.nombre}</b>
                    {' a '}
                    <b>{paso_a_mandar.nombre}</b>
                  </>
                );
              },
            },
            {
              titleText: 'Comentario',
              dataIndex: 'comentario',
              key: 'comentario',
              width: 600,
              render: (_comentario, record) => {
                if (!_comentario) return null;
                const { comentario } = _comentario;
                const paso = plantillaDeTramite
                  ?.pasos_para_tramites.find((p) => p.id === record.paso);
                const idx = [tiposDePasosEnum.VARIABLES, tiposDePasosEnum.CARGOS]
                  .includes(paso.tipo_de_paso) ? comentario.indexOf(':') : -1;
                const items = idx === -1 ? null : comentario.substring(idx + 1);
                const comment = idx === -1 ? comentario : comentario.substring(0, idx);

                return (
                  <>
                    {_comentario.es_comentario_interno && '(INTERNO) '}
                    {comment}
                    {!!_comentario.archivos.length && (
                      <>
                        {' '}
                        <Tooltip title="Presione para ver archivos adjuntos">
                          <Button
                            onClick={() => {
                              base64Ref.current.archivos = _comentario.archivos
                                .map((e) => e.archivo);
                              base64Ref.current.archivos = base64Ref.current.archivos.length > 1
                                ? base64Ref.current.archivos : base64Ref.current.archivos[0];
                              setVisiblePreview('archivos');
                            }}
                            type="link"
                            style={{ padding: 0 }}
                          >
                            <EyeOutlined />
                          </Button>
                        </Tooltip>
                      </>
                    )}
                    {!!items && (
                      <>
                        {' '}
                        <Tooltip title={items} overlayStyle={{ maxWidth: '70vw' }}>
                          <QuestionCircleOutlined />
                        </Tooltip>
                      </>
                    )}
                  </>
                );
              },
            },
          ]}
          rowKey="id"
          allowSearch={false}
          allowColumnSelector={false}
          allowSort={false}
        />
      </Modal>
      <TimeLine $open={timelineOpen}>
        <ToggleTimelineButton
          onClick={() => dispatch({ type: SET_GPM_TIMELINE_OPEN, payload: !timelineOpen })}
        >
          <DoubleRightOutlined rotate={timelineOpen ? 90 : -90} />
        </ToggleTimelineButton>
        <Row align="middle" justify="center">
          <StepsTimeline />
        </Row>
      </TimeLine>
      <ModalInfoPadron
        callback={(_padron) => onSolicitanteFound(_padron)}
        unidadesRecaudadoras={[]}
        gpm
      />
      <ModalInfoRepuve
        visible={!!visibleModalInfoRepuve}
        values={visibleModalInfoRepuve === 'RenderFieldsByConfig' ? valuesRepuveForm : undefined}
        onFinish={visibleModalInfoRepuve === 'RenderFieldsByConfig'
          ? () => form.setFieldsValue({ autofill: true })
          : undefined}
        onCancel={() => {
          setVisibleModalInfoRepuve(false);
          form.setFieldsValue({ valuesRepuve: undefined });
        }}
        onFinishText="Copiar a formulario"
        allowSearch={visibleModalInfoRepuve !== 'RenderFieldsByConfig'}
        modal
      />
      <ModalCambioPropietario
        open={openCambioPropietario}
        onCancel={onCancelModalCambioPropietario}
        loading={loading}
        onOk={async (placaModal) => {
          if (!placaModal) {
            message.warn('Ingrese el número de placa');
            return;
          }
          setLoading(true);
          const saved = await generarPlaca(
            {
              numero_de_placa: placaModal,
              fecha_expedicion_placa: placaModal === valuesRepuve?.doConsRpv_Placa
                ? toMoment(valuesRepuve.doConsPadron_Fecha_expedicion, DATE_FRONTEND_FORMAT) : null,
            },
            null,
            null,
            padronSolicitante?.id,
          );
          setLoading(false);
          if (!saved) return;
          setPadronAfectado({
            ...padronAfectado,
            numero_de_placa_vigente: placaModal,
            contribuyente_propietario: padronSolicitante,
          });
          onCancelModalCambioPropietario();
        }}
        padronAfectado={padronAfectado}
        padronSolicitante={padronSolicitante}
        initialValuePlaca={padronSolicitante?.rfc === valuesRepuve?.doConsPropietario_RFC
          ? valuesRepuve?.doConsRpv_Placa : null}
        fechaExpRpv={valuesRepuve?.doConsPadron_Fecha_expedicion}
      />
      <Modal
        onOk={() => finishTramite()}
        okText="Finalizar"
        title="Confirmación de finalización"
        onCancel={() => {
          setRealizarEnvio(REPUVE && permission.enviar_ws);
          setVisibleConfirmFinish(false);
        }}
        width="50vw"
        okButtonProps={{ className: 'no-color', icon: <CheckCircleOutlined /> }}
        cancelButtonProps={{ className: 'no-color' }}
        open={visibleConfirmFinish}
        forceRender={false}
        closable={false}
        maskClosable={!loading}
        keyboard={!loading}
      >
        El trámite será finalizado.
        Ya no se podrán realizar modificaciones del mismo.
        <br />
        {hasContactInfo(padronSolicitante || {}) ? (
          <>
            El solicitante será notificado sobre la finalización
            {esPasoDocumento && ' y recibirá el documento emitido durante el proceso'}
            .
          </>
        ) : (
          <>
            Solicitante no cuenta con información de contacto por lo que no será notificado
            sobre la finalización de este trámite.
            <br />
            <br />
            Si desea actualizar la información de contacto del solicitante
            <Button
              type="link"
              onClick={() => {
                Modal.destroyAll();
                setTimeout(() => dispatch({
                  type: SET_PIN_PADRON_INFO,
                  payload: { tipo_de_padron: tipoPadronSolicitante, ...padronSolicitante },
                }));
              }}
              style={{ padding: '0 0 0 5px' }}
            >
              presione aquí
            </Button>
            .
          </>
        )}
        {REPUVE && permission.enviar_ws && (
          <>
            <br />
            <br />
            <Form.Item
              className="fi-horizontal"
              label="¿Realizar envío a base de datos nacional?"
              style={{ marginBottom: 0 }}
            >
              <Radio.Group buttonStyle="solid" defaultValue={realizarEnvioWS ? 1 : 0} size="small">
                <Radio.Button value={1} onClick={() => setRealizarEnvio(true)}>Si</Radio.Button>
                <Radio.Button value={0} onClick={() => setRealizarEnvio(false)}>No</Radio.Button>
              </Radio.Group>
            </Form.Item>
            <br />
            Si no realiza el envío ahora será necesario hacerlo manualmente más tarde.
          </>
        )}
      </Modal>
    </ThemeProvider>
  );
};

const TAB_HEIGHT = 160;

const TimeLine = styled(Row)`
  position: absolute;
  left: 0;
  right: 0;
  bottom: ${(props) => (props.$open ? 0 : -TAB_HEIGHT)}px;
  border-style: dashed;
  border-width: 1px 0 0 0;
  border-color: #a1a1a1;

  .ant-row {
    height: ${TAB_HEIGHT}px;
    width: 100vw;
    padding: 0 30px;
    overflow-y: scroll;
  }

  .ant-steps {
    margin-top: 56px;
    .ant-steps-item .ant-steps-item-content {
      width: 220px;
    }
    .ant-steps-item-icon {
      margin-left: 107px !important;
    }
    .ant-steps-item-tail {
      margin: 0 0 0 107px !important;
    }
    .ant-steps-item:nth-child(even) .ant-steps-item-content {
      margin-top: -40px;
    }
  }
`;

const ToggleTimelineButton = styled(Button)`
  position: absolute;
  top: -32px;
  right: calc(50vw - 16px);
  border-style: dashed;
  border-width: 1px 1px 0 1px;
  border-color: #a1a1a1;
`;

const Container = styled.div`
  height: ${(props) => (props.$timelineOpen ? `calc(100vh - ${TAB_HEIGHT}px)` : '100vh')};
  overflow: hidden scroll;
  padding: 10px 15px;
  .ant-form-item-control-input-content .ant-form-item-control-input input,
  .ant-select-single:not(.ant-select-customize-input) .ant-select-selector {
    height: 36px;
  }
  .ant-form-item-label label,
  .ant-select-selection-item,
  .ant-input {
    font-size: 16px;
  }
  .ant-steps-item-finish>.ant-steps-item-container>.ant-steps-item-tail:after {
    background-color: ${({ theme }) => theme.activeBackgroundColor};
  }
  .ant-steps-item-finish .ant-steps-item-icon>.ant-steps-icon .ant-steps-icon-dot {
    background: ${({ theme }) => theme.activeBackgroundColor};
  }
  .ant-steps-item-process .ant-steps-item-icon>.ant-steps-icon .ant-steps-icon-dot {
    background: ${({ theme }) => theme.activeBackgroundColor};
  }

  .ant-result-icon span, .ant-result-title {
    color: ${({ theme }) => theme.primaryText} !important;
  }

  @media only screen and (min-width: 768px) {
    padding: 20px 30px;
  }
`;

const StyledButton = styled(Button).attrs({ className: 'no-color' })`
  height: 60px;
  background: ${({ theme }) => theme.backgroundColor};
  color: ${({ theme, $selected }) => ($selected ? theme.primaryText : theme.color)};
  border-radius: 12px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  span:not(.anticon) {
    -webkit-box-orient: vertical;
    display: -webkit-box;
    -webkit-line-clamp: ${(props) => props.lineClamp || 2};
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: normal;
    text-transform: uppercase;
    margin: 0;
    font-weight: bold;
    text-align: left;
  }

  .anticon, .ant-btn-link {
    font-size: 16px;
  }

  .ant-btn-link {
    border: none;
    padding: 0 0 0 10px;
  }

  &.disabled .ant-btn-link * {
    color: rgba(0, 0, 0, 0.25) !important;
  }

  :not(.disabled) {
    * {
      color: ${({ theme, $selected }) => ($selected ? theme.primaryText : theme.color)} !important;
    }
    :focus, :hover, :active {
      background: ${({ theme }) => theme.backgroundColor};
      opacity: 0.8;
      color: ${({ theme, $selected }) => ($selected ? theme.primaryText : theme.color)} !important;
    }
  }

  @media only screen and (min-width: 768px) {
    height: 80px;
    .anticon, .ant-btn-link {
      font-size: 20px;
    }
  }
`;

const StepsContent = styled.div`
  background-color: #fafafa;
  border: 1px dashed #e9e9e9;
  border-radius: 2px;
  padding: 20px 20px 10px;
  height: calc(100vh - 197px - ${(props) => (props.$timelineOpen ? TAB_HEIGHT : 0)}px);
  .scrollable {
    max-height: calc(100vh - 215px - ${(props) => (props.$timelineOpen ? TAB_HEIGHT : 0)}px);
    overflow: hidden scroll;
    margin-bottom: 10px
  }
  iframe {
    min-height: 50vh;
    height: calc(100vh - 300px - ${(props) => (props.$timelineOpen ? TAB_HEIGHT : 0)}px) !important;
  }
  .btn-contrast .ant-btn[disabled] {
    color: ${({ theme }) => theme.color} !important;
  }
`;

const RadioGroup = styled(Radio.Group)`
  display: flex;
  flex-direction: column;
  width: -webkit-fill-available;
  row-gap: 5px;
  margin-inline: 5px;
`;

const RadioButton = styled(Radio.Button).attrs({ className: 'no-color' })`
  width: 100%;
  height: auto;
  border-radius: 8px !important;
  padding-block: 10px;

  &:focus, :hover, :active {
    opacity: 0.8;
    color: ${({ theme, $selected }) => (!$selected ? theme.primaryText : theme.color)} !important;

    &:not([disabled]){
      opacity: 1;
      color: #000 !important;
    }
  }
`;

export default GPM;
